import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import * as echarts from 'echarts';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { VariablePayLetterPopupComponent } from 'src/app/shared/popups/variable-pay-letter-popup/variable-pay-letter-popup.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { VariablePayDashboardPopupComponent } from 'src/app/shared/popups/variable-pay-dashboard-popup/variable-pay-dashboard-popup.component';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { debounceTime, forkJoin, Observable, of, Subject, Subscription, switchMap, tap } from 'rxjs';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { ToastrService } from 'ngx-toastr'
import { DownloadAsPdfService } from 'src/app/service/downloadAspdf/download-as-pdf.service';

interface RatingItem {
  minRange: number;
  maxRange: number | null;
  rating: string | null;
}

interface Rating {
  id: number | null;
  createdAt: string;
  createdBy: string | null;
  isDeleted: boolean;
  lastModifiedBy: string | null;
  maxScoreRange: number | null;
  minScoreRange: number | null;
  rating: number | null;
  updatedAt: string;
  variablepaySetupId: number;
}

enum FrequencyType {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  SemiAnnually = 'Semi_Annually',
  Annually = 'Annually',
  All = 'All'
}

@Component({
  selector: 'app-variable-pay',
  templateUrl: './variable-pay.component.html',
  styleUrls: ['./variable-pay.component.scss'],
})
export class VariablePayComponent implements OnInit {

  selectedTypeTabIndex = 0;
  selectedTypeTabName = 'Dashboard';
  buttonColorName: any;
  loggedInUserName: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  showSetupPopup: boolean = false;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  companyYears: { year: string }[] = [];
  selectedYear: any;
  fromYear: any;
  toYear: any;
  incrementPeriodArray: any = [];
  getIndividualBandList: any = [];
  ratingArrayForSetup: any = [];
  addedratingArray: any = [];
  variablePayGridBandList: any = [];
  departmentGroups: any[] = [];
  variablePayData: any = [];
  fromVariablePayMonth: any = [];
  toVariablePayMonth: any = [];
  editedItemId: number | null = null;
  isFormDisabled: boolean = false;
  onCheckIconView: boolean = true;
  isInValidMaxRange = false;
  invalidErrMessageForRating: any;
  isInValidRating = false;
  errorMsgForRating: boolean = false;
  editIndexofRating: any;
  showInfo: boolean = false;
  activeVariablePayInputTab: boolean = true;
  activeVariablePayReportsTab: boolean = true;
  selected = '25';
  currentPageNumberOfVariablePay: any = 1;
  totalPagesOfVariablePay: any = 0;
  setupFrequency: any = null;
  setupMonths: any = [];
  frequencies: string[] = ["Monthly", "Quaterly", "Semi-Annually", "Annually"];
  filteredFrequencies: string[] = [];
  filteredFrequenciesSummary: string[] = [];
  selectedMonths: string[] = [];
  firstMonth: string = '';
  cutoffDate!: string;
  individualScoreData: any[] = [];
  variableIndivaidualScoreData: any[] = [];
  gridBand: any[] = [];
  variableGridBandList: any = [];
  incrementSummaryFormYear: any;
  incrementSummaryToYear: any;
  currentItem: any = [];
  dropdownSettings: IDropdownSettings = {};
  gridData: any = [];
  variableSummaryData: any[] = [];
  selectedDashboardYear: string = 'January-March';
  selectedMonth!: string;
  private cutoffInputSubject = new Subject<number>();
  cutOffDaysChange: Subject<string> = new Subject<string>();

  monthlyOptions: string[] = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
  ];
  quarterlyOptions: string[] = [
    'January-March', 'April-June', 'July-September', 'Octomber-December'
  ];
  semiAnnuallyOptions: string[] = [
    'January-June', 'July-December'
  ];
  annuallyOptions: string[] = ['January - December'];

  periodOptions: any;

  dropdownDisabled: boolean = false;

  getMonthsToVariablePay: string[] = [];
  days: string | undefined;
  apiCallsMade: boolean = false;
  frequencyName!: string;
  errorMsgForRange: boolean = false;
  variablePayFrquency: any = null;
  fromMonth: any = null;
  toMonth: any = null;
  frequencyPeriod: any = null;

  frquencyForSummary!: string;

  GetOverallIncrementBudgetGrid: any = [];

  fromYearData!: string;
  toYearData!: string;

  cutOffDateForVariablepay!: string;

  variablePaySetupId!: number;
  searchString: any = null;
  debounceTimer: any;
  totalEligibleCount: any;
  totalNonEligibleCount: any;

  variablePayGraphType: any = 'bar';
  showVariablePayStatus: boolean = false;
  variablePayChartStatus: echarts.ECharts | undefined;

  variablePayDeptWiseType: any = 'bar';
  showVariablePayDeptWise: boolean = false;
  variablePayDeptWiseStatus: echarts.ECharts | undefined;

  variablePayRatingWiseType: any = 'bar';
  showVariablePayRatingWise: boolean = false;
  variablePayRatingWiseStatus: echarts.ECharts | undefined;

  variablePayBandWiseType: any = 'bar';
  showVariablePayBandWise: boolean = false;
  variablePayBandWiseStatus: echarts.ECharts | undefined;

  variablePayEmployeeCount: any = 'bar';
  showVariablePayEmployeeCount: boolean = false;
  variablePayEmployeeCountStatus: echarts.ECharts | undefined;

  variablePayActualAmount: any = 'bar';
  showVariablePayActualAmount: boolean = false;
  variablePayActualAmountStatus: echarts.ECharts | undefined;

  variablePayEligibleEmployees: any = 'bar';
  showVariablePayEligibleEmployees: boolean = false;
  variablePayEligibleEmployeesStatus: echarts.ECharts | undefined;

  fisrtDashboardColor: any = '#F6921E';
  shouldUpdateCharts: boolean = false;
  variablePaySetupForm!: FormGroup;
  paramsSubscription!: Subscription;

  isInValidMaxIndividualKpi = false;
  isInValidMinIndividualKpi = false;
  isInValidMaxIndividualCompetency = false;
  isInValidMinIndividualCompetency = false;
  IsIndividualTotalWeightage = false;

  InvalidIndividualCompetencyMaxTW = false;
  InvalidIndividualCompetencyMinTW = false;
  InvalidDepthKpiMaxScore = false;
  InvalidDepthKpiMinScore = false;
  InvalidcompanyKpiScoreMaxScore = false
  InvalidcompanyKpiScoreMinScore = false;
  InvalidcompanyscoreWT = false;

  isVisibleOverallVariablePayBudgetGridAdd = true;
  isVisibleOverallVariablePayBudgetGridSave = false;

  isVisibleOverallIncrementBudgetGridAdd = true;
  isVisibleOverallIncrementBudgetGridSave = false;

  dummyData = [
    { name: 'Jan', value: 120 },
    { name: 'Feb', value: 200 },
    { name: 'Mar', value: 150 },
    { name: 'Apr', value: 80 },
    { name: 'May', value: 70 },
    { name: 'Jun', value: 110 },
    { name: 'Jul', value: 130 }
  ];

  employeeData = [
    { id: 1, department: 'Sales', band: 'Executive', name: 'Abhijeet Mandle', manager: 'Akshay A', hod: 'Akshay A', designation: 'Type here', doj: '10/07/2024', ctc: '6 Lac' },
    { id: 2, department: 'Sales', band: 'Executive', name: 'Ankit Gupta', manager: 'Akshay A', hod: 'Akshay A', designation: 'Test', doj: '10/07/2024', ctc: '6 Lac' },
    { id: 3, department: 'Sales', band: 'Executive', name: 'Akshay Chavan', manager: 'Akshay A', hod: 'Akshay A', designation: 'Test', doj: '10/07/2024', ctc: '6 Lac' },
    { id: 4, department: 'Sales', band: 'Executive', name: 'Vinita Joisa', manager: 'Akshay A', hod: 'Akshay A', designation: 'Type here', doj: '10/07/2024', ctc: '6 Lac' },
    { id: 5, department: 'Sales', band: 'Executive', name: 'Pooja Shinde', manager: 'Akshay A', hod: 'Akshay A', designation: 'Type here', doj: '10/07/2024', ctc: '6 Lac' },
    { id: 6, department: 'Sales', band: 'Managerial', name: 'Akshay A', manager: 'Ashay Chavan', hod: 'Ashay Chavan', designation: 'Type here', doj: '10/07/2024', ctc: '6 Lac' },
    { id: 7, department: 'Sales', band: 'Managerial', name: 'Gaurav C', manager: 'Ashay Chavan', hod: 'Ashay Chavan', designation: 'Type here', doj: '10/07/2024', ctc: '6 Lac' },
    { id: 8, department: 'Sales', band: 'Managerial', name: 'Anoop C', manager: 'Ashay Chavan', hod: 'Ashay Chavan', designation: 'Type here', doj: '10/07/2024', ctc: '6 Lac' },
    { id: 9, department: 'Sales', band: 'Managerial', name: 'Vibha G', manager: 'Ashay Chavan', hod: 'Ashay Chavan', designation: 'Type here', doj: '10/07/2024', ctc: '6 Lac' },
    { id: 10, department: 'Sales', band: 'Leadership', name: 'Akshay A', manager: 'Anoop C', hod: 'Anoop C', designation: 'Type here', doj: '10/07/2024', ctc: '6 Lac' },
    { id: 11, department: 'Sales', band: 'Leadership', name: 'Abhijeet Mandle', manager: 'Akshay A', hod: 'Akshay A', designation: 'Type here', doj: '10/07/2024', ctc: '6 Lac' },
    { id: 12, department: 'Sales', band: 'Leadership', name: 'Ankit Gupta', manager: 'Akshay A', hod: 'Akshay A', designation: 'Type here', doj: '10/07/2024', ctc: '6 Lac' },
  ]


  variablePayShowHideSummaryData = [
    {
      "fieldId": 1,
      "isVisible": true,
      "fieldName": "Department",
      "position": 1,
      "isEditable": true
    },
    {
      "fieldId": 2,
      "isVisible": true,
      "fieldName": "Band",
      "position": 2,
      "isEditable": true
    },
    {
      "fieldId": 3,
      "isVisible": true,
      "fieldName": "Total Emp.",
      "position": 3,
      "isEditable": true
    },
    {
      "fieldId": 4,
      "isVisible": true,
      "fieldName": "Total Fixed CTC",
      "position": 4,
      "isEditable": true
    },
    {
      "fieldId": 5,
      "isVisible": true,
      "fieldName": "Eligible Emp. Count",
      "position": 5,
      "isEditable": true
    },
    {
      "fieldId": 6,
      "isVisible": true,
      "fieldName": "Eligible Emp. Fixed CTC",
      "position": 6,
      "isEditable": true
    },
    {
      "fieldId": 7,
      "isVisible": true,
      "fieldName": "Overall VP Bonus Budget",
      "position": 7,
      "isEditable": true
    },
    {
      "fieldId": 8,
      "isVisible": true,
      "fieldName": "VP Bonus actual amount",
      "position": 8,
      "isEditable": true
    },
    {
      "fieldId": 9,
      "isVisible": true,
      "fieldName": "Varience",
      "position": 9,
      "isEditable": true
    },
    {
      "fieldId": 10,
      "isVisible": true,
      "fieldName": "Varience %",
      "position": 10,
      "isEditable": true
    },
  ];

  variablePayReportShowHideSummaryData = [
    { department: 'Sales', band: 'Executive', employee: 'Abhijeet Mandle', manager: 'Akshay A', hod: 'Akshay A', designation: 'Type here', doj: '10/07/2024', totalFixedCTCPA: '6 Lac', totalFixedCTCPQ: '60', eligibleEmployee: 'Yes', individualKPI: '60', deptScore: '70', companyScore: '45', finalScore: 'Good', finalRating: '50', variableBonus: '% of CTC', fixedBudget: '60', actualVariablePay: '10%', daysServedPeriod: '30', proratedVB: '10%', hodNormalization: '10%', hrNormalization: '10%', finalVBAmount: '60' },
    { department: 'Sales', band: 'Executive', employee: 'Ankit Gupta', manager: 'Akshay A', hod: 'Akshay A', designation: 'Test', doj: '10/07/2024', totalFixedCTCPA: '6 Lac', totalFixedCTCPQ: '60', eligibleEmployee: 'Yes', individualKPI: '60', deptScore: '70', companyScore: '45', finalScore: 'Good', finalRating: '50', variableBonus: '% of CTC', fixedBudget: '60', actualVariablePay: '10%', daysServedPeriod: '30', proratedVB: '10%', hodNormalization: '10%', hrNormalization: '10%', finalVBAmount: '60' },
    { department: 'Sales', band: 'Executive', employee: 'Akshay Chavan', manager: 'Akshay A', hod: 'Akshay A', designation: 'Test', doj: '10/07/2024', totalFixedCTCPA: '6 Lac', totalFixedCTCPQ: '60', eligibleEmployee: 'Yes', individualKPI: '60', deptScore: '70', companyScore: '45', finalScore: 'Good', finalRating: '50', variableBonus: '% of CTC', fixedBudget: '60', actualVariablePay: '10%', daysServedPeriod: '30', proratedVB: '10%', hodNormalization: '10%', hrNormalization: '10%', finalVBAmount: '60' },
    { department: 'Sales', band: 'Executive', employee: 'Vinita Joisa', manager: 'Akshay A', hod: 'Akshay A', designation: 'Type here', doj: '10/07/2024', totalFixedCTCPA: '6 Lac', totalFixedCTCPQ: '60', eligibleEmployee: 'Yes', individualKPI: '60', deptScore: '70', companyScore: '45', finalScore: 'Good', finalRating: '50', variableBonus: '% of CTC', fixedBudget: '60', actualVariablePay: '10%', daysServedPeriod: '30', proratedVB: '10%', hodNormalization: '10%', hrNormalization: '10%', finalVBAmount: '60' },
    { department: 'Sales', band: 'Executive', employee: 'Pooja Shinde', manager: 'Akshay A', hod: 'Akshay A', designation: 'Type here', doj: '10/07/2024', totalFixedCTCPA: '6 Lac', totalFixedCTCPQ: '60', eligibleEmployee: 'Yes', individualKPI: '60', deptScore: '70', companyScore: '45', finalScore: 'Good', finalRating: '50', variableBonus: '% of CTC', fixedBudget: '60', actualVariablePay: '10%', daysServedPeriod: '30', proratedVB: '10%', hodNormalization: '10%', hrNormalization: '10%', finalVBAmount: '60' },
    { department: 'Sales', band: 'Managerial', employee: 'Akshay A', manager: 'Ashay Chavan', hod: 'Ashay Chavan', designation: 'Type here', doj: '10/07/2024', totalFixedCTCPA: '6 Lac', totalFixedCTCPQ: '60', eligibleEmployee: 'Yes', individualKPI: '60', deptScore: '70', companyScore: '45', finalScore: 'Good', finalRating: '50', variableBonus: '% of CTC', fixedBudget: '60', actualVariablePay: '10%', daysServedPeriod: '30', proratedVB: '10%', hodNormalization: '10%', hrNormalization: '10%', finalVBAmount: '60' },
    { department: 'Sales', band: 'Managerial', employee: 'Gaurav C', manager: 'Ashay Chavan', hod: 'Ashay Chavan', designation: 'Type here', doj: '10/07/2024', totalFixedCTCPA: '6 Lac', totalFixedCTCPQ: '60', eligibleEmployee: 'Yes', individualKPI: '60', deptScore: '70', companyScore: '45', finalScore: 'Good', finalRating: '50', variableBonus: '% of CTC', fixedBudget: '60', actualVariablePay: '10%', daysServedPeriod: '30', proratedVB: '10%', hodNormalization: '10%', hrNormalization: '10%', finalVBAmount: '60' },
    { department: 'Sales', band: 'Managerial', employee: 'Anoop C', manager: 'Ashay Chavan', hod: 'Ashay Chavan', designation: 'Type here', doj: '10/07/2024', totalFixedCTCPA: '6 Lac', totalFixedCTCPQ: '60', eligibleEmployee: 'Yes', individualKPI: '60', deptScore: '70', companyScore: '45', finalScore: 'Good', finalRating: '50', variableBonus: '% of CTC', fixedBudget: '60', actualVariablePay: '10%', daysServedPeriod: '30', proratedVB: '10%', hodNormalization: '10%', hrNormalization: '10%', finalVBAmount: '60' },
    { department: 'Sales', band: 'Managerial', employee: 'Vibha G', manager: 'Ashay Chavan', hod: 'Ashay Chavan', designation: 'Type here', doj: '10/07/2024', totalFixedCTCPA: '6 Lac', totalFixedCTCPQ: '60', eligibleEmployee: 'Yes', individualKPI: '60', deptScore: '70', companyScore: '45', finalScore: 'Good', finalRating: '50', variableBonus: '% of CTC', fixedBudget: '60', actualVariablePay: '10%', daysServedPeriod: '30', proratedVB: '10%', hodNormalization: '10%', hrNormalization: '10%', finalVBAmount: '60' },
    { department: 'Sales', band: 'Leadership', employee: 'Akshay A', manager: 'Anoop C', hod: 'Anoop C', designation: 'Type here', doj: '10/07/2024', totalFixedCTCPA: '6 Lac', totalFixedCTCPQ: '60', eligibleEmployee: 'Yes', individualKPI: '60', deptScore: '70', companyScore: '45', finalScore: 'Good', finalRating: '50', variableBonus: '% of CTC', fixedBudget: '60', actualVariablePay: '10%', daysServedPeriod: '30', proratedVB: '10%', hodNormalization: '10%', hrNormalization: '10%', finalVBAmount: '60' },
    { department: 'Sales', band: 'Leadership', employee: 'Abhijeet Mandle', manager: 'Akshay A', hod: 'Akshay A', designation: 'Type here', doj: '10/07/2024', totalFixedCTCPA: '6 Lac', totalFixedCTCPQ: '60', eligibleEmployee: 'Yes', individualKPI: '60', deptScore: '70', companyScore: '45', finalScore: 'Good', finalRating: '50', variableBonus: '% of CTC', fixedBudget: '60', actualVariablePay: '10%', daysServedPeriod: '30', proratedVB: '10%', hodNormalization: '10%', hrNormalization: '10%', finalVBAmount: '60' },
    { department: 'Sales', band: 'Leadership', employee: 'Ankit Gupta', manager: 'Akshay A', hod: 'Akshay A', designation: 'Type here', doj: '10/07/2024', totalFixedCTCPA: '6 Lac', totalFixedCTCPQ: '60', eligibleEmployee: 'Yes', individualKPI: '60', deptScore: '70', companyScore: '45', finalScore: 'Good', finalRating: '50', variableBonus: '% of CTC', fixedBudget: '60', actualVariablePay: '10%', daysServedPeriod: '30', proratedVB: '10%', hodNormalization: '10%', hrNormalization: '10%', finalVBAmount: '60' },
  ];

  vpCategoryList = [
    { id: 1, name: 'Fixed Budget' },
    { id: 2, name: '% of CTC' }
  ];
  ScoreToFinalScoreConverterPlusCompanyScore = [
    {
      id: 1,
      band: 'Executive',
      individualCompetencyWeightage: 100,
      deptKpiScore: 100,
      companyKpiScore: 100,
      totalWeightage: 100
    }
  ]

  GetOverallVariablePayBudgetGrid = [
    {
      id: 1,
      year: 'FY 2024-25',
      noOfEligibleEmployees: null,
      totalCtcOfEmployees: null,
      finalVariablePayPercentage: null,
      finalVariablePayAmount: null
    }
  ]
  displayCutoffDate: string | undefined;
  frequencyCycle: any;
  setupData: any;
  noOfEligibleEmployees: any;
  cdr: any;
  totalCtcOfEligibleEmployees: any;
  selectIncrementInputYear: any;
  incrementSummaryFYyear: any;
  incrementInputFormYear: any;
  totalCtcOfEmployees: any;
  companyScoreId: any;
  loggedInUserId: any;
  cutOffDays: number | null = null;

  variableInput: any = [];
  getIncrementInputNonEligibleTableData!: any[];
  getIncrementInputEligibleTableData: any[] = [];
  bandName: any;
  managerName: any;
  employeeName: any;

  totalEligibleTotalFixedCtcPA = 0;
  totalEligibleTotalFixedCtcPM = 0;
  totalEligibleEligibleEmp = 0;
  totalEligibleCompetencyScore = 0;
  totalEligibleDeptScore = 0;
  totalEligibleCompanyScore = 0;
  totalEligibleFinalScore = 0;
  totalEligibleFinalRating = 0;
  totalEligibleCTCFixedBudget = 0;
  totalEligibleFixedBudget = 0;
  totalEligibleActualVariablePayBonus = 0;
  totalEligibleDaysPeriod = 0;
  totalEligibleProtatedVB = 0;
  totalEligibleHODNoramlization = 0;
  totalEligiblenormalisationHRMDCEO = 0;
  totalEligibleVBAmount = 0;


  totalNonEligibleTotalFixedCtcPA = 0;
  totalNonEligibleEligibleEmp = 0;
  totalNonEligibleCompetencyScore = 0;
  totalNonEligibleDeptScore = 0;
  totalNonEligibleCompanyScore = 0;
  totalNonEligibleFinalRating = 0;
  totalNonEligibleIncrementPct = 0;
  totalNonEligibleDaysServedinIncrementPeriod = 0;
  totalNonEligibleProratedIncrementPct = 0;
  totalNonEligibleHODIncrementPct = 0;
  totalNonEligibleHrAndMdIncrementPct = 0;
  totalNonEligibleIncrementAmount = 0;
  totalNonEligiblePromotionPct = 0;
  totalNonEligiblePromotionAmount = 0;
  totalNonEligibleupdatedCtcAfterIAndP = 0;
  totalNonEligibleMarketBenchMarkCtc = 0;
  totalNonEligiblemarketCorrectionPct = 0;
  totalNonEligibleMarketCorrectionAmount = 0;
  totalNonEligibleFinalIncrementPct = 0;
  totalNonEligibleFinalIncrementAmount = 0;
  totalNonEligibleFinalAnnualCtc = 0;
  totalNonEligibleFinalMonthlyCtc = 0;
  vpId: any;
  vpCategory = [];

  vpCategoryData = [
    {
      "id": 1,
      "name": 'Fixed VP Budget'
    },
    {
      "id": 2,
      "name": '% of CTC'
    }
  ]
  bandWiseIncrementAmountIcon: any;
  year: any;
  loggedInCompanyReviewCycle: any;
  subModuleButtonColor: any;
  isShowMD: any;
  selectedDashboardMonthPeriod: any;
  deptWiseBudgetVsActualDept: any;
  selectedDeptNameForEligbleNonEligible: any = []
  private inputChanged: Subject<number> = new Subject<number>();


  constructor(public router: Router, private httpService: HttpService, private encryptionService: EncryptionService,
    private config: Config, private activatedroute: ActivatedRoute, public sharedService: SharedService, public dialog: MatDialog,
    private fb: FormBuilder, private datePipe: DatePipe, private cdRef: ChangeDetectorRef, private loader: LoaderService,
    private toastr: ToastrService, private pdfDownload: DownloadAsPdfService
  ) {
    this.inputChanged.pipe(debounceTime(300)).subscribe((day: number) => {
      this.getVariablePaySetup();
    });
  }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    this.isShowMD = this.loggedInUserRoles.some((role: any) => role.name === 'MD');

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };

    this.cutOffDaysChange
      .pipe(debounceTime(300)) // Debounce for 300ms, adjust as needed
      .subscribe(day => this.processCutoffDateInput(day));
  }

  ionViewWillEnter() {
    if (!this.apiCallsMade) {
      this.paramsSubscription = this.activatedroute.params.subscribe((params: any) => {
        
        if (params?.operation === 'Setup') {
          this.isVariablePayApproved = false;
          this.showSetupPopup = true;
          this.selectedTypeTabName = '';
          this.getFiscalYear().subscribe();
          this.checkVPPolicyFile();
        } else {
          this.showSetupPopup = false;
          this.selectedTypeTabIndex = params?.tabIndex;
          this.getFiscalYearFromPMS();

        }
      });

      this.getVariablePayInputTableHideShowAllData();
      this.getVariablePayReportsTableHideShowAllData();
    }
  }

  // get Fiscal year from PMS

  getFiscalYearForPMS: any;
  pmsFrequency: any;
  getMonthsForPeriod: any;
  periodMonthsForDashboard: any;

  getFiscalYearFromPMS() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.companyYears = [];
      data?.data?.yearRanges?.forEach((ele: any) => {
        const [start, end] = ele.split('_');
        this.companyYears.push({ year: `${start}-${end}` });
      });

      const currentYear = new Date().getFullYear();
      let yearValue = this.loggedInCompanyFiscalyear === 'Jan_Dec'
        ? `${currentYear}-${currentYear}`
        : `${currentYear}-${currentYear + 1}`;

      let selectedYearIndex = this.companyYears.findIndex((ele: any) => ele.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }

      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      let yearValue1 = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue1 = `${currentYear}-${currentYear}`;
      } else {
        yearValue1 = `${currentYear}-${currentYear + 1}`;
        if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
          if (currentMonth < 3) {
            yearValue1 = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'July_Jun') {
          if (currentMonth < 6) {
            yearValue1 = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
          if (currentMonth < 9) {
            yearValue1 = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
      }
      this.selectedYear = yearValue1;


      // this.selectedYear = this.companyYears[selectedYearIndex]?.year;
      const test = this.selectedYear.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];

      const nextYearIndex = (selectedYearIndex + 1) % this.companyYears.length;
      const nextToNextYearIndex = (selectedYearIndex + 2) % this.companyYears.length;

      this.fromVariablePayMonth = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.companyYears[nextYearIndex]?.year);
      this.toVariablePayMonth = this.getToMonthsArray(this.loggedInCompanyFiscalyear, this.companyYears[nextToNextYearIndex]?.year);
      if (Number(this.fromYear) == currentYear
        || Number(this.toYear) == currentYear) {
        this.isSelectedYearIsSameYeartoCurrentYear = true;
      } else {
        this.isSelectedYearIsSameYeartoCurrentYear = false;
      }
      if(this.loggedInUserRole == 'Employee' || this.loggedInUserRole=='Manager'){
        this.vpPeriodsByUser();
      }else{
        this.getVPCurrentYearFrequeny();
        this.getFrequencyPMS();
        this.getFrequencyForDashboard();
        this.getVariablePaySetup();
        this.getBandDataFunction();
        this.showCurrentYear();
      }
    })
  }

  getFrequencyPMS() {
    // this.httpService.callGetService(`${this.config.getPMSSetUpByID}${this.loggedInUserCompanyID}/${this.fromYear}/${this.toYear}`).subscribe((res: any) => {
    //   this.pmsFrequency = res.data;
    //   this.getPeriodData();
    // })
  }

  getPeriodData() {
    // this.httpService.callGetService(`${this.config.getVariablePayMonths}/${this.loggedInUserCompanyID}/${this.pmsFrequency.reviewCycle}`).subscribe((res: any) => {
    //   this.getMonthsForPeriod = res.data['months'];

    //   this.getMonthsForPeriod?.map((data: any) => {
    //     this.periodMonthsForDashboard = data;
    //   })
    // })
  }


  // Setup Started

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/variablepay', { operation: operation }]);
    this.getVariablePaySetup();
  }

  // Date Format Function 

  formatDateString(dateString: string): string {
    const dateParts = dateString.split('-'); // Split the date string by '-'
    return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`; // Return formatted string as dd/mm/yyyy
  }

  // Get Setup Data

  getVariablePaySetup() {
    
    if (this.setupFrequency == null || this.selectedYear == null || this.frequencyPeriod == null || this.selectedMonths == null)
      return;

    // Prepare the request object
    const request = {
      companyId: this.loggedInUserCompanyID,
      cutOffDate: new Date(this.cutOffDateForVariablepay),
      frequency: this.setupFrequency,
      frequencyCycle: this.frequencyPeriod,
      fromYear: Number(this.fromYear),
      toYear: Number(this.toYear)
    };

    this.httpService.callPostService(this.config.getVariablePaySetup, request).subscribe((response: any) => {
      
      this.setupData = response.data;
      this.vpId = this.setupData?.id;
      this.vpIdForApproval = this.setupData?.id;
      this.checkIsFreezeForHOD();
      this.checkIsSenForMDCeoForApproval();
      this.checkIsVariablePayApproved();
      this.checkIsSenForHRForApproval();
      if (this.setupData && this.setupData.cutOffDateForVariablepay) {
        this.cutOffDateForVariablepay = this.formatDateString(this.setupData.cutOffDateForVariablepay);
        const cutoffDate = new Date(this.setupData.cutOffDateForVariablepay);
        this.cutOffDays = this.setupData.cutOffDays;
        this.cutOffDate = this.setupData.cutOffDays;
      } else {
        this.cutOffDays = null;
        this.cutOffDate = 1;
        this.calculateCutoffDate('1')
      }
      this.finalVPAmount = this.setupData?.finalVPAmount;
      this.finalVPPercentage = this.setupData?.finalVPPercentage;

      this.noOfEligibleEmployees = this.setupData?.noOfEligibleEmployees ?? 0;
      this.totalCtcOfEligibleEmployees = this.setupData?.totalCtcOfEligibleEmployees ?? 0;

      this.fromMonth = this.setupData?.fromMonth ? this.setupData?.fromMonth : null;
      this.toMonth = this.setupData?.toMonth ? this.setupData.toMonth.charAt(0).toUpperCase() + this.setupData.toMonth.slice(1).toLowerCase() : null;

      this.GetOverallIncrementBudgetGridData = []
      this.GetOverallIncrementBudgetGridData.push({
        year: this.selectedYear,
        frequencyPeriod: this.frequencyPeriod,
        frequencyCycle: this.setupData?.frequencyCycle,
        noOfEligibleEmployees: this.setupData?.noOfEligibleEmployees ?? 0,
        totalCtcOfEligibleEmployees: this.setupData?.totalCtcOfEligibleEmployees ?? 0,
        finalVPPercentage: this.setupData?.finalVPPercentage ? this.setupData?.finalVPPercentage : null,
        finalVPAmount: this.setupData?.finalVPAmount ? this.setupData?.finalVPAmount : null,
        isNew: true
      });

      this.getBandDataFunction();
      this.getPrevYearSetupVP()
    });
  }

  getBandDataFunction() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear,
    };

    this.httpService.callPostService(this.config.getBandListForIncrement, request).subscribe((result: any) => {     
      this.variableIndivaidualScoreData = result.data?.map((data: any) => {
        const isNullData = data.individualCompetencyWeightage === null ||
          data.individualKpiScoreWeightage === null ||
          data.totalWeightage === null;
        return {
          band: data,
          id: null,
          individualCompetencyWeightage: data.individualCompetencyWeightage,
          individualKpiScoreWeightage: data.individualKpiScoreWeightage,
          totalWeightage: data.totalWeightage,
          createdAt: null,
          createdBy: null,
          isDeleted: false,
          lastModifiedBy: null,
          updatedAt: null,
          variablepaySetupId: null,
          hasNullData: isNullData // Add a flag to indicate if data is null
        };
      });

      const nullData = this.variableIndivaidualScoreData.filter(item => item.hasNullData);
      const filledData = this.variableIndivaidualScoreData.filter(item => !item.hasNullData);

      this.individualCompanyScore = result.data?.map((data: any) => ({
        band: data,
        deptKpiScore: null,
        id: null,
        individualKpiCompetencyWeightage: null,
        companyKPIScoreWeightage: null,
        totalWeightage: null,
        createdAt: null,
        createdBy: null,
        isDeleted: false,
        lastModifiedBy: null,
        updatedAt: null,
        variablepaySetupId: null,
      }));
      this.variableGridBandList = result.data?.map((data: any) => ({
        band: data,
        id: [],
        variablepayPercentage: [],
      }));
      this.getScoreToFinalConverterCompanyScore();
      this.getScoreRating();
      this.GetIncrementGrid();
      if (this.setupFrequency === 'Annually') {
        this.getScoreToFinalConverterIndividual();
      }
    });
  }


  // Update getFiscalYear to return an observable
  getFiscalYear(): Observable<any> {
    return this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).pipe(
      tap((data: any) => {
        this.companyYears = [];
        data?.data?.yearRanges?.forEach((ele: any) => {
          const [start, end] = ele.split('_');
          this.companyYears.push({ year: `${start}-${end}` });
        });

        const currentYear = new Date().getFullYear();
        let yearValue = this.loggedInCompanyFiscalyear === 'Jan_Dec'
          ? `${currentYear}-${currentYear}`
          : `${currentYear}-${currentYear + 1}`;

        let selectedYearIndex = this.companyYears.findIndex((ele: any) => ele.year === yearValue);
        if (selectedYearIndex === -1) {
          selectedYearIndex = 0; // Default to the first year if current year not found
        }
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        let yearValue1 = '';
        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          yearValue1 = `${currentYear}-${currentYear}`;
        } else {
          yearValue1 = `${currentYear}-${currentYear + 1}`;
          if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
            if (currentMonth < 3) {
              yearValue1 = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue1 = `${currentYear}-${currentYear + 1}`;
            }
          }
          if (this.loggedInCompanyFiscalyear === 'July_Jun') {
            if (currentMonth < 6) {
              yearValue1 = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue1 = `${currentYear}-${currentYear + 1}`;
            }
          }
          if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
            if (currentMonth < 9) {
              yearValue1 = `${currentYear - 1}-${currentYear}`;
            } else {
              yearValue1 = `${currentYear}-${currentYear + 1}`;
            }
          }
        }
        this.selectedYear = yearValue1;
        const test = this.selectedYear.split('-');
        this.fromYear = test[0];
        this.toYear = test[1];

        const nextYearIndex = (selectedYearIndex + 1) % this.companyYears.length;
        const nextToNextYearIndex = (selectedYearIndex + 2) % this.companyYears.length;

        this.fromVariablePayMonth = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.companyYears[nextYearIndex]?.year);
        this.toVariablePayMonth = this.getToMonthsArray(this.loggedInCompanyFiscalyear, this.companyYears[nextToNextYearIndex]?.year);
        if (Number(this.fromYear) == currentYear
          || Number(this.toYear) == currentYear) {
          this.isSelectedYearIsSameYeartoCurrentYear = true;
        } else {
          this.isSelectedYearIsSameYeartoCurrentYear = false;
        }
        // this.getFrequency();
        this.getVPCurrentYearFrequeny();
      })
    );
  }

  // Update getFrequency to return an observable
  getFrequency() {
    this.httpService.callGetService(`${this.config.getPMSSetUpByID}${this.loggedInUserCompanyID}/${this.fromYear}/${this.toYear}`).subscribe((response: any) => {
      this.setupFrequency = response.data['reviewCycle'] ? response.data['reviewCycle'] : response.data['yearRanges'];
      this.filterFrequencies()
    })
    // Switch to the observable returned by filterFrequencies()
    // switchMap(() => forkJoin([this.filterFrequencies(), this.tooltipDynamic()]))
  }
  setUpYearChnage(event: any) {
    
    this.setupFrequency = null;
    this.frequencyPeriod = null;
    this.fromMonth = null;
    this.toMonth = null;
    this.variableIndivaidualScoreData = [];
    this.individualCompanyScore = [];
    this.addedratingArray = [];
    this.GetOverallIncrementBudgetGridData = [];
    this.variableGridBandList = [];
  }
  isSelectedYearIsSameYeartoCurrentYear: boolean = false;
  onYearChange() {
    const selectedYear = this.selectedYear.split('-');
    this.fromYear = selectedYear[0];
    this.toYear = selectedYear[1];
    this.filteredFrequenciesVariable = [];
    
    const currentYear = new Date().getFullYear();
    if (Number(this.fromYear) == currentYear
      || Number(this.toYear) == currentYear) {
      this.isSelectedYearIsSameYeartoCurrentYear = true;
    } else {
      this.isSelectedYearIsSameYeartoCurrentYear = false;
    }
    this.clearCutOffDays();
    this.getFrequencyForVariable();
    this.getVPCurrentYearFrequeny();
    // this.getFrequency()
  }
  selectedRating: any = [];
  onYearChangeReport(event: any) {
    const selectedYear = this.selectedYear.split('-');
    this.fromYear = selectedYear[0];
    this.toYear = selectedYear[1];
    this.frequencyPeriod = null;
    this.setupFrequencyForReports = [];
    this.selectedDepartment = [];
    this.getDepartmentsList = [];
    this.selectedBand = [];
    this.getBandList = [];
    this.vpCategory = [];
    this.getRatingData = [];
    this.selectedRating = []
    this.getFrequencyForReports();
  }
  onYearChangeVPSummary(event: any) {
    const selectedYear = this.selectedYear.split('-');
    this.fromYear = selectedYear[0];
    this.toYear = selectedYear[1];
    this.variableSummaryData = [];
    this.getFrequencyForSummary();
  }
  variableFrequency: any;
  getFrequencyForVariable() {
    this.httpService.callGetService(`${this.config.getPMSSetUpByID}${this.loggedInUserCompanyID}/${this.fromYear}/${this.toYear}`).subscribe((response: any) => {
      if (response?.data == null) {

      } else {
        this.variableFrequency = response?.data['reviewCycle'];
        this.filterFrequencyVariable();
      }
    })
  }
  generatedId!: string;

  private parseDateString(dateString: string): Date {
    const [day, month, year] = dateString.split('/')?.map(num => parseInt(num, 10));
    return new Date(year, month - 1, day); // Month is zero-based in JS
  }

  async setUpVariableCutOff(): Promise<any> {
    if (this.cutOffDateForVariablepay == 'Invalid day' || !this.setupFrequency || !this.frequencyPeriod
      || !this.fromMonth || !this.toMonth) {
      this.toastr.error('Please fill all mandetory fields.', '', {
        timeOut: 3000,
      });
      return;
    }
    this.loader.simpleLoader();
    const rawCutOffDate = this.cutOffDateForVariablepay || '20/10/2024'; // Default for testing
    const cutOffDate = this.datePipe.transform(this.parseDateString(rawCutOffDate), "yyyy-MM-dd");
    const payload = {
      "createdBy": null,
      "createdAt": null,
      "lastModifiedBy": null,
      "updatedAt": null,
      "id": this.vpId ? this.vpId : null,
      "companyId": this.loggedInUserCompanyID,
      "cutOffDateForVariablepay": cutOffDate,
      "cutOffDays": this.cutOffDate,
      "finalVPAmount": this.finalVPAmount,
      "finalVPPercentage": this.finalVPPercentage,
      "frequency": this.frequencyName,
      "frequencyCycle": this.frequencyPeriod,
      "fromMonth": this.fromMonth,
      "fromYear": parseInt(this.fromYear),
      "toMonth": this.toMonth,
      "toYear": parseInt(this.toYear),
    };
    try {
      const response: any = await this.httpService.callPostService(this.config.variablePaySetup, payload).toPromise();
      this.loader.dismissLoader();
      this.vpId = response.data?.id;
      const generatedId = response.data?.id;
      this.getVPCurrentYearFrequeny();
      const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: "Variable Pay Setup Successfully",
          btn2: 'OK',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: true,
          showSuccessMessage: false,
          showCloseIcon: false,
        },
      });

      successdialogRef.afterClosed().subscribe(result => {
        this.dropdownDisabled = true;
      this.loader.dismissLoader();
      });
      return generatedId;

    } catch (error) {
      console.error("Error saving Variable Pay Setup:", error);
      throw error; // Propagate the error to be handled by the caller
      this.loader.dismissLoader();
    }
  }

  generatedVariablePaySetupId: any;
  getVariableInputData() {
    if (this.vpPolicyFileIsNotAvailable) {
      this.toastr.error('Please upload variable pay policy.', '', {
        timeOut: 3000,
      });
      return;
    }
    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "variablepaySetupId": this.vpId
    }
    this.loader.simpleLoader();
    this.httpService.callPostService(this.config.variableAddInput, payload).subscribe((response: any) => {
      this.loader.dismissLoader();
      if (response?.status == false) {
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: response?.message,
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false,
          },
        });
      } else {
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: "Variable Pay Added Successfully",
            btn2: 'OK',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false,
          },
        });
      }
    })
  }
  vpPolicyFileIsNotAvailable: boolean = false;
  checkVPPolicyFile() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": null,
      "fromYear": null,
      "relatedToName": "Variable Pay Policy",
      "toYear": null
    };
    this.httpService.callPostService(this.config.getVPPolicyFile, request).subscribe((result: any) => {
      if (result?.data == null) {
        this.vpPolicyFileIsNotAvailable = true;
      } else {
        this.vpPolicyFileIsNotAvailable = false;
      }
    });
  }

  tabTypeChanged(event: MatTabChangeEvent): void {
    this.selectedTypeTabName = event.tab.textLabel;
    this.selectedTypeTabIndex = event?.index;
    this.searchString = null;
    if (this.selectedTypeTabIndex == 0) {
      setTimeout(() => {
        this.BudgetVsActualGraph();
        this.getDashBoardGenderWise();
        this.getDashBoardDeptWise();
        this.getDashBoardRateWise();
        this.getDashBoardBandWise();
        this.getDeptForRateVSEmployee();
        this.getDashBoardActualAmountWise();
        this.getDashBoardEligibleEmployeeWise();
        this.getDeptForGender();
        this.getDashboradDeptData();
        this.getData();
        this.getDeptForRating();
        this.getDeptForBand();
        this.getDashboardCounts();
      }, 0); // Delays the function to allow the DOM to render
    }

    if (this.selectedTypeTabIndex == 1) {
      // this.callApiWithSearchInput();
      this.selectedDepartment = []
      this.selectedBand = []
      this.selectedManager = []
      this.selectedEmployee = []
      this.totalEligibleCount = 0;
      this.totalNonEligibleCount = 0;
      this.getIncrementInputEligibleTableData = [];
      this.getIncrementInputNonEligibleTableData = [];
      this.getFiscalYearForVariableInput();
      this.getVariablePaySetup();
      this.getVPCurrentYearFrequeny();
      this.getData();
    }

    if (this.selectedTypeTabIndex == 2) {
      this.getVPCurrentYearFrequeny();
      this.getVariablePaySetup();
      this.getFiscalYearForVariableSummary();
      // this.callApiWithSearch();
    }

    if (this.selectedTypeTabIndex == 3) {
      // this.callApiWithSearchInput();
      this.selectedDepartment = []
      this.selectedBand = []
      this.vpCategory = []
      this.selectedRating = []
      this.totalEligibleCount = 0;
      this.totalNonEligibleCount = 0;
      this.getIncrementInputEligibleTableData = [];
      this.getIncrementInputNonEligibleTableData = [];
      this.getVariablePaySetup();
      this.getFiscalYearForVariableReports();
    }
  }

  // Get previous year band data 

  previousYearData: any;
  getPreviousYearData() {
    this.httpService.callGetService(`${this.config.getPreviousYearFrequency}/${this.loggedInUserCompanyID}/${this.setupFrequency}/${this.fromYear}/${this.toYear}`).subscribe((data: any) => {
      this.previousYearData = data;
    })
  }

  getDepartmentDataDashboard: any = [];
  variableDeptData: any;
  departmentNamesArrayForDashboard: any = [];
  frequencyCycleForDashboard: any;
  frequencyForDashboard: any;
  frequencyCycleDashboard: any;
  counterDashboardData: any;
  budgetVSActualData: any;
  genderWiseFrequency: any;
  genderWiseData: any[] = [];

  deptWiseFrequency: any;
  deptWiseData: any[] = [];

  rateWiseFrequency: any;
  rateWiseData: any[] = [];

  bandWiseFrequency: any;
  bandWiseData: any[] = [];

  rateEmployeeWiseData: any[] = [];
  rateEmployeeFrequency: any;

  actualAmountFrequency: any;
  ActualAmountWiseData: any[] = [];

  eligibleEmployeeFrequency: any;
  eligibleEmployeeWiseData: any[] = [];

  actualVsBudgetFrequency: any;

  monthPeriodForBudget: any;
  monthPeriodForGender: any;
  monthPeriodForDept: any;
  monthPeriodForRating: any;
  monthPeriodForBand: any;
  monthPeriodForRatingCount: any;
  monthPeriodForDeptWiseEligbleNonEligible: any;
  // depts 

  deptForGender: any = 'All';
  deptForRating: any = 'All';

  // Array
  getBudgetVsActualData: any[] = [];
  selectGenderWiseBudgetVsActualDept: any = 'All';
  selectRateWiseDept: any;

  vpFrequency: any

  periodForDashboard: any;

  genderWiseBudgetVsActualDeptGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  BudgetVsActualGraphType: any = {
    bar: {},
    line: {},
  };

  deptIncrementGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  ratingWiseVariableBudgetGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  bandWiseBudgetVsActualsGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  ratingVsEmpCountGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  yearVsBudgetAndActualAmountGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  deptWiseEligibleAndNonEligibleEmpCountGraphType: any = {
    bar: {},
    pie: {},
    line: {},
  };

  frequencyDeptName: any = [];
  frequencyRating: any = [];
  selectedDeptForGender: string = '';
  selectedDeptForRating: string = '';
  selectedDeptForBands: string = '';
  selectedDeptForRatingVsEmployeeCount: string = '';
  selectedDeptForYearVsBudget: string = '';
  selectedDeptForEligible: string = '';

  async getDashboradDeptData() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": this.frequencyName || null, // Include frequency cycle if already selected
      "fromYear": Number(this.fromYear),
      "searchString": this.searchString || null, // Include searchString
      "toYear": Number(this.toYear),
      "isHod": isHod
    };

    this.httpService.callPostService(this.config.variableInput, payload).subscribe((response: any) => {
      this.variableDeptData = response?.data?.vpInputs;
      this.frequencyCycleDashboard = this.variableDeptData[0]?.bands[0]?.employees[0]?.frequencyCycle || '';
    });

    await this.getDashboardCounts();
  }

  updateDashboardPeriodOptions(event: any) {
    
    this.periodForDashboard = event.value; // Get selected frequency cycle
    this.monthPeriodForBudget = this.selectedDashboardMonthPeriod
    this.monthPeriodForGender = this.selectedDashboardMonthPeriod
    this.monthPeriodForDept = this.selectedDashboardMonthPeriod
    this.monthPeriodForRating = this.selectedDashboardMonthPeriod
    this.monthPeriodForBand = this.selectedDashboardMonthPeriod
    this.monthPeriodForRatingCount = this.selectedDashboardMonthPeriod
    if (this.selectedDashboardMonthPeriod) {
      this.monthPeriodForDeptWiseEligbleNonEligible = this.selectedDashboardMonthPeriod;
    }
    this.periodForDashboard = this.selectedDashboardMonthPeriod
    this.getDeptForGender();
    this.BudgetVsActualGraph();
    this.getDashboradDeptData();
    this.getData();
    this.getDeptForRating();
    this.getDeptForBand();
    this.getDeptForRateVSEmployee();
    this.getDashboardCounts();
    this.getDashBoardActualAmountWise();
  }

  getDashboardCounts() {
    
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    this.departmentNamesArrayForDashboard = this.variableDeptData?.map((data: any) => data.departmentName);
    // this.frequencyCycleForDashboard = this.variableDeptData[0]?.bands[0]?.employees[0]?.frequencyCycle || '';
    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "depts": this.departmentNamesArrayForDashboard,
      "frequency": null,
      "frequencyCycle": this.periodForDashboard,
      "fromYear": Number(this.fromYear),
      "toYear": Number(this.toYear),
      "isHod": isHod
    }

    this.httpService.callPostService(this.config.variableDashboardCount, payload).subscribe((response: any) => {
      this.counterDashboardData = response.data;
    })
  }

  getFrequencyForDashboard() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      if (response.data != null) {
        
        this.vpFrequency = response.data;
        const currentMonthIndex = new Date().getMonth();
        const today = new Date();
        const month = today.toLocaleString('default', { month: 'long' });
        if (this.setupFrequency == 'Monthly') {
          this.vpFrequency.forEach((ele: any) => {
            var checkMonth = ele?.split('-');
            if (month == checkMonth[0]) {
              this.frequencyPeriod = ele;
              this.selectedDashboardMonthPeriod = ele;
              this.monthPeriodForBudget = ele;
              this.monthPeriodForGender = ele;
              this.monthPeriodForDept = ele;
              this.monthPeriodForRating = ele;
              this.monthPeriodForBand = ele;
              this.monthPeriodForRatingCount = ele;
              this.monthPeriodForDeptWiseEligbleNonEligible = ele;
              this.periodForDashboard = ele;; // Get selected frequency cycle
            }
          });
        }

        if (this.setupFrequency == 'Quarterly' || this.setupFrequency == 'Semi_Annually' || this.setupFrequency == 'Semi-Annually'
          || this.setupFrequency == 'Annually') {
          for (let range of this.vpFrequency) {
            const [start, end] = range?.split('-');
            const startMonthIndex = this.getMonthIndex(start);
            const endMonthIndex = this.getMonthIndex(end);
            if (
              (currentMonthIndex >= startMonthIndex && currentMonthIndex <= endMonthIndex) ||
              (startMonthIndex > endMonthIndex && (currentMonthIndex >= startMonthIndex || currentMonthIndex <= endMonthIndex))
            ) {
              this.selectedDashboardMonthPeriod = range;
              this.monthPeriodForBudget = range;
              this.monthPeriodForGender = range;
              this.monthPeriodForDept = range;
              this.monthPeriodForRating = range;
              this.monthPeriodForBand = range;
              this.monthPeriodForRatingCount = range;
              this.monthPeriodForDeptWiseEligbleNonEligible = range;
              this.periodForDashboard = range;; // Get selected frequency cycle
            }
          }
        }
      } else {
        this.vpFrequency = null;
        this.selectedDashboardMonthPeriod = null
        this.monthPeriodForBudget = null
        this.monthPeriodForGender = null
        this.monthPeriodForDept = null
        this.monthPeriodForRating = null
        this.monthPeriodForBand = null
        this.monthPeriodForRatingCount = null
        this.monthPeriodForDeptWiseEligbleNonEligible = null
        this.periodForDashboard = null
      }
      
      this.getDeptForGender();
      this.BudgetVsActualGraph();
      this.getDashboradDeptData();
      this.getData();
      this.getDeptForRating();
      this.getDeptForBand();
      this.getDeptForRateVSEmployee();
      this.getDashboardCounts();
    });
  }

  // Budget vs Actual Graph Implementation

  getFrequencyForActualVsBudget() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      this.actualVsBudgetFrequency = response.data;
    });
  }

  updateActualVsBudgetOption(event: any) {
    let period = event.value;
    if (period === 'Semi-Annually') {
      period = 'Semi_Annually';
    }
    this.frequencyName = period;
    this.BudgetVsActualGraph();
  }

  BudgetVsActualGraph() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "depts": this.departmentNamesArrayForDashboard,
      "frequency": null,
      "frequencyCycle": this.monthPeriodForBudget,
      "fromYear": Number(this.fromYear),
      "toYear": Number(this.toYear),
      "isHod": isHod
    }

    this.httpService.callPostService(this.config.variableDashboardDashboardBudget, payload).subscribe((response: any) => {
      this.getBudgetVsActualData = [];
      this.budgetVSActualData = response.data;
      this.getBudgetVsActualData.push(response.data)
      // this.budgetWiseGraph(this.budgetVSActualData);
      this.BudgetVsActualGraphType.bar = this.BudgetVsActualBarGraph(this.budgetVSActualData);
      this.BudgetVsActualGraphType.line = this.BudgetVsActualLineGraph(this.budgetVSActualData);
      this.switchBudgetVsActualGraphType('bar');
    })
  };
  BudgetVsActualIcon: any = 'bar';
  BudgetVsActualTable: any = false;

  BudgetVsActualTableData() {
    this.BudgetVsActualIcon = '';
    this.BudgetVsActualTable = true;
  }
  switchBudgetVsActualGraphType(graphType: any) {
    this.BudgetVsActualIcon = graphType;
    this.BudgetVsActualTable = false;
    
    const dom = document.getElementById("budgetWiseGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.BudgetVsActualBarGraph(this.budgetVSActualData)
      }
      if (graphType == 'line') {
        this.BudgetVsActualBarGraph(this.budgetVSActualData)
      }
      if (this.BudgetVsActualGraphType[graphType] && typeof this.BudgetVsActualGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.BudgetVsActualGraphType[graphType], true);
      }
    }
  }
  BudgetVsActualBarGraph(data: any): echarts.EChartsOption {
    const totalActual = data.actualAmount;
    const totalBudget = data.budgetAmount;

    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tooltipContent = params?.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: [''],
          name: '',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: {
        type: 'value',
        name: 'Budget & Actual Amount',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 20
        },
        splitLine: { show: false }
      },
      axisLabel: {
        formatter: function (value: number) {
          return formatNumber(value, 0);
        }
      },
      series: [
        {
          type: 'bar',
          name: 'Budget',
          barWidth: '15%',
          data: [totalBudget],
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          },

        },
        {
          type: 'bar',
          name: 'Actual',
          barWidth: '15%',
          data: [totalActual],
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          },
        },
      ],
    };
  }
  BudgetVsActualLineGraph(data: any): echarts.EChartsOption {
    const totalBudget = data.budgetAmount;
    const totalActual = data.actualAmount;

    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tooltipContent = params?.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: [''],
          name: '',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Budget & Actual Amount',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false },
          axisLabel: {
            formatter: function (value: number) {
              return formatNumber(value, 0);
            }
          }
        },
      ],
      series: [
        {
          type: 'line',
          name: 'Budget',
          data: [totalBudget],
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
        {
          type: 'line',
          name: 'Actual',
          data: [totalActual],
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
      ],
    };
  }
  // budgetWiseGraph(data: any) {
  //   const chartDom = document.getElementById('budgetWiseGraph')!;
  //   const myChart = echarts.init(chartDom);
  //   const totalActual = data.actualAmount;
  //   const totalBudget = data.budgetAmount;
  //   const option = {
  //     tooltip: {
  //       trigger: 'axis',
  //       axisPointer: {
  //         type: 'shadow',
  //       },
  //     },
  //     legend: {
  //       data: ['Budget', 'Actual'],
  //       bottom: 0,
  //       left: 'center',
  //     },
  //     xAxis: {
  //       type: 'category',
  //       data: ['Budget', 'Actual']
  //     },
  //     yAxis: {
  //       type: 'value',
  //       nameLocation: 'middle',
  //       nameTextStyle: {
  //         fontSize: 14,
  //         padding: 20
  //       },
  //       splitLine: { show: false }
  //     },
  //     series: [
  //       {
  //         data: [
  //           {
  //             value: totalBudget,
  //             name: 'Budget',
  //             itemStyle: {
  //               color: '#393186'
  //             },
  //             label: { show: true, position: 'top', fontSize: 9 }
  //           },
  //           {
  //             value: totalActual,
  //             name: 'Actual',
  //             itemStyle: {
  //               color: '#F3820E'
  //             },
  //             label: { show: true, position: 'top', fontSize: 9 }
  //           },
  //         ],
  //         type: 'bar',
  //         barWidth: '15%',
  //       }
  //     ]
  //   }
  //   myChart.setOption(option);
  // }

  selectedGenderWieBudgetVsActualDept() {
    if (this.selectGenderWiseBudgetVsActualDept.length > 0) {
      this.getFrequencyForGenderWise();
      this.getDashBoardGenderWise();
    }
  }

  getFrequencyForGenderWise() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      this.genderWiseFrequency = response.data;
    });
  }

  updateGenderWiseOption(event: any) {
    let period = event.value;
    if (period === 'Semi-Annually') {
      period = 'Semi_Annually';
    }
    this.frequencyName = period;
    this.getDeptForGender();
  }

  updateGenderWiseOptionForDept(event: any) {
    // this.selectedDeptForGender = event.value; // Store selected department
    this.getDashBoardGenderWise();
  }

  getDeptForGender() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const request = {
      "bands": [],
      "companyId": this.loggedInUserCompanyID,
      "department": [],
      "frequencyCycle": this.monthPeriodForGender,
      "fromYear": Number(this.fromYear),
      "isEligible": true,
      "toYear": Number(this.toYear),
      "isHod": isHod
    }
    this.httpService.callPostService(this.config.getVPDepartments, request)
      .subscribe((result: any) => {
        this.frequencyDeptName = [];
        if (Array.isArray(result.data)) {
          result?.data?.forEach((ele: any) => {
            let obj = {
              id: ele,
              name: ele,
            }
            this.frequencyDeptName.push(obj);
          });
          this.frequencyDeptName = this.frequencyDeptName.sort((a: any, b: any) => a.name.localeCompare(b.name));
          this.deptForGender = this.frequencyDeptName[0].id;
          this.getDashBoardGenderWise();
        } else {
          console.error('Expected an array, but got:', result.data);
        }
      });
  }

  getDashBoardGenderWise() {
    
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    var depts = [];
    if (this.deptForGender == 'All') {
      depts = this.frequencyDeptName?.map((ele: any) => ele.id);
    } else {
      depts.push(this.deptForGender)
    }
    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "depts": depts, // Use selected department
      "frequency": null,
      "frequencyCycle": this.monthPeriodForGender,
      "fromYear": Number(this.fromYear),
      "toYear": Number(this.toYear),
      "isHod": isHod
    };

    this.httpService.callPostService(this.config.variableDashboardGenderWise, payload)
      .subscribe((response: any) => {
        this.genderWiseData = response.data;

        this.genderWiseBudgetVsActualDeptGraphType.bar = this.genderWiseBudgetVsActualBarGraph(this.genderWiseData);
        this.genderWiseBudgetVsActualDeptGraphType.pie = this.genderWiseBudgetVsActualPieGraph(this.genderWiseData);
        this.genderWiseBudgetVsActualDeptGraphType.line = this.genderWiseBudgetVsActualLineGraph(this.genderWiseData);

        this.switchGenderWiseBudgetVsActualGraphType('bar');
      });
  }


  // Graph section gender
  generWiseBudgetVsActualIcon: any = 'bar';
  GenerWiseBudgetVsActualTable: any = false;
  getGenderWiseBudgetVsActualData: any[] = []

  switchGenderWiseBudgetVsActualGraphType(graphType: any) {
    this.generWiseBudgetVsActualIcon = graphType;
    this.GenerWiseBudgetVsActualTable = false;

    const dom = document.getElementById("genderWiseVariablePayGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.genderWiseBudgetVsActualBarGraph(this.genderWiseData)
      }
      if (graphType == 'pie') {
        this.genderWiseBudgetVsActualPieGraph(this.genderWiseData)
      }
      if (graphType == 'line') {
        this.genderWiseBudgetVsActualLineGraph(this.genderWiseData)
      }
      if (this.genderWiseBudgetVsActualDeptGraphType[graphType] && typeof this.genderWiseBudgetVsActualDeptGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.genderWiseBudgetVsActualDeptGraphType[graphType], true);
      }
    }
  }

  genderWiseBudgetVsActualBarGraph(data: any): echarts.EChartsOption {
    if (data.length === 0) {
      if (this.genderWiseBudgetVsActualDeptGraphType) {
        this.genderWiseBudgetVsActualDeptGraphType.clear();
      }
    }
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tooltipContent = params?.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: data?.map((ele: any) => ele.gender),
          name: 'Gender',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          // axisLabel: {
          //   formatter: '{value}%',
          // },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Budget & Actual Amount',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false },
          axisLabel: {
            formatter: function (value: number) {
              return formatNumber(value, 0);
            }
          }
        },
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '15%',
          data: data?.map((ele: any) => ele.budgetAmount),
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '15%',
          data: data?.map((ele: any) => ele.actualAmount),
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
      ],
    };
  }

  genderWiseBudgetVsActualPieGraph(data: any): echarts.EChartsOption {
    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item'
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            {
              value: data?.map((ele: any) => ele.budgetAmount),
              name: 'Budget',
            },
            {
              value: data?.map((ele: any) => ele.actualAmount),
              name: 'Actual'
            }
          ]
        }
      ]
    }
  }
  genderWiseBudgetVsActualLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tooltipContent = params?.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: data?.map((ele: any) => ele.gender),
          name: 'Gender',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 6,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Budget & Actual Amount',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false },
          axisLabel: {
            formatter: function (value: number) {
              return formatNumber(value, 0);
            }
          }
        },
      ],
      series: [
        {
          name: 'Budget',
          type: 'line',
          data: data?.map((ele: any) => ele.budgetAmount),
          label: {
            show: true, position: 'right', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
        {
          name: 'Actual',
          type: 'line',
          data: data?.map((ele: any) => ele.actualAmount),
          label: {
            show: true, position: 'right', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        }
      ]
    };
  }

  GenderWiseBudgetVsActualTableData() {
    this.generWiseBudgetVsActualIcon = '';
    this.GenerWiseBudgetVsActualTable = true;
  }

  // Dept wise Graph Section

  getFrequencyForDeptWise() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      this.deptWiseFrequency = response.data;
    });
  }

  updateDeptWiseOption(event: any) {
    let period = event.value;
    if (period === 'Semi-Annually') {
      period = 'Semi_Annually';
    }
    this.frequencyName = period;
  }

  getDashBoardDeptWise() {
    
    // this.departmentNamesArrayForDashboard = this.variableDeptData?.map((data: any) => data.departmentName);
    // this.frequencyCycleForDashboard = this.variableDeptData[0]?.bands[0]?.employees[0]?.frequencyCycle || '';
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    var depts = [];
    if (this.deptWiseBudgetVsActualDept.length != 0) {
      depts = this.deptWiseBudgetVsActualDept?.map((ele: any) => ele.id)
    } else {
      depts = this.getDepartmentsList?.map((ele: any) => ele.id)
    }

    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "depts": depts,
      "frequency": null,
      "frequencyCycle": this.monthPeriodForDept,
      "fromYear": Number(this.fromYear),
      "toYear": Number(this.toYear),
      "isHod": isHod
    }
    this.httpService.callPostService(this.config.variableDashboardDeptWise, payload).subscribe((response: any) => {
      this.deptWiseData = response.data;
      this.deptIncrementGraphType.bar = this.deptWiseBudgetVsActualBarGraph(this.deptWiseData);
      this.deptIncrementGraphType.pie = this.deptWiseBudgetVsActualPieGraph(this.deptWiseData);
      this.deptIncrementGraphType.line = this.deptWiseBudgetVsActualLineGraph(this.deptWiseData);

      this.switchDeptWiseBudgetVsActualGraphType('bar');
    })
  }

  onSelectDeptWiseDashboard() {
    if (this.selectedDepartment.length > 0) {
      const department: any = this.selectedDepartment?.map((dept: any) => dept.name);
      this.deptName = department;
      this.getDashBoardDeptWise();
    } else {

    }
  }

  onDeDeptWiseDashboard() {
    this.deptWiseData = [];
    this.getDashBoardDeptWise();
  }

  selectAllDeptWiseDashboard(items: any): void {
    this.deptWiseBudgetVsActualDept = items;
    this.getDashBoardDeptWise();
  }

  onDeSelectAllDeptWiseDashboard() {
    this.deptWiseBudgetVsActualDept = [];
    this.getDashBoardDeptWise();
  }

  // Graph View for Dept Wise 

  budgetVsActualIncrementIcon: any = 'bar';
  budgetVsActualIncrementIconTable: any = false;
  deptWiseBudgetVsActualIcon: any = "bar";
  deptWiseBudgetVsActualTable: any = false;
  ratingWiseIncrementAmountIcon: any = 'bar';
  ratingWiseIncrementAmountTable: any = false;
  bandWiseBudgetVsActualsIcon: any = 'bar';
  bandWiseBudgetVsActualsTable: any = false;
  ratingVsEmpCountIcon: any = 'bar';
  ratingVsEmpCountTable: any = false;
  yearVsBudgetAndActualAmountIcon: any = 'bar';
  yearVsBudgetAndActualAmountTable: any = false;
  deptWiseEligibleAndNonEligibleEmpCountIcon: any = 'bar';
  deptWiseEligibleAndNonEligibleEmpCountTable: any = false;

  switchDeptWiseBudgetVsActualGraphType(graphType: any) {
    this.deptWiseBudgetVsActualIcon = graphType;
    this.deptWiseBudgetVsActualTable = false;

    const dom = document.getElementById("deptWiseVariablePayGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.deptWiseBudgetVsActualBarGraph(this.deptWiseData)
      }
      if (graphType == 'pie') {
        this.deptWiseBudgetVsActualPieGraph(this.deptWiseData)
      }
      if (graphType == 'line') {
        this.deptWiseBudgetVsActualLineGraph(this.deptWiseData)
      }
      if (this.deptIncrementGraphType[graphType] && typeof this.deptIncrementGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.deptIncrementGraphType[graphType], true);
      }
    }
  }

  deptWiseBudgetVsActualBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tooltipContent = params?.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return params[0].name + '<br/>' + tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: data?.map((ele: any) => ele.department),
          name: 'Departments',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 10,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            formatter: function (value) {
              return value.length > 5 ? value.slice(0, 4) + '...' : value; // Truncate to 4 characters + ...
            },
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Budget & Actual Amount',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false },
          axisLabel: {
            formatter: function (value: number) {
              return formatNumber(value, 0);
            }
          }
        },
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '15%',
          data: data?.map((ele: any) => ele.budgetAmount),
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '15%',
          data: data?.map((ele: any) => ele.actualAmount),
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
      ],
    };
  }

  deptWiseBudgetVsActualPieGraph(data: any): echarts.EChartsOption {
    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item'
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            {
              value: data?.map((ele: any) => ele.budgetAmount),
              name: 'Budget',
            },
            {
              value: data?.map((ele: any) => ele.actualAmount),
              name: 'Actual'
            }
          ]
        }
      ]
    }
  }
  deptWiseBudgetVsActualLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tooltipContent = params?.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return params[0].name + '<br/>' + tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: data?.map((ele: any) => ele.department),
          name: 'Departments',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 10,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            formatter: function (value) {
              return value.length > 5 ? value.slice(0, 4) + '...' : value; // Truncate to 4 characters + ...
            },
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Budget & Actual Amount',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false },
          axisLabel: {
            formatter: function (value: number) {
              return formatNumber(value, 0);
            }
          }
        },
      ],
      series: [
        {
          name: 'Budget',
          type: 'line',
          data: data?.map((ele: any) => ele.budgetAmount),
          label: {
            show: true, position: 'right', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
        {
          name: 'Actual',
          type: 'line',
          data: data?.map((ele: any) => ele.actualAmount),
          label: {
            show: true, position: 'right', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        }
      ]
    };
  }

  deptWiseBudgetVsActualTableData() {
    this.deptWiseBudgetVsActualIcon = '';
    this.deptWiseBudgetVsActualTable = true;
  }

  // Rating Wise Graph Section

  getFrequencyForRateWise() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      this.rateWiseFrequency = response.data;
    });
  }

  updateRateWiseOption(event: any) {
    let period = event.value;
    if (period === 'Semi-Annually') {
      period = 'Semi_Annually';
    }
    this.frequencyName = period;
    // this.getDashBoardGenderWise();
    this.getDeptForRating();
  }

  getDeptForRating() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const request = {
      "bands": [],
      "companyId": this.loggedInUserCompanyID,
      "department": [],
      "frequencyCycle": this.monthPeriodForRating,
      "fromYear": Number(this.fromYear),
      "isEligible": true,
      "toYear": Number(this.toYear),
      "isHod": isHod
    }
    this.httpService.callPostService(this.config.getVPDepartments, request)
      .subscribe((result: any) => {
        this.frequencyRating = [];
        if (Array.isArray(result.data)) {
          result?.data?.forEach((ele: any) => {
            let obj = {
              id: ele,
              name: ele,
            }
            this.frequencyRating.push(obj);
          });
          this.frequencyRating = this.frequencyRating?.sort((a: any, b: any) => a.name.localeCompare(b.name));
          this.deptForRating = this.frequencyRating[0].id;
          this.getDashBoardRateWise();
        } else {
          console.error('Expected an array, but got:', result.data);
        }
      });
  }

  updateRateWiseOptionForDept(event: any) {
    this.selectedDeptForRating = event.value
    this.getDashBoardRateWise();
  }

  getDashBoardRateWise() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    var depts = [];
    if (this.deptForRating == 'All') {
      depts = this.frequencyRating?.map((ele: any) => ele.id)
    } else {
      depts.push(this.deptForRating)
    }
    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "depts": depts,
      "frequency": null,
      "frequencyCycle": this.monthPeriodForRating,
      "fromYear": Number(this.fromYear),
      "toYear": Number(this.toYear),
      "isHod": isHod
    }
    this.httpService.callPostService(this.config.variableDashboardRateWise, payload).subscribe((response: any) => {
      this.rateWiseData = response.data;
      this.ratingWiseVariableBudgetGraphType.bar = this.ratingWiseBudgetVsActualBarGraph(this.rateWiseData);
      this.ratingWiseVariableBudgetGraphType.pie = this.ratingWiseBudgetVsActualPieGraph(this.rateWiseData);
      this.ratingWiseVariableBudgetGraphType.line = this.ratingWiseBudgetVsActualLineGraph(this.rateWiseData);

      this.switchRatingWiseBudgetVsActualGraphType('bar');
    })
  }

  onSelectRatingWiseDashboard() {
    if (this.selectedDepartment.length > 0) {
      const department: any = this.selectedDepartment?.map((dept: any) => dept.name);
      this.deptName = department;
      this.getDashBoardRateWise();
    } else {
    }
  }

  onDeRatingWiseDashboard() {
    this.rateWiseData = [];
    this.getDashBoardRateWise();
  }

  selectAllRatingWiseDashboard(items: any): void {
    this.deptName = items?.map((ele: any) => ele.name)
    this.getDashBoardRateWise();
  }

  onDeSelectAllRateWiseDashboard() {
    this.rateWiseData = [];
    this.getDashBoardRateWise();
  }

  // Graph View for Rating Wise 

  switchRatingWiseBudgetVsActualGraphType(graphType: any) {
    this.ratingWiseIncrementAmountIcon = graphType;
    this.ratingWiseIncrementAmountTable = false;

    const dom = document.getElementById("rateWiseVariablePayGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.ratingWiseBudgetVsActualBarGraph(this.rateWiseData)
      }
      if (graphType == 'pie') {
        this.ratingWiseBudgetVsActualPieGraph(this.rateWiseData)
      }
      if (graphType == 'line') {
        this.ratingWiseBudgetVsActualLineGraph(this.rateWiseData)
      }
      if (this.ratingWiseVariableBudgetGraphType[graphType] && typeof this.ratingWiseVariableBudgetGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.ratingWiseVariableBudgetGraphType[graphType], true);
      }
    }
  }

  ratingWiseBudgetVsActualBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tooltipContent = params?.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: data?.map((ele: any) => ele.rating),
          name: 'Ratings',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 10,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Budget & Actual Amount',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false },
          axisLabel: {
            formatter: function (value: number) {
              return formatNumber(value, 0);
            }
          }
        },
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '15%',
          data: data?.map((ele: any) => ele.budgetAmount),
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '15%',
          data: data?.map((ele: any) => ele.actualAmount),
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
      ],
    };
  }

  ratingWiseBudgetVsActualPieGraph(data: any): echarts.EChartsOption {
    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item'
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            {
              value: data?.map((ele: any) => ele.budgetAmount),
              name: 'Budget',
            },
            {
              value: data?.map((ele: any) => ele.actualAmount),
              name: 'Actual'
            }
          ]
        }
      ]
    }
  }
  ratingWiseBudgetVsActualLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tooltipContent = params?.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: data?.map((ele: any) => ele.rating),
          name: 'Ratings',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 10,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Budget & Actual Amount',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false },
          axisLabel: {
            formatter: function (value: number) {
              return formatNumber(value, 0);
            }
          }
        },
      ],
      series: [
        {
          name: 'Budget',
          type: 'line',
          data: data?.map((ele: any) => ele.budgetAmount),
          label: {
            show: true, position: 'right', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
        {
          name: 'Actual',
          type: 'line',
          data: data?.map((ele: any) => ele.actualAmount),
          label: {
            show: true, position: 'right', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        }
      ]
    };
  }

  ratingWiseBudgetVsActualTableData() {
    this.ratingWiseIncrementAmountIcon = '';
    this.ratingWiseIncrementAmountTable = true;
  }

  // Band Wise Graph Section 

  frequencyBand: any = [];
  deptForBand: any = 'All';

  getFrequencyForBandWise() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      this.bandWiseFrequency = response.data;
    });
  }

  updateBandWiseOption(event: any) {
    let period = event.value;
    if (period === 'Semi-Annually') {
      period = 'Semi_Annually';
    }
    this.frequencyName = period;
    // this.getDashBoardGenderWise();

    this.getDeptForBand();
  }

  getDeptForBand() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const request = {
      "bands": [],
      "companyId": this.loggedInUserCompanyID,
      "department": [],
      "frequencyCycle": this.monthPeriodForBand,
      "fromYear": Number(this.fromYear),
      "isEligible": true,
      "toYear": Number(this.toYear),
      "isHod": isHod
    }
    this.httpService.callPostService(this.config.getVPDepartments, request)
      .subscribe((res: any) => {
        this.frequencyBand = [];
        if (Array.isArray(res.data)) {
          res?.data?.forEach((ele: any) => {
            let obj = {
              id: ele,
              name: ele,
            }
            this.frequencyBand.push(obj);
          });
          this.frequencyBand = this.frequencyBand.sort((a: any, b: any) => a.name.localeCompare(b.name));
          this.deptForBand = this.frequencyBand[0].id;
          this.getDashBoardBandWise();
        } else {
          console.error('Expected an array, but got:', res.data);
        }
      });
  }

  updateBandWiseOptionForDept(event: any) {
    this.selectedDeptForBands = event.value
    this.getDashBoardBandWise();
  }

  getDashBoardBandWise() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    var depts = [];
    if (this.deptForBand == 'All') {
      depts = this.frequencyBand?.map((ele: any) => ele.id)
    } else {
      depts.push(this.deptForBand)
    }

    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "depts": depts,
      "frequency": null,
      "frequencyCycle": this.monthPeriodForBand,
      "fromYear": Number(this.fromYear),
      "toYear": Number(this.toYear),
      "isHod": isHod
    }

    this.httpService.callPostService(this.config.variableDashboardBandWise, payload).subscribe((response: any) => {
      this.bandWiseData = response.data;
      this.bandWiseBudgetVsActualsGraphType.bar = this.bandWiseBudgetVsActualBarGraph(this.bandWiseData);
      this.bandWiseBudgetVsActualsGraphType.pie = this.bandWiseBudgetVsActualPieGraph(this.bandWiseData);
      this.bandWiseBudgetVsActualsGraphType.line = this.bandWiseBudgetVsActualLineGraph(this.bandWiseData);

      this.switchBandWiseBudgetVsActualGraphType('bar');

    })
  }

  onSelectBandWiseDashboard() {
    if (this.selectedDepartment.length > 0) {
      const department: any = this.selectedDepartment?.map((dept: any) => dept.name);
      this.deptName = department;
      this.getDashBoardBandWise();
    } else {
    }
  }

  onDeBandWiseDashboard() {
    this.rateWiseData = [];
    this.getDashBoardRateWise();
  }

  selectAllBandWiseDashboard(items: any): void {
    this.deptName = items?.map((ele: any) => ele.name)
    this.getDashBoardRateWise();
  }

  onDeSelectAllBandWiseDashboard() {
    this.rateWiseData = [];
    this.getDashBoardBandWise();
  }

  // Graph View for Band Wise 

  switchBandWiseBudgetVsActualGraphType(graphType: any) {
    this.bandWiseIncrementAmountIcon = graphType;
    this.bandWiseBudgetVsActualsTable = false;

    const dom = document.getElementById("bandWiseVariablePayGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.bandWiseBudgetVsActualBarGraph(this.bandWiseData)
      }
      if (graphType == 'pie') {
        this.bandWiseBudgetVsActualPieGraph(this.bandWiseData)
      }
      if (graphType == 'line') {
        this.bandWiseBudgetVsActualLineGraph(this.bandWiseData)
      }
      if (this.bandWiseBudgetVsActualsGraphType[graphType] && typeof this.bandWiseBudgetVsActualsGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.bandWiseBudgetVsActualsGraphType[graphType], true);
      }
    }
  }

  bandWiseBudgetVsActualBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };
    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tooltipContent = params?.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: data?.map((ele: any) => ele.band),
          name: 'Band',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 10,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Budget & Actual Amount',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false },
          axisLabel: {
            formatter: function (value: number) {
              return formatNumber(value, 0);
            }
          }
        },
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '15%',
          data: data?.map((ele: any) => ele.budgetAmount),
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '15%',
          data: data?.map((ele: any) => ele.actualAmount),
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
      ],
    };
  }

  bandWiseBudgetVsActualPieGraph(data: any): echarts.EChartsOption {
    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item'
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            {
              value: data?.map((ele: any) => ele.budgetAmount),
              name: 'Budget',
            },
            {
              value: data?.map((ele: any) => ele.actualAmount),
              name: 'Actual'
            }
          ]
        }
      ]
    }
  }
  bandWiseBudgetVsActualLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };
    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tooltipContent = params?.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: data?.map((ele: any) => ele.band),
          name: 'Band',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 10,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Budget & Acutual Amount',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false },
          axisLabel: {
            formatter: function (value: number) {
              return formatNumber(value, 0);
            }
          }
        },
      ],
      series: [
        {
          name: 'Budget',
          type: 'line',
          data: data?.map((ele: any) => ele.budgetAmount),
          label: {
            show: true, position: 'right', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
        {
          name: 'Actual',
          type: 'line',
          data: data?.map((ele: any) => ele.actualAmount),
          label: {
            show: true, position: 'right', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        }
      ]
    };
  }

  bandWiseBudgetVsActualTableData() {
    this.bandWiseIncrementAmountIcon = '';
    this.bandWiseBudgetVsActualsTable = true;
  }

  // Rate and Employees

  frequencyEmployeeVSBand: any = [];
  deptForRateVsEmloyee: any = null;

  getFrequencyForRateEmployee() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      this.rateEmployeeFrequency = response.data;
    });
  }

  updateRateEmployeeWiseOption(event: any) {
    let period = event.value;
    if (period === 'Semi-Annually') {
      period = 'Semi_Annually';
    }
    this.frequencyName = period;
    // this.getDashBoardGenderWise();
    this.getDeptForRateVSEmployee();
  }

  getDeptForRateVSEmployee() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const request = {
      "bands": [],
      "companyId": this.loggedInUserCompanyID,
      "department": [],
      "frequencyCycle": this.monthPeriodForRatingCount,
      "fromYear": Number(this.fromYear),
      "isEligible": true,
      "toYear": Number(this.toYear),
      "isHod": isHod
    }
    this.httpService.callPostService(this.config.getVPDepartments, request)
      .subscribe((res: any) => {
        this.frequencyEmployeeVSBand = [];
        if (Array.isArray(res.data)) {
          res?.data?.forEach((ele: any) => {
            let obj = {
              id: ele,
              name: ele,
            }
            this.frequencyEmployeeVSBand.push(obj);
          });
          this.frequencyEmployeeVSBand = this.frequencyEmployeeVSBand.sort((a: any, b: any) => a.name.localeCompare(b.name));
          this.deptForRateVsEmloyee = this.frequencyEmployeeVSBand[0].id;
          this.getDashBoardRateEmployeeWise();
        } else {
          console.error('Expected an array, but got:', res.data);
        }
      });
  }

  updateYearVsEmolyeeOptionForDept(event: any) {
    this.selectedDeptForRatingVsEmployeeCount = event.value;
    this.getDashBoardRateEmployeeWise();
  }

  getDashBoardRateEmployeeWise() {
    // this.departmentNamesArrayForDashboard = this.variableDeptData?.map((data: any) => data.departmentName);
    // this.frequencyCycleForDashboard = this.variableDeptData[0]?.bands[0]?.employees[0]?.frequencyCycle || '';
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }

    var depts = [];
    if (this.deptForRateVsEmloyee == 'All') {
      depts = this.frequencyEmployeeVSBand?.map((ele: any) => ele.id);
    } else {
      depts.push(this.deptForRateVsEmloyee)
    }
    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "depts": depts,
      "frequency": null,
      "frequencyCycle": this.monthPeriodForRatingCount,
      "fromYear": Number(this.fromYear),
      "toYear": Number(this.toYear),
      "isHod": isHod
    }
    this.httpService.callPostService(this.config.variableDashboardRateEmployee, payload).subscribe((response: any) => {
      this.rateEmployeeWiseData = response.data;
      // this.defaultChartEmployeeCount();
      
      this.ratingVsEmpCountGraphType.bar = this.ratingVsEmpCountBarGraph(this.rateEmployeeWiseData);
      this.ratingVsEmpCountGraphType.pie = this.ratingVsEmpCountPieGraph(this.rateEmployeeWiseData);
      this.ratingVsEmpCountGraphType.line = this.ratingVsEmpCountLineGraph(this.rateEmployeeWiseData);

      this.switchRateEmployeeWiseBudgetVsActualGraphType('bar');
    })
  }

  onSelectRateEmployeeWiseDashboard() {
    if (this.selectedDepartment.length > 0) {
      const department: any = this.selectedDepartment?.map((dept: any) => dept.name);
      this.deptName = department;
      this.getDashBoardRateEmployeeWise();
    }
  }

  onDeRateEmployeeWiseDashboard() {
    this.rateWiseData = [];
    this.getDashBoardRateEmployeeWise();
  }

  selectAllRateEmployeeWiseDashboard(items: any): void {
    this.deptName = items?.map((ele: any) => ele.name)
    this.getDashBoardRateWise();
  }

  onDeSelectAllRateEmployeeWiseDashboard() {
    this.rateWiseData = [];
    this.getDashBoardRateEmployeeWise();
  }

  // Graph View for Rate and Employee Wise 

  switchRateEmployeeWiseBudgetVsActualGraphType(graphType: any) {
    this.ratingVsEmpCountIcon = graphType;
    this.ratingVsEmpCountTable = false;

    const dom = document.getElementById("ratingWiseVariablePayGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.ratingVsEmpCountBarGraph(this.rateEmployeeWiseData)
      }
      if (graphType == 'pie') {
        this.ratingVsEmpCountPieGraph(this.rateEmployeeWiseData)
      }
      if (graphType == 'line') {
        this.ratingVsEmpCountLineGraph(this.rateEmployeeWiseData)
      }
      if (this.ratingVsEmpCountGraphType[graphType] && typeof this.ratingVsEmpCountGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.ratingVsEmpCountGraphType[graphType], true);
      }
    }
  }

  ratingVsEmpCountBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      // color: ['#393186'],
      // tooltip: {
      //   trigger: 'axis',
      //   axisPointer: {
      //     type: 'shadow',
      //   },
      //   // formatter: function (params: any) {
      //   //   let tooltipContent = params?.map((item: any) =>
      //   //     `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
      //   //   ).join('<br/>');
      //   //   return tooltipContent;
      //   // }
      // },
      // legend: {
      //   data: ['Employee'],
      //   bottom: 0,
      //   left: 'center',
      // },
      // xAxis: [
      //   {
      //     type: 'category',
      //     data: data?.map((ele: any) => ele.rating),
      //     name: 'Rating',
      //     nameLocation: 'middle',
      //     nameTextStyle: {
      //       fontSize: 14,
      //       padding: 10,
      //     },
      //     axisTick: {
      //       alignWithLabel: true,
      //     },
      //   },
      // ],
      // yAxis: [
      //   {
      //     type: 'value',
      //     name: 'Employee Count',
      //     nameLocation: 'middle',
      //     nameTextStyle: {
      //       fontSize: 14,
      //       padding: 20
      //     },
      //     splitLine: { show: false },
      //     axisLabel: {
      //       // formatter: function (value: number) {
      //       //   return formatNumber(value, 0);
      //       // }
      //     }
      //   },
      // ],
      // series: [
      //   {
      //     name: 'Employee Count',
      //     type: 'bar',
      //     barWidth: '15%',
      //     data: data?.map((ele: any) => ele.employeeCount),
      //     label: { show: true, position: 'top', fontSize: 9,
      //       // formatter: (params: any) => formatNumber(params.value, 4),
      //      }
      //   },
      // ],
      color: ['#393186'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        // formatter: function (params: any) {
        //   let tooltipContent = params?.map((item: any) =>
        //     `${item.seriesName}: ${formatNumber(parseFloat(item.value), 0)}`
        //   ).join('<br/>');
        //   return tooltipContent;
        // }
      },
      legend: {
        data: ['Employee Count'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: data?.map((ele: any) => ele.rating),
          name: 'Rating',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 10,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Employee Count',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false },
          axisLabel: {

          }
        },
      ],
      series: [
        {
          name: 'Employee Count',
          type: 'bar',
          barWidth: '15%',
          data: data?.map((ele: any) => ele.employeeCount),
          label: {
            show: true, position: 'top', fontSize: 9,
            // formatter: (params: any) => formatNumber(params.value, 0),
          }
        },
      ],

    };
  }

  ratingVsEmpCountPieGraph(data: any): echarts.EChartsOption {
    var data1: { name: any; value: any; }[] = [];
    data?.forEach((ele: any) => {
      let obj = {
        name: ele.rating,
        value: ele.employeeCount
      }
      data1.push(obj)
    })
    return {
      tooltip: {
        trigger: 'item',
        formatter: function (params) {
          // Type assertion to provide the correct type
          const param = params as unknown as {
            name: string;
            value: number;
            data: { name: string; numberOfEmployees: number; value: number; }
          };
          const total = data.reduce((acc: any, item: { value: any; }) => acc + item.value, 0);
          const percentage = ((param.value / total) * 100).toFixed(2);

          return `${param.name}: ${param.value}`;
        }
      },
      legend: {
        bottom: 10
      },
      series: [
        {
          name: 'Rating',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'outside',  // Place labels outside
            formatter: '{b}: {d}%'  // Label format: category and percentage
          },
          emphasis: {
            label: {
              show: false,
              fontSize: 20,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: data1,
          itemStyle: {
            color: function (params: any) {
              const value = params.name; // Get the value of the current bar
              const colors = ['#F42700', '#E4BEA4', '#FBBC3C', '#403684', '#FF8B00', '#32AB4A'];

              // Check if the value is above 90
              if (value == '0-50') {
                return colors[0]; // First color if value is above 90
              } if (value == '50-60') {
                return colors[1]; // First color if value is above 90
              } if (value == '60-70') {
                return colors[2]; // First color if value is above 90
              } if (value == '70-80') {
                return colors[3]; // First color if value is above 90
              } if (value == '80-90') {
                return colors[4]; // First color if value is above 90
              } if (value == '>90') {
                return colors[5]; // First color if value is above 90
              }
              else {
                return colors[params.dataIndex % colors.length]; // Cycle through colors otherwise
              }
            }
          }
        }
      ],
      xAxis: { show: false },  // Hide xAxis for pie chart
      yAxis: { show: false }
    };
  }
  ratingVsEmpCountLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };
    return {
      color: ['#393186'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        // formatter: function (params: any) {
        //   let tooltipContent = params?.map((item: any) =>
        //     `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
        //   ).join('<br/>');
        //   return tooltipContent;
        // }
      },
      legend: {
        data: ['Employee'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: data?.map((ele: any) => ele.rating),
          name: 'Rating',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 10,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Employee Count',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false },
          axisLabel: {
            // formatter: function (value: number) {
            //   return formatNumber(value, 0);
            // }
          }
        },
      ],
      series: [
        {
          name: 'Employee Count',
          type: 'line',
          data: data?.map((ele: any) => ele.employeeCount),
          label: {
            show: true, position: 'right', fontSize: 9,
            // formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
      ]
    };
  }

  ratingVsEmpCountTableData() {
    this.ratingVsEmpCountIcon = '';
    this.ratingVsEmpCountTable = true;
  }

  // Year vs Budget & Actual Amount

  getFrequencyForActualAmount() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      this.actualAmountFrequency = response.data;
    });
  }

  updateActualAmountWiseOption(event: any) {
    this.selectedDeptForYearVsBudget = event.value;
    this.getDashBoardActualAmountWise();
  }

  getDashBoardActualAmountWise() {
    
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    var depts = [];
    if (this.selectGenderWiseBudgetVsActualDept == 'All') {
      depts = this.getDepartmentsList?.map((ele: any) => ele.id)
    } else {
      depts.push(this.selectGenderWiseBudgetVsActualDept)
    }
    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "depts": depts,
      "frequency": this.setupFrequency,
      "frequencyCycle": this.frequencyName,
      "fromYear": Number(this.fromYear),
      "toYear": Number(this.toYear),
      "isHod": isHod
    }
    this.httpService.callPostService(this.config.variableDashboardActualAmount, payload).subscribe((response: any) => {
      this.ActualAmountWiseData = response.data;
      this.yearVsBudgetAndActualAmountGraphType.bar = this.yearVsBudgetCountBarGraph(this.ActualAmountWiseData);
      this.yearVsBudgetAndActualAmountGraphType.pie = this.yearVsBudgetCountPieGraph(this.ActualAmountWiseData);
      this.yearVsBudgetAndActualAmountGraphType.line = this.yearVsBudgetCountLineGraph(this.ActualAmountWiseData);

      this.switchYearVsBudgetActualAmountGraphType('bar');
    })
  }

  onSelectActualAmountWiseDashboard() {
    if (this.selectedDepartment.length > 0) {
      const department: any = this.selectedDepartment?.map((dept: any) => dept.name);
      this.deptName = department;
      this.getDashBoardActualAmountWise();
    } else {
    }
  }

  onDeActualAmountWiseDashboard() {
    this.rateWiseData = [];
    this.getDashBoardActualAmountWise();
  }

  selectAllRateActualAmountWiseDashboard(items: any): void {
    this.deptName = items?.map((ele: any) => ele.name)
    this.getDashBoardActualAmountWise();
  }

  onDeSelectAllActualAmountWiseDashboard() {
    this.rateWiseData = [];
    this.getDashBoardActualAmountWise();
  }

  // Graph View for Actual Amount Wise 

  switchYearVsBudgetActualAmountGraphType(graphType: any) {
    this.yearVsBudgetAndActualAmountIcon = graphType;
    this.yearVsBudgetAndActualAmountTable = false;

    const dom = document.getElementById("actualAmountVariablePayGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.yearVsBudgetCountBarGraph(this.ActualAmountWiseData)
      }
      if (graphType == 'pie') {
        this.yearVsBudgetCountPieGraph(this.ActualAmountWiseData)
      }
      if (graphType == 'line') {
        this.yearVsBudgetCountLineGraph(this.ActualAmountWiseData)
      }
      if (this.yearVsBudgetAndActualAmountGraphType[graphType] && typeof this.yearVsBudgetAndActualAmountGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.yearVsBudgetAndActualAmountGraphType[graphType], true);
      }
    }
  }

  yearVsBudgetCountBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tooltipContent = params?.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: data?.map((ele: any) => ele.year),
          name: 'Year',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 10,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Budget & Actual Amount',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false },
          axisLabel: {
            formatter: function (value: number) {
              return formatNumber(value, 0);
            }
          },
        },
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '15%',
          data: data?.map((ele: any) => ele.budgetAmount),
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '15%',
          data: data?.map((ele: any) => ele.actualAmount),
          label: {
            show: true, position: 'top', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
      ],
    };
  }
  yearVsBudgetCountPieGraph(data: any): echarts.EChartsOption {
    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item'
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            {
              value: data?.map((ele: any) => ele.budgetAmount),
              name: 'Budget',
            },
            {
              value: data?.map((ele: any) => ele.actualAmount),
              name: 'Actual'
            }
          ]
        }
      ]
    }
  }
  yearVsBudgetCountLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };
    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tooltipContent = params?.map((item: any) =>
            `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
          ).join('<br/>');
          return tooltipContent;
        }
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: {
        type: 'category',
        data: data?.map((ele: any) => ele.year),
        name: 'Year',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 10,
        },
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        name: 'Budget & Actual Amount',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 20
        },
        splitLine: { show: false },
        axisLabel: {
          formatter: function (value: number) {
            return formatNumber(value, 0);
          }
        },
      },
      series: [
        {
          name: 'Budget',
          type: 'line',
          data: data?.map((ele: any) => ele.budgetAmount),
          label: {
            show: true, position: 'right', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        },
        {
          name: 'Actual',
          type: 'line',
          data: data?.map((ele: any) => ele.actualAmount),
          label: {
            show: true, position: 'right', fontSize: 9,
            formatter: (params: any) => formatNumber(params.value, 4)
          }
        }
      ]
    };
  }

  yearVsBudgetEmpCountTableData() {
    this.yearVsBudgetAndActualAmountIcon = '';
    this.yearVsBudgetAndActualAmountTable = true;
  }

  // Eligible Employees Graph

  getFrequencyForEligibleEmployee() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      this.eligibleEmployeeFrequency = response.data;
    });
  }

  updateEligibleEmployeeWiseOption(event: any) {
    let period = event.value;
    if (period === 'Semi-Annually') {
      period = 'Semi_Annually';
    }
    this.frequencyName = period;
    // this.getDashBoardGenderWise();
  }

  getDashBoardEligibleEmployeeWise() {
    // this.departmentNamesArrayForDashboard = this.variableDeptData?.map((data: any) => data.departmentName);
    // this.frequencyCycleForDashboard = this.variableDeptData[0]?.bands[0]?.employees[0]?.frequencyCycle || '';
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    var depts = [];
    if (this.selectedDeptNameForEligbleNonEligible.length != 0) {
      depts = this.selectedDeptNameForEligbleNonEligible?.map((ele: any) => ele.id)
    } else {
      depts = this.getDepartmentsList?.map((ele: any) => ele.id)
    }
    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "depts": depts,
      "frequency": null,
      "frequencyCycle": this.monthPeriodForDeptWiseEligbleNonEligible,
      "fromYear": Number(this.fromYear),
      "toYear": Number(this.toYear),
      "isHod": isHod
    }

    this.httpService.callPostService(this.config.variableDashboardDeptWiseEligibleEmployees, payload).subscribe((response: any) => {
      this.eligibleEmployeeWiseData = response.data;

      this.deptWiseEligibleAndNonEligibleEmpCountGraphType.bar = this.deptWiseEligibleAndNonEligibleCountBarGraph(this.eligibleEmployeeWiseData);
      this.deptWiseEligibleAndNonEligibleEmpCountGraphType.pie = this.deptWiseEligibleAndNonEligibleCountPieGraph(this.eligibleEmployeeWiseData);
      this.deptWiseEligibleAndNonEligibleEmpCountGraphType.line = this.deptWiseEligibleAndNonEligibleCountLineGraph(this.eligibleEmployeeWiseData);

      this.switchEligibleEmployeeWiseDataGraphType('bar');
    })
  }


  selectAllEligibleEmployeesWiseDashboard(items: any): void {
    this.selectedDeptNameForEligbleNonEligible = items;
    this.getDashBoardEligibleEmployeeWise();
  }

  onDeSelectAllEligibleEmployeesWiseDashboard() {
    this.selectedDeptNameForEligbleNonEligible = [];
    this.getDashBoardEligibleEmployeeWise();
  }

  // Graph View for Actual Amount Wise 

  switchEligibleEmployeeWiseDataGraphType(graphType: any) {
    this.deptWiseEligibleAndNonEligibleEmpCountIcon = graphType;
    this.deptWiseEligibleAndNonEligibleEmpCountTable = false;

    const dom = document.getElementById("eligibleEmployeeCountGraph") as HTMLDivElement
    const chartEmpTaskStatus = echarts.init(dom);
    if (chartEmpTaskStatus) {
      if (graphType == 'bar') {
        this.deptWiseEligibleAndNonEligibleCountBarGraph(this.eligibleEmployeeWiseData)
      }
      if (graphType == 'pie') {
        this.deptWiseEligibleAndNonEligibleCountPieGraph(this.eligibleEmployeeWiseData)
      }
      if (graphType == 'line') {
        this.deptWiseEligibleAndNonEligibleCountLineGraph(this.eligibleEmployeeWiseData)
      }
      if (this.deptWiseEligibleAndNonEligibleEmpCountGraphType[graphType] && typeof this.deptWiseEligibleAndNonEligibleEmpCountGraphType[graphType] === "object") {
        chartEmpTaskStatus.setOption(this.deptWiseEligibleAndNonEligibleEmpCountGraphType[graphType], true);
      }
    }
  }

  deptWiseEligibleAndNonEligibleCountBarGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };

    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        // formatter: function (params: any) {
        //   let tooltipContent = params?.map((item: any) =>
        //     `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
        //   ).join('<br/>');
        //   return tooltipContent;
        // }
      },
      legend: {
        data: ['Eligible', 'Not Eligible'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: data?.map((ele: any) => ele.department),
          name: 'Departments',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 10,
          },
          axisTick: {
            alignWithLabel: true,
          },
          axisLabel: {
            formatter: function (value) {
              return value.length > 5 ? value.slice(0, 4) + '...' : value; // Truncate to 4 characters + ...
            },
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          name: 'Count',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false },
          axisLabel: {
            // formatter: function (value: number) {
            //   return formatNumber(value, 0);
            // }
          }
        },
      ],
      series: [
        {
          name: 'Eligible',
          type: 'bar',
          barWidth: '15%',
          data: data?.map((ele: any) => ele.eligibleCount),
          label: {
            show: true, position: 'top', fontSize: 9,
            // formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
        {
          name: 'Not Eligible',
          type: 'bar',
          barWidth: '15%',
          data: data?.map((ele: any) => ele.notEligibleCount),
          label: {
            show: true, position: 'top', fontSize: 9,
            // formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
      ],
    };
  }
  deptWiseEligibleAndNonEligibleCountPieGraph(data: any): echarts.EChartsOption {
    return {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item'
      },
      legend: {
        data: ['Eligible', 'Not Eligible'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            {
              value: data?.map((ele: any) => ele.eligibleCount),
              name: 'Eligible',
            },
            {
              value: data?.map((ele: any) => ele.notEligibleCount),
              name: 'Not Eligible'
            }
          ]
        }
      ]
    }
  }
  deptWiseEligibleAndNonEligibleCountLineGraph(data: any): echarts.EChartsOption {
    const formatNumber = (num: number, decimals = 1) => {
      if (num >= 1e7) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e7) + ' Cr';
      if (num >= 1e5) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e5) + ' L';
      if (num >= 1e3) return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num / 1e3) + ' K';
      return new Intl.NumberFormat('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(num);
    };
    return {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        // formatter: function (params: any) {
        //   let tooltipContent = params?.map((item: any) =>
        //     `${item.seriesName}: ${formatNumber(parseFloat(item.value), 4)}`
        //   ).join('<br/>');
        //   return tooltipContent;
        // }
      },
      legend: {
        data: ['Eligible', 'Not Eligible'],
        bottom: 0,
        left: 'center',
      },
      xAxis: {
        show: true,
        type: 'category',
        name: 'Departments',
        data: data?.map((ele: any) => ele.department),
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 10,
        },
        axisTick: {
          alignWithLabel: true,
        },
        axisLabel: {
          formatter: function (value) {
            return value.length > 5 ? value.slice(0, 4) + '...' : value; // Truncate to 4 characters + ...
          },
        },
      },
      yAxis: {
        type: 'value',
        name: 'Count',
        nameLocation: 'middle',
        nameTextStyle: {
          fontSize: 14,
          padding: 20
        },
        splitLine: { show: false },
        axisLabel: {
          // formatter: function (value: number) {
          //   return formatNumber(value, 0);
          // }
        }
      },
      series: [
        {
          name: 'Eligible',
          type: 'line',
          data: data?.map((ele: any) => ele.eligibleCount),
          label: {
            show: true, position: 'right', fontSize: 9,
            // formatter: (params: any) => formatNumber(params.value, 4),
          }
        },
        {
          name: 'Not Eligible',
          type: 'line',
          data: data?.map((ele: any) => ele.notEligibleCount),
          label: {
            show: true, position: 'right', fontSize: 9,
            // formatter: (params: any) => formatNumber(params.value, 4),
          }
        }
      ]
    };
  }
  deptWiseEligibleAndNonEligibleCountLineGraphTable() {
    this.deptWiseEligibleAndNonEligibleEmpCountIcon = '';
    this.deptWiseEligibleAndNonEligibleEmpCountTable = true;
  }

  // Summary

  variablePaySummaryTableHideShowAllData = [
    {
      "fieldId": 1,
      "isVisible": true,
      "fieldName": "Department",
      "position": 1,
      "isEditable": true
    },
    {
      "fieldId": 2,
      "isVisible": true,
      "fieldName": "Band",
      "position": 2,
      "isEditable": true
    },
    {
      "fieldId": 3,
      "isVisible": true,
      "fieldName": "Total Emp.",
      "position": 3,
      "isEditable": true
    },
    {
      "fieldId": 4,
      "isVisible": true,
      "fieldName": "Total Fixed CTC",
      "position": 4,
      "isEditable": true
    },
    {
      "fieldId": 5,
      "isVisible": true,
      "fieldName": "Eligible Emp. Count",
      "position": 5,
      "isEditable": true
    },
    {
      "fieldId": 6,
      "isVisible": true,
      "fieldName": "Eligible Emp. Fixed CTC",
      "position": 6,
      "isEditable": true
    },
    {
      "fieldId": 7,
      "isVisible": true,
      "fieldName": "Overall VP Bonus Budget",
      "position": 7,
      "isEditable": true
    },
    {
      "fieldId": 8,
      "isVisible": true,
      "fieldName": "VP Bonus Actual Amount",
      "position": 8,
      "isEditable": true
    },
    {
      "fieldId": 9,
      "isVisible": true,
      "fieldName": "Varience",
      "position": 9,
      "isEditable": true
    },
    {
      "fieldId": 10,
      "isVisible": true,
      "fieldName": "Varience % (Varience * 100 / Budget)",
      "position": 10,
      "isEditable": true
    }
  ];

  updateVariablePaySummaryColumnVisibility(data: any, index: any) {
    this.variablePaySummaryTableHideShowAllData[index].isVisible = false;
  }

  onSelectVariablePaySummaryHideShowCheckBox(event: any) {
    this.isAnyColumnInvisible = this.variablePaySummaryTableHideShowAllData?.some((ele: any) => !ele.isVisible);
    this.allColumnsInvisible = this.variablePaySummaryTableHideShowAllData?.every((ele: any) => !ele.isVisible);
  }

  getVariableSummaryColumnVisibility(fieldName: string): boolean {
    const column = this.variablePaySummaryTableHideShowAllData.find(item => item.fieldName.trim() === fieldName.trim());
    return column ? column.isVisible : false;
  }

  getFiscalYearForVariableSummary() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.companyYears = [];
      data?.data?.yearRanges?.forEach((ele: any) => {
        var test = ele.split('_');
        let obj = {
          year: test[0] + '-' + test[1]
        };
        this.companyYears.push(obj);
      });

      const currentYear = new Date().getFullYear();
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
      }

      let selectedYearIndex = this.companyYears.findIndex((ele: any) => ele?.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0; // Default to the first year if current year not found
      }
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      let yearValue1 = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue1 = `${currentYear}-${currentYear}`;
      } else {
        yearValue1 = `${currentYear}-${currentYear + 1}`;
        if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
          if (currentMonth < 3) {
            yearValue1 = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'July_Jun') {
          if (currentMonth < 6) {
            yearValue1 = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
          if (currentMonth < 9) {
            yearValue1 = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
      }
      this.selectedYear = yearValue1;
      var test = this.selectedYear?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];


      const nextYearIndex = (selectedYearIndex + 1) % this.companyYears.length;
      const nextToNextYearIndex = (selectedYearIndex + 2) % this.companyYears.length;

      this.fromVariablePayMonth = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.companyYears[nextYearIndex]?.year);
      this.toVariablePayMonth = this.getToMonthsArray(this.loggedInCompanyFiscalyear, this.companyYears[nextToNextYearIndex]?.year);
      this.getFrequencyForSummary();
      if (Number(this.fromYear) == currentYear
        || Number(this.toYear) == currentYear) {
        this.isSelectedYearIsSameYeartoCurrentYear = true;
      } else {
        this.isSelectedYearIsSameYeartoCurrentYear = false;
      }
    });
  }

  variablePeriodFrquencySummary!: any[];
  getSummaryData: any;
  setPeriod: any[] = [];
  getFrequencyForSummary() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      this.variablePeriodFrquencySummary = response.data;
      const currentMonthIndex = new Date().getMonth();
      const today = new Date();
      const month = today.toLocaleString('default', { month: 'long' });
      if (this.setupFrequency == 'Monthly') {
        this.variablePeriodFrquencySummary?.forEach((ele: any) => {
          var checkMonth = ele?.split('-');
          if (month == checkMonth[0]) {
            this.frequencyPeriod = ele;
          }
        });
      }

      if (this.setupFrequency == 'Quarterly' || this.setupFrequency == 'Semi_Annually' || this.setupFrequency == 'Semi-Annually'
        || this.setupFrequency == 'Annually'
      ) {
        for (let range of this.variablePeriodFrquencySummary) {
          const [start, end] = range?.split('-');
          const startMonthIndex = this.getMonthIndex(start);
          const endMonthIndex = this.getMonthIndex(end);
          if (
            (currentMonthIndex >= startMonthIndex && currentMonthIndex <= endMonthIndex) ||
            (startMonthIndex > endMonthIndex && (currentMonthIndex >= startMonthIndex || currentMonthIndex <= endMonthIndex))
          ) {
            this.frequencyPeriod = range;
          }
        }
      }
      if (this.selectedTypeTabIndex == 2) {
        this.callApiWithSearch();
      }
    });
  }

  // API call with searchString and other data

  getVariablePaySummaryEligibleTableData: any;
  gtFixedCTC: any = 0;
  gtEligibleEmpCount: any = 0;
  gtEligibleEmpFixedCTC: any = 0;
  gtOverallVPBonusBudget: any = 0;
  gtVPBonusActualAmount: any = 0;
  gtVarience: any = 0;
  gtVariencePer: any = 0;
  callApiWithSearch() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": this.frequencyPeriod || null, // Include frequency cycle if already selected
      "fromYear": Number(this.fromYear),
      "searchString": this.searchString || null, // Include searchString
      "toYear": Number(this.toYear),
      "isHod": isHod
    };

    this.httpService.callPostService(this.config.variableSummary, payload).subscribe((response: any) => {
      if (response?.data != null) {
        this.variableSummaryData = response.data?.vpSummary;
        this.gtFixedCTC = response.data?.gtFixedCTC;
        this.gtEligibleEmpCount = response.data?.gtEligibleEmpCount;
        this.gtEligibleEmpFixedCTC = response.data?.gtEligibleEmpFixedCTC;
        this.gtOverallVPBonusBudget = response.data?.gtOverallVPBonusBudget;
        this.gtVPBonusActualAmount = response.data?.gtVPBonusActualAmount;
        this.gtVarience = response.data?.gtVarience;
        this.gtVariencePer = response.data?.gtVariencePer;
      }
    });

  }

  getDepartmentCounts(department: any) {
    let eligibleEmployeesCount = 0;
    let totalfixedCTCCount = 0;
    let totalEligibleEmployeeFixedCTC = 0;
    let totalOverallVariablePayBonusBudget = 0;
    let totalVariableBonusAmount = 0;
    let totalVarience = 0;
    let totalVarienceBudget = 0;
    let totalEmployeesCount = 0;
    // Iterate over each band in the department
    if (department.bands && department.bands.length > 0) {
      department.bands.forEach((band: any) => {
        if (band.inputSummary) {
          if (band.inputSummary.totalEmployees) {
            totalEmployeesCount += band.inputSummary.totalEmployees;
          }
          if (band.inputSummary.eligibleEmployees) {
            eligibleEmployeesCount += band.inputSummary.eligibleEmployees;
          }
          if (band.inputSummary.totalFixedCTC) {
            totalfixedCTCCount += band.inputSummary.totalFixedCTC;
          }
          if (band.inputSummary.eligibleEmployeesFixedCTC) {
            totalEligibleEmployeeFixedCTC += band.inputSummary.eligibleEmployeesFixedCTC;
          }
          if (band.inputSummary.overallVariablePayBonusBudget) {
            totalOverallVariablePayBonusBudget += band.inputSummary.overallVariablePayBonusBudget;
          }
          if (band.inputSummary.variablePayBonusAmount) {
            totalVariableBonusAmount += band.inputSummary.variablePayBonusAmount;
          }
          if (band.inputSummary.variance) {
            totalVarience += band.inputSummary.variance;
          }
          if (band.inputSummary.variancePercentage) {
            totalVarienceBudget += band.inputSummary.variancePercentage;
          }
        }
      });
    }

    return {
      totalEmployees: totalEmployeesCount,
      eligibleEmployees: eligibleEmployeesCount,
      totalFixedCTC: totalfixedCTCCount,
      eligibleEmployeesFixedCTC: totalEligibleEmployeeFixedCTC,
      overallVariablePayBonusBudget: totalOverallVariablePayBonusBudget,
      variablePayBonusAmount: totalVariableBonusAmount,
      variance: totalVarience,
      variancePercentage: totalVarienceBudget
    };
  }

  getGrandTotal(property: any): any {
    return this.variableSummaryData?.reduce((total: any, department: any) => {
      let value = 0;

      // Sum property at the root level (if present)
      if (department[property] !== undefined && !isNaN(department[property])) {
        value += department[property];
      }

      // Sum property inside bands -> inputSummary (if present)
      if (department.bands && department.bands.length > 0) {
        department.bands.forEach((band: any) => {
          if (band.inputSummary && band.inputSummary[property] !== undefined && !isNaN(band.inputSummary[property])) {
            value += band.inputSummary[property];
          }
        });
      }

      return total + value;
    }, 0);
  }

  departments: any[] = [];

  totalEmployeesOutsideBands: number = 0;
  calculateTotalEmployeesOutsideBands(): void {
    this.totalEmployeesOutsideBands = this.variableSummaryData?.reduce((acc: any, department: { totalEmployees: any; }) => {
      return acc + department.totalEmployees;
    }, 0);
  }

  getFinalData: any;

  getOverallTotal(property: string): number {
    let total = 0;
    this.variableSummaryData.forEach((department: { employeeSummaryData: any[]; }) => {
      department.employeeSummaryData.forEach((employee: any) => {
        total += employee[property];
      });
    });
    return total;
  }

  filterMonthsForSummary(frequency: string) {
    const frequencyMapping: { [key in FrequencyType]?: string[] } = {
      [FrequencyType.Monthly]: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      [FrequencyType.Quarterly]: ["April-June", "July-September", "October-December", "January-March"],
      [FrequencyType.SemiAnnually]: ["April-September", "October-March"],
      [FrequencyType.Annually]: ["April-March"],
    };

    this.filteredFrequenciesSummary = frequencyMapping[frequency as FrequencyType] || [];
  }


  onSearch(event: any) {
    this.searchString = event.target.value;
    if (this.searchString == '') {
      this.searchString = null;
    }
    // Clear the previous timer if the user is still typing
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Set a new timer, e.g., 300ms after the user stops typing
    this.debounceTimer = setTimeout(() => {
      this.callApiWithSearch(); // Call the API after debounce
    }, 300);
  }



  // Handle selection change and send payload
  updateSummaryOptions(event: any) {
    let period = event.value; // Get selected frequency cycle
    if (period === 'Semi-Annually') {
      period = 'Semi_Annually';
    }
    this.frequencyName = period;

    // Call API with updated frequency cycle
    this.callApiWithSearch();
  }

  onClickDownloadvpSummaryExcelFile(id: any) {
    this.loader.simpleLoader()
    this.isShowExcelData = true;
    setTimeout(() => {
      const tableId = id
      const table = document.getElementById(tableId) as HTMLTableElement;
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
      if (!table) {
        alert('Table not found!');
        return;
      }
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `Variable_Pay_Summary_${formattedDate}.xlsx`);
      this.isShowExcelData = false;
      this.loader.dismissLoader()
    }, 1000);
  }

  // Variable Input


  variablePayInputTableHideShowAllData: any[] = [];

  isAnyColumnInvisible: boolean = false;
  allColumnsInvisible: boolean = false;



  getVariablePayInputTableHideShowAllData() {
    this.variablePayInputTableHideShowAllData = [
      {
        "fieldId": 1,
        "isVisible": true,
        "fieldName": "Department",
        "position": 1,
        "isEditable": true
      },
      {
        "fieldId": 2,
        "isVisible": true,
        "fieldName": "Band",
        "position": 2,
        "isEditable": true
      },
      {
        "fieldId": 3,
        "isVisible": true,
        "fieldName": "Employee",
        "position": 3,
        "isEditable": true
      },
      {
        "fieldId": 4,
        "isVisible": true,
        "fieldName": "Manager",
        "position": 4,
        "isEditable": true
      },
      {
        "fieldId": 5,
        "isVisible": true,
        "fieldName": "HOD",
        "position": 5,
        "isEditable": true
      },
      {
        "fieldId": 6,
        "isVisible": true,
        "fieldName": "Designation",
        "position": 6,
        "isEditable": true
      },
      {
        "fieldId": 7,
        "isVisible": true,
        "fieldName": "DOJ",
        "position": 7,
        "isEditable": true
      },
      {
        "fieldId": 8,
        "isVisible": true,
        "fieldName": "Total Fixed CTC p.f.",
        "position": 8,
        "isEditable": true
      },
      {
        "fieldId": 9,
        "isVisible": true,
        "fieldName": "Total Fixed CTC p.a.",
        "position": 9,
        "isEditable": true
      },
      {
        "fieldId": 10,
        "isVisible": true,
        "fieldName": "Eligible Emp.",
        "position": 10,
        "isEditable": true
      },
      {
        "fieldId": 11,
        "isVisible": true,
        "fieldName": "Individual KPI + Competency Score",
        "position": 11,
        "isEditable": true
      },
      {
        "fieldId": 12,
        "isVisible": true,
        "fieldName": "Department Score (out of 100)",
        "position": 12,
        "isEditable": true
      },
      {
        "fieldId": 13,
        "isVisible": true,
        "fieldName": "Company Score (out of 100)",
        "position": 13,
        "isEditable": true
      },
      {
        "fieldId": 14,
        "isVisible": true,
        "fieldName": "Final Score",
        "position": 14,
        "isEditable": true
      },
      {
        "fieldId": 15,
        "isVisible": true,
        "fieldName": "Final Rating",
        "position": 15,
        "isEditable": true
      },
      {
        "fieldId": 16,
        "isVisible": true,
        "fieldName": "Variable bonus category % age of CTC OR fixed budget",
        "position": 16,
        "isEditable": true
      },
      {
        "fieldId": 17,
        "isVisible": true,
        "fieldName": "Fixed budget value if applicable yearly",
        "position": 17,
        "isEditable": true
      },
      {
        "fieldId": 18,
        "isVisible": true,
        "fieldName": "Actual Variable pay Bonus - % / amount (according to rating to %)",
        "position": 18,
        "isEditable": true
      },
      {
        "fieldId": 19,
        "isVisible": true,
        "fieldName": "Days served in the period (Depending on review cycle)",
        "position": 19,
        "isEditable": true
      },
      {
        "fieldId": 20,
        "isVisible": true,
        "fieldName": "Prorated VB% / Amount",
        "position": 20,
        "isEditable": true
      },
      {
        "fieldId": 21,
        "isVisible": true,
        "fieldName": "HOD normalization",
        "position": 21,
        "isEditable": true
      },
      {
        "fieldId": 22,
        "isVisible": true,
        "fieldName": "HR normalization",
        "position": 22,
        "isEditable": true
      },
      {
        "fieldId": 23,
        "isVisible": true,
        "fieldName": "Final VB amount",
        "position": 23,
        "isEditable": true
      }
    ];
  }

  updateVariableInputColumnVisibility(data: any, index: any) {
    this.variablePayInputTableHideShowAllData[index].isVisible = false;
  }

  onSelectVariableInputHideShowCheckBox(event: any) {
    this.isAnyColumnInvisible = this.variablePayInputTableHideShowAllData?.some((ele: any) => !ele.isVisible);
    this.allColumnsInvisible = this.variablePayInputTableHideShowAllData?.every((ele: any) => !ele.isVisible);
  }

  getIncrementInputColumnVisibility(fieldName: string): boolean {
    const column = this.variablePayInputTableHideShowAllData.find(item => item.fieldName.trim() === fieldName.trim());
    return column ? column.isVisible : false;
  }

  updateVariablePayInputColumnVisibility(data: any, index: any) {
    this.variablePayInputTableHideShowAllData[index].isVisible = false;
  }


  variablePeriodFrquency: any[] = [];
  getFiscalYearForVariableInput() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.companyYears = [];
      data?.data?.yearRanges?.forEach((ele: any) => {
        var test = ele.split('_');
        let obj = {
          year: test[0] + '-' + test[1]
        };
        this.companyYears.push(obj);
      });

      const currentYear = new Date().getFullYear();
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
      }

      // Set selected year and calculate the next year
      let selectedYearIndex = this.companyYears.findIndex((ele: any) => ele?.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0; // Default to the first year if current year not found
      }
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      let yearValue1 = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue1 = `${currentYear}-${currentYear}`;
      } else {
        yearValue1 = `${currentYear}-${currentYear + 1}`;
        if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
          if (currentMonth < 3) {
            yearValue1 = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'July_Jun') {
          if (currentMonth < 6) {
            yearValue1 = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
          if (currentMonth < 9) {
            yearValue1 = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
      }
      this.selectedYear = yearValue1;
      var test = this.selectedYear?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];

      const nextYearIndex = (selectedYearIndex + 1) % this.companyYears.length;
      const nextToNextYearIndex = (selectedYearIndex + 2) % this.companyYears.length;

      this.fromVariablePayMonth = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.companyYears[nextYearIndex]?.year);
      this.toVariablePayMonth = this.getToMonthsArray(this.loggedInCompanyFiscalyear, this.companyYears[nextToNextYearIndex]?.year);
      // this.postBandDataFunction();
      // this.getIncrementSetupByYear();
      if (Number(this.fromYear) == currentYear
        || Number(this.toYear) == currentYear) {
        this.isSelectedYearIsSameYeartoCurrentYear = true;
      } else {
        this.isSelectedYearIsSameYeartoCurrentYear = false;
      }
      this.getVPCurrentYearFrequeny();
    });
  }
  getFrequencies() {
    
    this.httpService.callGetService(`${this.config.getPMSSetUpByID}${this.loggedInUserCompanyID}/${this.fromYear}/${this.toYear}`).subscribe((data: any) => {
      this.setupFrequency = data.data['reviewCycle'] ? data.data['reviewCycle'] : data.data['yearRanges'];
      this.getFrequencyForInput();
      this.filterFrequencies()
    });
  }
  getFrequencyForInput() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      
      this.variablePeriodFrquency = response.data;
      const currentMonthIndex = new Date().getMonth();
      const today = new Date();
      const month = today.toLocaleString('default', { month: 'long' });
      if (this.setupFrequency == 'Monthly') {
        this.variablePeriodFrquency?.forEach((ele: any) => {
          var checkMonth = ele?.split('-');
          if (month == checkMonth[0]) {
            this.frequencyPeriod = ele;
          }
        });
      }

      if (this.setupFrequency == 'Quarterly' || this.setupFrequency == 'Semi_Annually' || this.setupFrequency == 'Semi-Annually'
        || this.setupFrequency == 'Annually'
      ) {
        for (let range of this.variablePeriodFrquency) {
          const [start, end] = range?.split('-');
          const startMonthIndex = this.getMonthIndex(start);
          const endMonthIndex = this.getMonthIndex(end);
          if (
            (currentMonthIndex >= startMonthIndex && currentMonthIndex <= endMonthIndex) ||
            (startMonthIndex > endMonthIndex && (currentMonthIndex >= startMonthIndex || currentMonthIndex <= endMonthIndex))
          ) {
            this.frequencyPeriod = range;
          }
        }
      }
      this.getData();
      if (this.selectedTypeTabIndex == 2) {
        this.callApiWithSearch();
      }
      if (this.selectedTypeTabIndex == 1) {
        if (this.activeVariablePayInputTab === true) {
          this.getVariablePayInput();;
        } else if (this.activeVariablePayInputTab === false) {
          this.getVariableInputNonEligible();
        }
      }
      // this.filterMonthsForInput(this.setupFrequency);
    });
  }

  callApiWithSearchInput() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": this.frequencyName || null, // Include frequency cycle if already selected
      "fromYear": Number(this.fromYear),
      "searchString": this.searchString || null, // Include searchString
      "toYear": Number(this.toYear),
      "isHod": isHod
    };

    this.httpService.callPostService(this.config.variableInput, payload).subscribe((response: any) => {
      this.variableInput = response?.data?.vpInputs;
    });
  }

  filteredFrequenciesInput: any[] = [];
  variableInputData: any = [];

  onSearchInput(event: any) {
    this.searchString = event.target.value;
    if (this.searchString == '') {
      this.searchString = null;
    }
    // Clear the previous timer if the user is still typing
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Set a new timer, e.g., 300ms after the user stops typing
    this.debounceTimer = setTimeout(() => {
      if (this.activeVariablePayInputTab) {
        this.getVariablePayInput(); // Call the API after debounce
      } else {
        this.getVariableInputNonEligible();
      }
    }, 300);
  }



  // Handle selection change and send payload
  updateInputOptions(event: any) {
    let period = event.value; // Get selected frequency cycle

    if (period === 'Semi-Annually') {
      period = 'Semi_Annually';
    }
    this.frequencyName = period;

    // Call API with updated frequency cycle

    if (this.selectedTypeTabIndex == 0) {
      this.getDashboradDeptData();
      // this.getDashBoardBudgetVsActual();
    }
    // this.callApiWithSearchInput();
    this.getData();
  }

  getDepartmentData: any = [];

  filterEmployees(departmentList: any[], isEligible: boolean): any[] {
    return departmentList?.map(department => {
      return {
        ...department,
        bandGrades: department.bandGrades?.map((bandGrade: any) => {
          return {
            ...bandGrade,
            employeeData: bandGrade.employeeData.filter((employee: any) => employee.isEligible === isEligible)
          };
        })
      };
    });
  }

  rating: any;
  isHODDisabledHRnormalization: any;
  isHRAdminDisabledHODnormalization: any;
  getVariablePayInput() {
    
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const categoryName: string[] = this.vpCategory?.map((category: any) => category.name);
    const ratingName: string[] = this.selectedRating?.map((rating: any) => rating.name)
    const request = {
      "band": this.selectedBand?.map((ele: any) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "department": this.selectedDepartment?.map((ele: any) => ele.id),
      "employeeName": this.selectedEmployee?.map((ele: any) => ele.name),
      "frequencyCycle": this.frequencyPeriod || null,
      "fromYear": this.fromYear,
      "managerName": this.selectedManager?.map((ele: any) => ele.name),
      "searchString": this.searchString,
      "toYear": this.toYear,
      "isEligible": true,
      "rating": ratingName ? ratingName : null,
      "vpCategory": categoryName ? categoryName : this.vpCategory,
      "isHod": isHod
    };
    const request1 = {
      "band": this.selectedBand?.map((ele: any) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "department": this.selectedDepartment?.map((ele: any) => ele.id),
      "employeeName": this.selectedEmployee?.map((ele: any) => ele.id),
      "frequencyCycle": this.frequencyPeriod || null,
      "fromYear": this.fromYear,
      "managerName": this.selectedManager?.map((ele: any) => ele.id),
      "searchString": this.searchString,
      "toYear": this.toYear,
      "isEligible": true,
      "rating": ratingName ? ratingName : [],
      "vpCategory": categoryName ? categoryName : this.vpCategory,
      "isHod": isHod
    };
    sessionStorage.setItem('vpInputPayload',JSON.stringify(request1))
    this.httpService.callPostService(this.config.variableInput, request).subscribe((result: any) => {
      if (result.data != null) {
        this.getIncrementInputEligibleTableData = result.data?.vpInputs;
        this.totalNonEligibleCount = result.data?.nonEligibleEmpCount;
        this.totalEligibleCount = result.data?.eligibleEmpCount;
        this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
      } else {
        this.getIncrementInputEligibleTableData = []
        this.totalNonEligibleCount = 0;
        this.totalEligibleCount = 0;
      }
      // this.totalEligibleCount = this.getIncrementInputEligibleTableData.reduce((total: number, department: any) => {
      //   return total + department.bands.reduce((bandTotal: number, band: any) => {
      //     return bandTotal + band.employees.length;
      //   }, 0);
      // }, 0);
    });

    if (this.loggedInUserRole == 'HOD') {
      this.isHODDisabledHRnormalization = false;
      this.isHRAdminDisabledHODnormalization = true;
    } else {
      this.isHODDisabledHRnormalization = true;
      this.isHRAdminDisabledHODnormalization = false;
    }
  }

  calculateInputEligibleTotals(data: any[]): void {
    this.totalEligibleTotalFixedCtcPA = 0;
    this.totalEligibleTotalFixedCtcPM = 0;
    this.totalEligibleEligibleEmp = 0;
    this.totalEligibleCompetencyScore = 0;
    this.totalEligibleDeptScore = 0;
    this.totalEligibleCompanyScore = 0;
    this.totalEligibleFinalScore = 0;
    this.totalEligibleFinalRating = 0;
    this.totalEligibleCTCFixedBudget = 0;
    this.totalEligibleFixedBudget = 0;
    this.totalEligibleActualVariablePayBonus = 0;
    this.totalEligibleDaysPeriod = 0;
    this.totalEligibleProtatedVB = 0;
    this.totalEligibleHODNoramlization = 0;
    this.totalEligiblenormalisationHRMDCEO = 0;
    this.totalEligibleVBAmount = 0;

    let PectEligibleDaysPeriod = 0
    let totalEligibleProtatedVBAmount = 0
    
    data.forEach(department => {
      department.bands.forEach((bands: any) => {
        bands.employees.forEach((employee: any) => {
          this.totalEligibleTotalFixedCtcPA += parseFloat(employee.totalFixedCTCpa || 0);
          this.totalEligibleTotalFixedCtcPM += parseFloat(employee.totalFixedCTCpm || 0);
          this.totalEligibleCompetencyScore += parseFloat(employee.individualKPICompetencyScore || 0);
          this.totalEligibleDeptScore += parseFloat(employee.departmentScore || 0);
          this.totalEligibleCompanyScore += parseFloat(employee.companyScore || 0);
          this.totalEligibleFinalRating += parseFloat(employee.finalRating || 0);
          this.totalEligibleFinalScore += parseFloat(employee.finalScore || 0);
          this.totalEligibleCTCFixedBudget += parseFloat(employee.vpBonusCategoryOfCTC_OR_FixedBudget || 0);
          this.totalEligibleFixedBudget += parseFloat(employee.fixedBudgetValue || 0);
          this.totalEligibleActualVariablePayBonus += parseFloat(employee.actualVPBonusPercentAmount || 0);
          // this.totalEligibleDaysPeriod += parseFloat(employee.daysServed || 0);
          if (employee.daysServed !== null && employee.daysServed !== undefined) {
            this.totalEligibleDaysPeriod += parseFloat(employee.daysServed);
            PectEligibleDaysPeriod++;
          }
          if (employee.proratedVPPercentAmount !== null && employee.proratedVPPercentAmount !== undefined) {
            this.totalEligibleProtatedVB += parseFloat(employee.proratedVPPercentAmount);
            totalEligibleProtatedVBAmount++;
          }
          this.totalEligibleVBAmount += parseFloat(employee.finalVPAmount || 0);
        });
      });
    });
    if (PectEligibleDaysPeriod > 0) {
      this.totalEligibleDaysPeriod = parseFloat((this.totalEligibleDaysPeriod / PectEligibleDaysPeriod).toFixed(4));
    }
    if (totalEligibleProtatedVBAmount > 0) {
      this.totalEligibleProtatedVB = parseFloat((this.totalEligibleProtatedVB / totalEligibleProtatedVBAmount).toFixed(4));
    }
  }

  getVariableInputNonEligible() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const categoryName: string[] = this.vpCategory?.map((category: any) => category.name);
    const ratingName: string[] = this.selectedRating?.map((rating: any) => rating.name)
    const request = {
      "band": this.selectedBand?.map((ele: any) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "department": this.selectedDepartment?.map((ele: any) => ele.id),
      "employeeName": this.selectedEmployee?.map((ele: any) => ele.name),
      "frequencyCycle": this.frequencyPeriod || null,
      "fromYear": this.fromYear,
      "managerName": this.selectedManager?.map((ele: any) => ele.name),
      "searchString": this.searchString,
      "toYear": this.toYear,
      "isEligible": false,
      "rating": ratingName ? ratingName : null,
      "vpCategory": categoryName ? categoryName : this.vpCategory,
      "isHod": isHod
    };

    this.httpService.callPostService(this.config.variableInput, request).subscribe((result: any) => {
      if (result.data != null) {
        this.getIncrementInputNonEligibleTableData = result.data?.vpInputs;
        this.totalNonEligibleCount = result.data?.nonEligibleEmpCount;
        this.totalEligibleCount = result.data?.eligibleEmpCount;
        this.calculateInputEligibleTotals(this.getIncrementInputNonEligibleTableData);
      } else {
        this.getIncrementInputNonEligibleTableData = []
        this.totalNonEligibleCount = 0;
        this.totalEligibleCount = 0;
      }
      // this.totalNonEligibleCount = this.getIncrementInputNonEligibleTableData.reduce((total: number, department: any) => {
      //   return total + department.bands.reduce((bandTotal: number, band: any) => {
      //     return bandTotal + band.employees.length;
      //   }, 0);
      // }, 0);
    });

    if (this.loggedInUserRole == 'HOD') {
      this.isHODDisabledHRnormalization = false;
      this.isHRAdminDisabledHODnormalization = true;
    } else {
      this.isHODDisabledHRnormalization = true;
      this.isHRAdminDisabledHODnormalization = false;
    }
  }

  calculateInputNonEligibleTotals(data: any[]): void {
    // this.totalEligibleTotalFixedCtcPA = 0;
    // this.totalEligibleEligibleEmp = 0;
    // this.totalEligibleCompetencyScore = 0;
    // this.totalEligibleDeptScore = 0;
    // this.totalEligibleCompanyScore = 0;
    // this.totalEligibleFinalScore = 0;
    // this.totalEligibleFinalRating = 0;
    // this.totalEligibleCTCFixedBudget = 0;
    // this.totalEligibleFixedBudget = 0;
    // this.totalEligibleActualVariablePayBonus = 0;
    // this.totalEligibleDaysPeriod = 0;
    // this.totalEligibleProtatedVB = 0;
    // this.totalEligibleHODNoramlization = 0;
    // this.totalEligiblenormalisationHRMDCEO = 0;
    // this.totalEligibleVBAmount = 0;
    // data.forEach(department => {
    //   department.bands.forEach((bands: any) => {
    //     bands.employees.forEach((employee: any) => {
    //       this.totalEligibleTotalFixedCtcPA += parseFloat(employee.totalFixedCTCpa || 0);
    //       this.totalEligibleEligibleEmp += parseFloat(employee.isEligible || 0);
    //       this.totalEligibleCompetencyScore += parseFloat(employee.individualKPICompetencyScore || 0);
    //       this.totalEligibleDeptScore += parseFloat(employee.departmentScore || 0);
    //       this.totalEligibleCompanyScore += parseFloat(employee.companyScore || 0);
    //       this.totalEligibleFinalRating += parseFloat(employee.finalRating || 0);
    //       this.totalEligibleFinalScore += parseFloat(employee.finalScore || 0);
    //       this.totalEligibleCTCFixedBudget += parseFloat(employee.vpBonusCategoryOfCTC_OR_FixedBudget || 0);
    //       this.totalEligibleFixedBudget += parseFloat(employee.fixedBudgetValue || 0);
    //       this.totalEligibleActualVariablePayBonus += parseFloat(employee.actualVPBonusPercentAmount || 0);
    //       this.totalEligibleDaysPeriod += parseFloat(employee.daysServed || 0);
    //       this.totalEligibleVBAmount += parseFloat(employee.finalVPAmount || 0);
    //     });
    //   });
    // });
  }

  getTotalRowSpan(bands: any[]): number {
    let totalRows = 0;
    bands.forEach(band => {
      if (band && Array.isArray(band.employees)) {
        totalRows += band.employees.length;
      }
    });
    return totalRows;
  }

  isShowExcelData: any = false;

  // onClickDownloadvpInputExcelFile() {
  //   this.loader.simpleLoader()
  //   this.isShowExcelData = true;
  //   setTimeout(() => {
  //     const tableId = this.activeVariablePayInputTab ? 'vpInputEligibleTable' : 'vpInputNonEligibleTable';
  //     const table = document.getElementById(tableId) as HTMLTableElement;
  //     const currentDate = new Date();
  //     const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
  //     if (!table) {
  //       alert('Table not found!');
  //       return;
  //     }
  //     const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
  //     const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  //     XLSX.writeFile(wb, `Variable_Pay_Input${formattedDate}.xlsx`);
  //   this.isShowExcelData = false;
  //   this.loader.dismissLoader()
  //   }, 1000);
  // }

  onClickDownloadvpInputExcelFile() {
    const flattenedData: any[] = [];
    this.getIncrementInputEligibleTableData.forEach((department: any) => {
      department.bands.forEach((band: any) => {
        band.employees.forEach((employee: any) => {
          flattenedData.push({
            "Department": department.departmentName,
            "Band": band.bandName,
            "Employee": employee.employeeName,
            "Manager": employee.managerName,
            "HOD": employee.hodName,
            "Designation": employee.designation,
            "DOJ": this.datePipe.transform(employee.employeeDOJ, "dd/MM/yyyy"),
            "Total Fixed CTC p.a": employee.totalFixedCTCpa,
            "Total Fixed CTC p.f. (P.Q)": employee.totalFixedCTCpm,
            "Eligible Emp": employee.isEligible ? "YES" : "NO",
            "Individual KPI + Competency Score": employee.individualKPICompetencyScore,
            "Department Score (out of 100)": employee.departmentScore,
            "Company Score (out of 100)": employee.companyScore,
            "Final Score": employee.finalScore,
            "Final Rating": employee.finalRating,
            "Variable bonus category %age of CTC OR fixed budget": employee.vpBonusCategoryOfCTC_OR_FixedBudget,
            "Fixed budget value if applicable yearly": employee.fixedBudgetValue,
            "Actual Variable pay Bonus - % / amount (according to rating to %)": employee.actualVPBonusPercentAmount,
            "Days served in the period (Depending on review cycle)": employee.daysServed,
            "Prorated VB %age / Amount": employee.proratedVPPercentAmount,
            "HOD normalization": employee.normalisationHhod,
            "HR normalization": employee.normalisationHRMDCEO,
            "Final VB Amount": employee.finalVPAmount,
          });
        });
      });
    });
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
    const fileName = 'Variable_Pay_Input_' + formattedDate + '.xlsx';
    saveAs(data, fileName);

  }

  getDepartmentsList!: any[];
  getData() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    var isEligible = true;
    if (this.selectedTypeTabName == 'Variable Pay Report') {
      isEligible = this.activeVariablePayReportsTab
    } else if (this.selectedTypeTabName == 'Variable Pay Input') {
      isEligible = this.activeVariablePayInputTab
    } else {
      isEligible = true
    }
    const request = {
      "bands": [],
      "companyId": this.loggedInUserCompanyID,
      "department": [],
      "frequencyCycle": this.frequencyPeriod,
      "fromYear": Number(this.fromYear),
      "isEligible": isEligible,
      "toYear": Number(this.toYear),
      "isHod": isHod
    }
    this.httpService.callPostService(this.config.getVPDepartments, request)
      .subscribe((result: any) => {
        this.getDepartmentsList = [];
        result?.data?.forEach((ele: any) => {
          let obj = {
            id: ele,
            name: ele,
          }
          this.getDepartmentsList.push(obj);
        });
        this.getDepartmentsList = this.getDepartmentsList?.sort((a: any, b: any) => a.name.localeCompare(b.name));
        this.deptWiseBudgetVsActualDept = this.getDepartmentsList;
        
        if (this.getDepartmentsList.length != 0) {
          this.selectGenderWiseBudgetVsActualDept = this.getDepartmentsList[0].id;
          // this.selectedDepartment = this.getDepartmentsList;
          this.getVariablePayInput();
          this.getVariableInputBandList
          this.getDashBoardActualAmountWise();
        }
        this.selectedDeptNameForEligbleNonEligible = this.getDepartmentsList;
        this.getDashBoardDeptWise();
        this.getDashBoardEligibleEmployeeWise();
      });
  }

  inputDepartment!: string;
  variableInputDeptData: any;
  selectedDepartment: any = [];
  getBandList: any = [];
  selectedBand: any = [];
  selectedManager: any = [];
  selectedEmployee: any = [];

  getEmployeeList: any = [];
  getManagerList: any = [];
  deptName: any;


  onSelectDepartment() {
    // Ensure selectedDepartment is an array and has selected items
    if (this.selectedDepartment && this.selectedDepartment.length > 0) {

      this.getBandList = [];
      this.selectedManager = [];
      this.selectedEmployee = [];

      // Proceed with API calls
      this.getVariableInputBandList();
      if (this.activeVariablePayInputTab === true) {
        this.getVariablePayInput();;
      } else if (this.activeVariablePayInputTab === false) {
        this.getVariableInputNonEligible();
      }
    } else {
      this.clearSelections(); // Clear selections if no department is selected
    }
  }

  clearSelections() {
    this.getBandList = [];
    this.selectedDepartment = [];
    this.selectedManager = [];
    this.selectedEmployee = [];
  }

  onDeSelectDepartment() {
    this.getBandList = [];
    this.getEmployeeList = [];
    this.getManagerList = [];
    this.selectedDepartment = [];
    this.selectedManager = [];
    this.selectedEmployee = [];
    this.getVariableInputBandList();
    if (this.activeVariablePayInputTab === true) {
      this.getVariablePayInput();;
    } else if (this.activeVariablePayInputTab === false) {
      this.getVariableInputNonEligible();
    }

  }

  selectAllDepartment(items: any): void {
    this.selectedDepartment = [...this.getDepartmentsList]; // Select all departments
    this.onSelectDepartment();
  }

  onDeSelectAllDepartment() {
    this.selectedDepartment = [];
    this.clearSelections();
    if (this.activeVariablePayInputTab === true) {
      this.getVariablePayInput();;
    } else if (this.activeVariablePayInputTab === false) {
      this.getVariableInputNonEligible();
    }
  }

  getVariableInputBandList() {
    if (this.selectedDepartment && this.selectedDepartment.length > 0) {
      var isEligible = true;
      if (this.selectedTypeTabName == 'Variable Pay Report') {
        isEligible = this.activeVariablePayReportsTab
      } else if (this.selectedTypeTabName == 'Variable Pay Input') {
        isEligible = this.activeVariablePayInputTab
      }
      var year = this.selectedYear.split('-');
      const request: any = {
        "bands": [],
        "companyId": this.loggedInUserCompanyID,
        "department": this.selectedDepartment?.map((dept: any) => dept.name),
        "frequencyCycle": this.frequencyPeriod,
        "fromYear": year[0],
        "isEligible": isEligible,
        "toYear": year[1]
      };

      this.httpService.callPostService(this.config.getBandsVP, request)
        .subscribe((result: any) => {
          if (result.data) {
            this.getBandList = result.data?.map((ele: any) => ({
              id: ele,
              name: ele
            }));
          }
        });
    } else {
    }
  }

  // Band for Variable Input

  onSelectdBand() {
    if (this.selectedBand.length > 0) {
      this.getManagerList = [];
      this.selectedManager = [];
      this.selectedEmployee = [];
      this.getManagerListByBand();
      if (this.activeVariablePayInputTab === true) {
        this.getVariablePayInput();;
      } else if (this.activeVariablePayInputTab === false) {
        this.getVariableInputNonEligible();
      }
    }
  }

  onDeSelectdBand() {
    this.getManagerList = [];
    this.getEmployeeList = [];
    this.selectedManager = [];
    this.selectedEmployee = [];
    if (this.activeVariablePayInputTab === true) {
      this.getVariablePayInput();;
    } else if (this.activeVariablePayInputTab === false) {
      this.getVariableInputNonEligible();
    }
  }

  selectAllBand(items: any): void {
    this.selectedBand = items;
    this.selectedManager = [];
    this.selectedEmployee = [];
    this.onSelectdBand()

    if (this.selectedTypeTabIndex == 3) {
      this.onSelectdBand();
    }
  }

  onDeSelectAllBand() {
    this.selectedBand = [];
    this.getManagerList = [];
    this.selectedManager = [];
    this.selectedEmployee = [];
    this.getEmployeeList = [];
    if (this.activeVariablePayInputTab === true) {
      this.getVariablePayInput();;
    } else if (this.activeVariablePayInputTab === false) {
      this.getVariableInputNonEligible();
    }
  }

  // Manager

  getManagerListByBand() {
    var isEligible = true;
    if (this.selectedTypeTabName == 'Variable Pay Report') {
      isEligible = this.activeVariablePayReportsTab
    } else if (this.selectedTypeTabName == 'Variable Pay Input') {
      isEligible = this.activeVariablePayInputTab
    }
    const request: any = {
      bands: this.selectedBand?.map((band: any) => band.name),
      companyId: this.loggedInUserCompanyID,
      department: this.selectedDepartment?.map((dept: any) => dept.name),
      fromYear: this.fromYear,
      toYear: this.toYear,
      isEligible: isEligible,
      frequencyCycle: this.frequencyPeriod
    };
    this.httpService.callPostService(this.config.variableInputGetManager, request).subscribe((result: any) => {
      if (result.data) {
        this.getManagerList = result.data?.map((ele: any) => ({
          name: ele.employeeName,
          id: ele.userId,
        }));
      }
    });
  }

  onSelectdManager() {
    if (this.selectedManager.length > 0) {
      this.getEmployeeList = [];
      this.selectedEmployee = [];
      this.getEmployeeListByManager();
      if (this.activeVariablePayInputTab === true) {
        this.getVariablePayInput();;
      } else if (this.activeVariablePayInputTab === false) {
        this.getVariableInputNonEligible();
      }
    }
    else {
      this.getEmployeeList = [];
      this.selectedEmployee = [];
    }
  }

  onDeSelectdManager() {
    this.getEmployeeList = [];
    this.selectedEmployee = [];
    if (this.activeVariablePayInputTab === true) {
      this.getVariablePayInput();;
    } else if (this.activeVariablePayInputTab === false) {
      this.getVariableInputNonEligible();
    }
  }

  selectAllManager(items: any): void {
    this.selectedManager = items;
    this.selectedEmployee = []
    this.onSelectdManager()

    if (this.selectedTypeTabIndex == 3) {
      this.onSelectdManager()
    }
  }

  onDeSelectAllManager() {
    this.selectedManager = [];
    this.getEmployeeList = [];
    this.selectedEmployee = [];
    if (this.activeVariablePayInputTab === true) {
      this.getVariablePayInput();;
    } else if (this.activeVariablePayInputTab === false) {
      this.getVariableInputNonEligible();
    }
  }

  // Employee

  getEmployeeListByManager() {
    var isEligible = true;
    if (this.selectedTypeTabName == 'Variable Pay Report') {
      isEligible = this.activeVariablePayReportsTab
    } else if (this.selectedTypeTabName == 'Variable Pay Input') {
      isEligible = this.activeVariablePayInputTab
    }
    var year = this.selectedYear.split('-');
    const request: any = {
      "bands": this.selectedBand?.map((band: any) => band.name),
      "companyId": this.loggedInUserCompanyID,
      "department": this.selectedDepartment?.map((dept: any) => dept.name),
      "frequencyCycle": this.frequencyPeriod,
      "fromYear": year[0],
      "isEligible": isEligible,
      "toYear": year[1],
      "userId": this.selectedManager?.map((ele: any) => ele.id),
    };
    this.httpService.callPostService(this.config.variableInputGetEmployee, request).subscribe((result: any) => {
      if (result.data) {
        this.getEmployeeList = result.data?.map((ele: any) => ({
          name: ele.employeeName,
          id: ele.userId
        }));
      }
    });
  }

  onSelectdEmployee() {
    if (this.selectedEmployee.length > 0) {
      if (this.activeVariablePayInputTab === true) {
        this.getVariablePayInput();;
      } else if (this.activeVariablePayInputTab === false) {
        this.getVariableInputNonEligible();
      }
    }
  }

  onDeSelectdEmployee() {
    if (this.activeVariablePayInputTab === true) {
      this.getVariablePayInput();;
    } else if (this.activeVariablePayInputTab === false) {
      this.getVariableInputNonEligible();
    }
  }

  selectAllEmployee(items: any) {
    this.selectedEmployee = items;
    this.onSelectdEmployee()
  }

  onDeSelectAllEmployee() {
    this.selectedEmployee = [];
    this.getIncrementInputEligibleTableData = [];
    this.getIncrementInputNonEligibleTableData = [];
    if (this.activeVariablePayInputTab === true) {
      this.getVariablePayInput();;
    } else if (this.activeVariablePayInputTab === false) {
      this.getVariableInputNonEligible();
    }
  }

  // VP Category

  getVPCategoryList: any;

  getBandListByVPCategory() {

  }

  onSelectedCategory() {
    // Map over the selected categories to extract the names
    const categoryName: string[] = this.vpCategory?.map((category: any) => category.name); // or item_text if using that field

    // Create the request payload with the array of category names (strings)
    const requestPayload: any = {
      categoryName: categoryName
    };

    // Call necessary functions after setting the payload
    this.getVPCategoryList = [];
    if (this.activeVariablePayReportsTab == true) {
      this.getIncrementReportsEligibleData()
    } else {
      this.getIncrementReportsNonEligibleData();
    }

  }

  onDeSelectedCategory() {
    if (this.activeVariablePayReportsTab == true) {
      this.getIncrementReportsEligibleData()
    } else {
      this.getIncrementReportsNonEligibleData();
    }
  }

  selectAllCategory(items: any): void {
    // Ensure vpCategory is assigned with selected items
    this.vpCategory = items;

    // Map over the selected items to extract names (or item_text)
    const categoryName: string[] = this.vpCategory?.map((category: any) => category?.name || category?.item_text || ''); // Ensure null/undefined check

    // Remove any null or empty values from the array
    const filteredCategoryName = categoryName.filter((name: string) => name !== null && name !== '');

    // Create the payload with the array of strings
    const requestPayload: any = {
      categoryName: filteredCategoryName  // Ensure you send filtered valid names
    };

    // Additional logic like calling functions
    this.getVPCategoryList = [];
    this.getVariablePayInput();
  }



  onDeSelectAllCategory() {
    this.selectedBand = [];
    this.getManagerList = [];
    this.selectedManager = [];
    this.selectedEmployee = [];
    this.getEmployeeList = [];
  }

  // Rating

  getRatingData: any = [];
  getBandListByRating() {
    const request = {
      "frequency": this.setupData?.reviewCycle,
      "frequencyCycle": this.frequencyName ? this.frequencyName : null,
      "fromYear": Number(this.fromYear),
      "toYear": Number(this.toYear)
    }
    this.httpService.callGetService(`${this.config.ratingForReports}/${this.loggedInUserCompanyID}/${this.fromYear}/${this.toYear}/${this.frequencyPeriod}`).subscribe((result: any) => {
      this.getRatingData = [];
      result.data?.forEach((ele: any) => {
        let obj = {
          name: ele,
          id: ele,
        };
        this.getRatingData.push(obj);
      });
      // this.getRatingData = result.data;

      // this.getVariablePayInput();
    })
  }

  onSelectdRating() {
    const categoryName: string[] = this.selectedRating?.map((rating: any) => rating.name)
    if (this.activeVariablePayReportsTab == true) {
      this.getIncrementReportsEligibleData()
    } else {
      this.getIncrementReportsNonEligibleData();
    }
  }

  onDeSelectdRating() {
    // this.getManagerList = [];
    // this.getEmployeeList = [];
    // this.selectedManager = "";
    // this.selectedEmployee = "";
    if (this.activeVariablePayReportsTab == true) {
      this.getIncrementReportsEligibleData()
    } else {
      this.getIncrementReportsNonEligibleData();
    }
  }

  selectAllRating(items: any): void {
    this.selectedRating = items;
    if (this.activeVariablePayReportsTab == true) {
      this.getIncrementReportsEligibleData()
    } else {
      this.getIncrementReportsNonEligibleData();
    }
  }

  onDeSelectAllRating() {
    this.selectedRating = []
    if (this.activeVariablePayReportsTab == true) {
      this.getIncrementReportsEligibleData()
    } else {
      this.getIncrementReportsNonEligibleData();
    }
  }

  // Reports SHow and Hide Data

  variablePayReportsTableHideShowAllData: any[] = [];

  getVariablePayReportsTableHideShowAllData() {
    this.variablePayReportsTableHideShowAllData = [
      {
        "fieldId": 1,
        "isVisible": true,
        "fieldName": "Department",
        "position": 1,
        "isEditable": true
      },
      {
        "fieldId": 2,
        "isVisible": true,
        "fieldName": "Band",
        "position": 2,
        "isEditable": true
      },
      {
        "fieldId": 3,
        "isVisible": true,
        "fieldName": "Employee",
        "position": 3,
        "isEditable": true
      },
      {
        "fieldId": 4,
        "isVisible": true,
        "fieldName": "Manager",
        "position": 4,
        "isEditable": true
      },
      {
        "fieldId": 5,
        "isVisible": true,
        "fieldName": "HOD",
        "position": 5,
        "isEditable": true
      },
      {
        "fieldId": 6,
        "isVisible": true,
        "fieldName": "Designation",
        "position": 6,
        "isEditable": true
      },
      {
        "fieldId": 7,
        "isVisible": true,
        "fieldName": "DOJ",
        "position": 7,
        "isEditable": true
      },
      {
        "fieldId": 8,
        "isVisible": true,
        "fieldName": "Total Fixed CTC p.f.",
        "position": 8,
        "isEditable": true
      },
      {
        "fieldId": 9,
        "isVisible": true,
        "fieldName": "Total Fixed CTC p.a.",
        "position": 9,
        "isEditable": true
      },
      {
        "fieldId": 10,
        "isVisible": true,
        "fieldName": "Eligible Emp.",
        "position": 10,
        "isEditable": true
      },
      {
        "fieldId": 11,
        "isVisible": true,
        "fieldName": "Individual KPI + Competency Score",
        "position": 11,
        "isEditable": true
      },
      {
        "fieldId": 12,
        "isVisible": true,
        "fieldName": "Department Score (out of 100)",
        "position": 12,
        "isEditable": true
      },
      {
        "fieldId": 13,
        "isVisible": true,
        "fieldName": "Company Score (out of 100)",
        "position": 13,
        "isEditable": true
      },
      {
        "fieldId": 14,
        "isVisible": true,
        "fieldName": "Final Score",
        "position": 14,
        "isEditable": true
      },
      {
        "fieldId": 15,
        "isVisible": true,
        "fieldName": "Final Rating",
        "position": 15,
        "isEditable": true
      },
      {
        "fieldId": 16,
        "isVisible": true,
        "fieldName": "Variable bonus category % age of CTC OR fixed budget",
        "position": 16,
        "isEditable": true
      },
      {
        "fieldId": 17,
        "isVisible": true,
        "fieldName": "Fixed budget value if applicable yearly",
        "position": 17,
        "isEditable": true
      },
      {
        "fieldId": 18,
        "isVisible": true,
        "fieldName": "Actual Variable pay Bonus - % / amount (according to rating to %)",
        "position": 18,
        "isEditable": true
      },
      {
        "fieldId": 19,
        "isVisible": true,
        "fieldName": "Days served in the period (Depending on review cycle)",
        "position": 19,
        "isEditable": true
      },
      {
        "fieldId": 20,
        "isVisible": true,
        "fieldName": "Prorated VB% / Amount",
        "position": 20,
        "isEditable": true
      },
      {
        "fieldId": 21,
        "isVisible": true,
        "fieldName": "HOD normalization",
        "position": 21,
        "isEditable": true
      },
      {
        "fieldId": 22,
        "isVisible": true,
        "fieldName": "HR normalization",
        "position": 22,
        "isEditable": true
      },
      {
        "fieldId": 23,
        "isVisible": true,
        "fieldName": "Final VB amount",
        "position": 23,
        "isEditable": true
      }
    ];
  }

  updateVariableReportsColumnVisibility(data: any, index: any) {
    this.variablePayReportsTableHideShowAllData[index].isVisible = false;
  }

  onSelectVariableReportsHideShowCheckBox(event: any) {
    this.isAnyColumnInvisible = this.variablePayReportsTableHideShowAllData?.some((ele: any) => !ele.isVisible);
    this.allColumnsInvisible = this.variablePayReportsTableHideShowAllData?.every((ele: any) => !ele.isVisible);
  }

  getIncrementReportsColumnVisibility(fieldName: string): boolean {
    const column = this.variablePayReportsTableHideShowAllData.find(item => item.fieldName.trim() === fieldName.trim());
    return column ? column.isVisible : false;
  }

  getIncrementReportsEligibleTableData: any[] = [];
  totalEligibleCountForReports: any;
  getIncrementReportsEligibleData() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const categoryName: string[] = this.vpCategory?.map((category: any) => category.name);
    const ratingName: string[] = this.selectedRating?.map((rating: any) => rating.name)
    const request = {
      "band": this.selectedBand?.map((ele: any) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "department": this.selectedDepartment?.map((ele: any) => ele.id),
      "employeeName": this.selectedEmployee?.map((ele: any) => ele.name),
      "frequencyCycle": this.frequencyPeriod || null,
      "fromYear": this.fromYear,
      "managerName": this.selectedManager?.map((ele: any) => ele.name),
      "searchString": this.searchString,
      "toYear": this.toYear,
      "isEligible": true,
      "rating": ratingName ? ratingName : null,
      "vpCategory": categoryName ? categoryName : this.vpCategory,
      "isHod": isHod
    };

    this.httpService.callPostService(this.config.variableInput, request).subscribe((result: any) => {
      if (result.data != null) {
        this.getIncrementInputEligibleTableData = result.data?.vpInputs;
        this.totalNonEligibleCount = result.data?.nonEligibleEmpCount;
        this.totalEligibleCount = result.data?.eligibleEmpCount;
        this.calculateInputEligibleTotals(this.getIncrementInputEligibleTableData);
      } else {
        this.getIncrementInputEligibleTableData = []
        this.totalNonEligibleCount = 0;
        this.totalEligibleCount = 0;
      }
      this.totalEligibleCountForReports = this.getIncrementInputEligibleTableData.reduce((total: number, department: any) => {
        return total + department.bands.reduce((bandTotal: number, band: any) => {
          return bandTotal + band.employees.length;
        }, 0);
      }, 0);
    });
  }

  calculateReportsEligibleTotals(data: any[]): void {
    // this.totalEligibleTotalFixedCtcPA = 0;
    // this.totalEligibleEligibleEmp = 0;
    // this.totalEligibleCompetencyScore = 0;
    // this.totalEligibleDeptScore = 0;
    // this.totalEligibleCompanyScore = 0;
    // this.totalEligibleFinalScore = 0;
    // this.totalEligibleFinalRating = 0;
    // this.totalEligibleCTCFixedBudget = 0;
    // this.totalEligibleFixedBudget = 0;
    // this.totalEligibleActualVariablePayBonus = 0;
    // this.totalEligibleDaysPeriod = 0;
    // this.totalEligibleProtatedVB = 0;
    // this.totalEligibleHODNoramlization = 0;
    // this.totalEligiblenormalisationHRMDCEO = 0;
    // this.totalEligibleVBAmount = 0;
    // data.forEach(department => {
    //   department.bands.forEach((bands: any) => {
    //     bands.employees.forEach((employee: any) => {
    //       this.totalEligibleTotalFixedCtcPA += parseFloat(employee.totalFixedCTCpa || 0);
    //       this.totalEligibleEligibleEmp += parseFloat(employee.isEligible || 0);
    //       this.totalEligibleCompetencyScore += parseFloat(employee.individualKPICompetencyScore || 0);
    //       this.totalEligibleDeptScore += parseFloat(employee.departmentScore || 0);
    //       this.totalEligibleCompanyScore += parseFloat(employee.companyScore || 0);
    //       this.totalEligibleFinalRating += parseFloat(employee.finalRating || 0);
    //       this.totalEligibleFinalScore += parseFloat(employee.finalScore || 0);
    //       this.totalEligibleCTCFixedBudget += parseFloat(employee.vpBonusCategoryOfCTC_OR_FixedBudget || 0);
    //       this.totalEligibleFixedBudget += parseFloat(employee.fixedBudgetValue || 0);
    //       this.totalEligibleActualVariablePayBonus += parseFloat(employee.actualVPBonusPercentAmount || 0);
    //       this.totalEligibleDaysPeriod += parseFloat(employee.daysServed || 0);
    //       this.totalEligibleVBAmount += parseFloat(employee.finalVPAmount || 0);
    //     });
    //   });
    // });
  }

  getIncrementReportsNonEligibleTableData: any[] = [];
  totalNonEligibleCountForReports: any;

  getIncrementReportsNonEligibleData() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const categoryName: string[] = this.vpCategory?.map((category: any) => category.name);
    const ratingName: string[] = this.selectedRating?.map((rating: any) => rating.name)
    const request = {
      "band": this.selectedBand?.map((ele: any) => ele.id),
      "companyId": this.loggedInUserCompanyID,
      "department": this.selectedDepartment?.map((ele: any) => ele.id),
      "employeeName": this.selectedEmployee?.map((ele: any) => ele.name),
      "frequencyCycle": this.frequencyPeriod || null,
      "fromYear": this.fromYear,
      "managerName": this.selectedManager?.map((ele: any) => ele.name),
      "searchString": this.searchString,
      "toYear": this.toYear,
      "isEligible": false,
      "rating": ratingName ? ratingName : null,
      "vpCategory": categoryName ? categoryName : this.vpCategory,
      "isHod": isHod
    };

    this.httpService.callPostService(this.config.variableInput, request).subscribe((result: any) => {
      if (result.data != null) {
        this.getIncrementInputNonEligibleTableData = result.data?.vpInputs;
        this.totalNonEligibleCount = result.data?.nonEligibleEmpCount;
        this.totalEligibleCount = result.data?.eligibleEmpCount;
        this.calculateInputEligibleTotals(this.getIncrementInputNonEligibleTableData);
      } else {
        this.getIncrementInputNonEligibleTableData = []
        this.totalNonEligibleCount = 0;
        this.totalEligibleCount = 0;
      }
      this.totalNonEligibleCountForReports = this.getIncrementInputEligibleTableData.reduce((total: number, department: any) => {
        return total + department.bands.reduce((bandTotal: number, band: any) => {
          return bandTotal + band.employees.length;
        }, 0);
      }, 0);
    });
  }

  calculateReportsNonEligibleTotals(data: any[]): void {
    // this.totalEligibleTotalFixedCtcPA = 0;
    // this.totalEligibleEligibleEmp = 0;
    // this.totalEligibleCompetencyScore = 0;
    // this.totalEligibleDeptScore = 0;
    // this.totalEligibleCompanyScore = 0;
    // this.totalEligibleFinalScore = 0;
    // this.totalEligibleFinalRating = 0;
    // this.totalEligibleCTCFixedBudget = 0;
    // this.totalEligibleFixedBudget = 0;
    // this.totalEligibleActualVariablePayBonus = 0;
    // this.totalEligibleDaysPeriod = 0;
    // this.totalEligibleProtatedVB = 0;
    // this.totalEligibleHODNoramlization = 0;
    // this.totalEligiblenormalisationHRMDCEO = 0;
    // this.totalEligibleVBAmount = 0;
    // data.forEach(department => {
    //   department.bands.forEach((bands: any) => {
    //     bands.employees.forEach((employee: any) => {
    //       this.totalEligibleTotalFixedCtcPA += parseFloat(employee.totalFixedCTCpa || 0);
    //       this.totalEligibleEligibleEmp += parseFloat(employee.isEligible || 0);
    //       this.totalEligibleCompetencyScore += parseFloat(employee.individualKPICompetencyScore || 0);
    //       this.totalEligibleDeptScore += parseFloat(employee.departmentScore || 0);
    //       this.totalEligibleCompanyScore += parseFloat(employee.companyScore || 0);
    //       this.totalEligibleFinalRating += parseFloat(employee.finalRating || 0);
    //       this.totalEligibleFinalScore += parseFloat(employee.finalScore || 0);
    //       this.totalEligibleCTCFixedBudget += parseFloat(employee.vpBonusCategoryOfCTC_OR_FixedBudget || 0);
    //       this.totalEligibleFixedBudget += parseFloat(employee.fixedBudgetValue || 0);
    //       this.totalEligibleActualVariablePayBonus += parseFloat(employee.actualVPBonusPercentAmount || 0);
    //       this.totalEligibleDaysPeriod += parseFloat(employee.daysServed || 0);
    //       this.totalEligibleVBAmount += parseFloat(employee.finalVPAmount || 0);
    //     });
    //   });
    // });
  }

  onClickDownloadvpReportsExcelFile() {
    // this.loader.simpleLoader()
    // this.isShowExcelData = true;
    // setTimeout(() => {
    //   const tableId = this.activeVariablePayReportsTab ? 'vpReportsEligibleTable' : 'vpReportsNonEligibleTable';
    //   const table = document.getElementById(tableId) as HTMLTableElement;
    //   console.warn(tableId);

    //   const currentDate = new Date();
    //   const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
    //   if (!table) {
    //     alert('Table not found!');
    //     return;
    //   }
    //   const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
    //   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    //   XLSX.writeFile(wb, `Variable_Pay_Reports${formattedDate}.xlsx`);
    //   this.isShowExcelData = false;
    //   this.loader.dismissLoader()
    // }, 1000);

    const flattenedData: any[] = [];
    this.getIncrementInputEligibleTableData.forEach((department: any) => {
      department.bands.forEach((band: any) => {
        band.employees.forEach((employee: any) => {
          flattenedData.push({
            "Department": department.departmentName,
            "Band": band.bandName,
            "Employee": employee.employeeName,
            "Manager": employee.managerName,
            "HOD": employee.hodName,
            "Designation": employee.designation,
            "DOJ": this.datePipe.transform(employee.employeeDOJ, "dd/MM/yyyy"),
            "Total Fixed CTC p.a": employee.totalFixedCTCpa,
            "Total Fixed CTC p.f.": employee.totalFixedCTCpm,
            "Eligible Emp": employee.isEligible ? "YES" : "NO",
            "Individual KPI + Competency Score": employee.individualKPICompetencyScore,
            "Department Score (out of 100)": employee.departmentScore,
            "Company Score (out of 100)": employee.companyScore,
            "Final Score": employee.finalScore,
            "Final Rating": employee.finalRating,
            "Variable bonus category %age of CTC OR fixed budget": employee.vpBonusCategoryOfCTC_OR_FixedBudget,
            "Fixed budget value if applicable yearly": employee.fixedBudgetValue,
            "Actual Variable pay Bonus - % / amount (according to rating to %)": employee.actualVPBonusPercentAmount,
            "Days served in the period (Depending on review cycle)": employee.daysServed,
            "Prorated VB %age / Amount": employee.proratedVPPercentAmount,
            "HOD normalization": employee.normalisationHhod,
            "HR normalization": employee.normalisationHRMDCEO,
            "Final VB Amount": employee.finalVPAmount,
          });
        });
      });
    });
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(flattenedData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data'],
    };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').join('-');
    const fileName = 'Variable_Pay_Report_' + formattedDate + '.xlsx';
    saveAs(data, fileName);
  }
  // Reports Section


  getFiscalYearForVariableReports() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.companyYears = [];
      data?.data?.yearRanges?.forEach((ele: any) => {
        var test = ele.split('_');
        let obj = {
          year: test[0] + '-' + test[1]
        };
        this.companyYears.push(obj);
      });

      const currentYear = new Date().getFullYear();
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
      }

      // Set selected year and calculate the next year
      let selectedYearIndex = this.companyYears.findIndex((ele: any) => ele?.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0; // Default to the first year if current year not found
      }
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      let yearValue1 = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue1 = `${currentYear}-${currentYear}`;
      } else {
        yearValue1 = `${currentYear}-${currentYear + 1}`;
        if (this.loggedInCompanyFiscalyear === 'Apr_Mar') {
          if (currentMonth < 3) {
            yearValue1 = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'July_Jun') {
          if (currentMonth < 6) {
            yearValue1 = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
        if (this.loggedInCompanyFiscalyear === 'Oct_Sep') {
          if (currentMonth < 9) {
            yearValue1 = `${currentYear - 1}-${currentYear}`;
          } else {
            yearValue1 = `${currentYear}-${currentYear + 1}`;
          }
        }
      }
      this.selectedYear = yearValue1;
      var test = this.selectedYear?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];

      const nextYearIndex = (selectedYearIndex + 1) % this.companyYears.length;
      const nextToNextYearIndex = (selectedYearIndex + 2) % this.companyYears.length;

      this.fromVariablePayMonth = this.getFormMonthsArray(this.loggedInCompanyFiscalyear, this.companyYears[nextYearIndex]?.year);
      this.toVariablePayMonth = this.getToMonthsArray(this.loggedInCompanyFiscalyear, this.companyYears[nextToNextYearIndex]?.year);
      // this.postBandDataFunction();
      // this.getIncrementSetupByYear();
      if (Number(this.fromYear) == currentYear
        || Number(this.toYear) == currentYear) {
        this.isSelectedYearIsSameYeartoCurrentYear = true;
      } else {
        this.isSelectedYearIsSameYeartoCurrentYear = false;
      }
      this.getFrequencyForReports();
    });
  }

  setupFrequencyForReports: any;

  getFrequencyForReports() {
    this.httpService.callGetService(`${this.config.variableFrequency}/${this.fromYear}/${this.toYear}/${this.loggedInUserCompanyID}`).subscribe((response: any) => {
      
      this.setupFrequencyForReports = response.data;
      if (response.data == null) {
        this.frequencyPeriod = null;
      } else {
        this.frequencyPeriod = response.data[0];
      }
      this.getIncrementInputEligibleTableData = [];
      this.getIncrementInputNonEligibleTableData = []
      if (this.activeVariablePayInputTab === true) {
        this.getVariablePayInput();
      } else if (this.activeVariablePayInputTab === false) {
        this.getVariableInputNonEligible();
      }
      this.getBandListByRating();
      // this.filterMonthsForReports(this.setupFrequencyForReports);
    });
  }

  variableReport: any;
  callApiWithSearchReports() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": this.frequencyName || null, // Include frequency cycle if already selected
      "fromYear": Number(this.fromYear),
      "searchString": this.searchString || null, // Include searchString
      "toYear": Number(this.toYear),
      "isHod": isHod
    };

    this.httpService.callPostService(this.config.variableInput, payload).subscribe((response: any) => {
      this.variableReport = response?.data?.vpInputs;
    });
  }

  filteredFrequenciesReports: any;

  filterMonthsForReports(frequency: string) {
    const frequencyMapping: { [key in FrequencyType]?: string[] } = {
      [FrequencyType.Monthly]: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      [FrequencyType.Quarterly]: ["April-June", "July-September", "October-December", "January-March"],
      [FrequencyType.SemiAnnually]: ["April-September", "October-March"],
      [FrequencyType.Annually]: ["April-March"],
    };

    this.filteredFrequenciesReports = frequencyMapping[frequency as FrequencyType] || [];
  }

  updateReportOptions(event: any) {
    
    let period = event.value; // Get selected frequency cycle
    if (period === 'Semi-Annually') {
      period = 'Semi_Annually';
    }
    this.frequencyName = period;
    // Call API with updated frequency cycle
    this.getBandListByRating();
    // this.callApiWithSearchReport();
    // this.getFrequency();
    this.getData();
  }

  callApiWithSearchReport() {
    var isHod = false
    if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
      isHod = true
    }
    const payload = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": this.frequencyName || null, // Include frequency cycle if already selected
      "fromYear": Number(this.fromYear),
      "searchString": this.searchString || null, // Include searchString
      "toYear": Number(this.toYear),
      "isHod": isHod
    };

    this.httpService.callPostService(this.config.variableInput, payload).subscribe((response: any) => {
      this.variableReport = response?.data?.vpInputs;
    });
  }

  employeeID: any;

  onEditIncrementInputTableData(employee: any, id: any) {
    const payload = {
      "isEligible": employee.isEligible,
      "normalisationHOD": employee.normalisationHhod,
      "normalisationHRMDCEO": employee.normalisationHRMDCEO
    };
    this.httpService.callPutService(`${this.config.variablePayInputUpdate}/${id}`, payload).subscribe((data: any) => {
      if (this.activeVariablePayInputTab === true) {
        this.getVariablePayInput();;
      } else if (this.activeVariablePayInputTab === false) {
        this.getVariableInputNonEligible();
      }
    })
  }

  getFormMonthsArray(fiscalYear: string, selectedYear: string): string[] {
    const allMonths = ["April", "May", "June", "July", "August", "September", "October", "November", "December", "January", "February", "March"];
    const [startYear, endYear] = selectedYear.split('-');

    let formattedMonths = allMonths?.map((month, index) => {
      let year = (index < 9) ? startYear : endYear;
      return `${this.sharedService.transform(month)} ${year.slice(-2)}`;
    });

    return formattedMonths;
  }

  getToMonthsArray(fiscalYear: string, selectedYear: string): string[] {
    const allMonths = ["April", "May", "June", "July", "August", "September", "October", "November", "December", "January", "February", "March"];
    const [startYear, endYear] = selectedYear.split('-');

    let formattedMonths = allMonths?.map((month, index) => {
      let year = (index < 9) ? startYear : endYear;
      return `${this.sharedService.transform(month)} ${year.slice(-2)}`;
    });

    return formattedMonths;
  }

  filteredFrequenciesVariable: any;

  filterFrequencyVariable() {
    switch (this.variableFrequency) {
      case 'Monthly':
        this.filteredFrequenciesVariable = ["Monthly", "Quarterly", "Semi-Annually", "Annually"];
        break;
      case 'Quarterly':
        this.filteredFrequenciesVariable = ["Quarterly", "Semi-Annually", "Annually"];
        break;
      case 'Semi_Annually':
        this.filteredFrequenciesVariable = ["Semi-Annually", "Annually"];
        break;
      case 'Annually':
        this.filteredFrequenciesVariable = ["Annually"];
        break;
      default:
        this.filteredFrequenciesVariable = this.frequencies;
    }
  }

  filterFrequencies() {
    // Call the get months API from Here and store the result into the setupFrequency
    
    switch (this.setupFrequency) {
      case 'Monthly':
        this.filteredFrequencies = ["Monthly", "Quarterly", "Semi-Annually", "Annually"];
        break;
      case 'Quarterly':
        this.filteredFrequencies = ["Quarterly", "Semi-Annually", "Annually"];
        break;
      case 'Semi_Annually':
        this.filteredFrequencies = ["Semi-Annually", "Annually"];
        break;
      case 'Annually':
        this.filteredFrequencies = ["Annually"];
        break;
      default:
        this.filteredFrequencies = this.frequencies;
    }

    this.updatePeriodOptions(this.setupFrequency);
    // Return an observable of filtered frequencies
    // this.updatePeriodOptions(this.setupFrequency)
    return of(this.filteredFrequencies);
  }

  updatePeriodOptions(event: any): void {
    let period = this.setupFrequency;
    if (period === 'Semi-Annually') {
      period = 'Semi_Annually';
    }
    this.frequencyName = this.setupFrequency;
    this.httpService.callGetService(
      `${this.config.getVariablePayMonths}/${this.loggedInUserCompanyID}/${period}`
    ).subscribe((response: any) => {
      
      this.setupMonths = response.data['months'];
      const currentMonthIndex = new Date().getMonth();
      const today = new Date();
      const month = today.toLocaleString('default', { month: 'long' });
      if (this.frequencyName == 'Monthly') {
        this.setupMonths.forEach((ele: any) => {
          var checkMonth = ele?.split('-');
          if (month == checkMonth[0]) {
            this.frequencyPeriod = ele;
          }
        });
      }

      if (this.frequencyName == 'Quarterly' || this.frequencyName == 'Semi_Annually' || this.frequencyName == 'Semi-Annually'
        || this.frequencyName == 'Annually'
      ) {
        for (let range of this.setupMonths) {
          const [start, end] = range?.split('-');
          const startMonthIndex = this.getMonthIndex(start);
          const endMonthIndex = this.getMonthIndex(end);
          if (
            (currentMonthIndex >= startMonthIndex && currentMonthIndex <= endMonthIndex) ||
            (startMonthIndex > endMonthIndex && (currentMonthIndex >= startMonthIndex || currentMonthIndex <= endMonthIndex))
          ) {
            this.frequencyPeriod = range;
          }
        }
      }

      this.onPeriodChange(this.setupMonths);
      this.getVariablePaySetup();
    });

  }
  getMonthIndex(monthName: string): number {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months.findIndex(month => month.toLowerCase() === monthName.toLowerCase());
  }

  onPeriodChange(event: any) {
    
    const selectedPeriod = this.frequencyPeriod;
    // Ensure event and value are not undefined

    // Check if selectedPeriod is valid (not undefined or null)
    if (!selectedPeriod) {
      this.selectedMonths = [];
      // this.frequencyPeriod = null;
      this.cutOffDate = null;
      this.cutOffDateForVariablepay = 'Invalid day';
      console.error('Selected period is undefined or null:', selectedPeriod);
      return; // Return an empty observable or handle the error case here
    }

    // If the period is multi-month (e.g., "January-March")
    if (this.frequencyName === 'Quarterly') {
      if (selectedPeriod.includes('-')) {
        this.selectedMonths = this.getMonthsBetween(selectedPeriod);  // Get the months between the period
        if (this.selectedMonths.length > 0) {
          // Calculate the next 3 months after the selected period
          const nextThreeMonths = this.getNextThreeMonths(this.selectedMonths[this.selectedMonths.length - 1]);

          // Set the From and To months to the next three months
          this.fromMonth = nextThreeMonths[0];
          this.toMonth = nextThreeMonths[nextThreeMonths.length - 1];
          this.getMonthsToVariablePay = nextThreeMonths;
        }
      }
    }
    else if (this.frequencyName === 'Monthly') {

      const monthResult = this.getNextMonth(selectedPeriod);
      this.selectedMonth = monthResult.next;  // This will give you the next month
      this.selectedMonths = [selectedPeriod];

      // Get the next 12 months starting from the month after the selected month
      this.getMonthsToVariablePay = [this.selectedMonth];

      this.fromMonth = this.getMonthsToVariablePay[0];
      this.toMonth = this.getMonthsToVariablePay[0];

    }
    else if (this.frequencyName === 'Semi-Annually') {
      if (selectedPeriod.includes('-')) {
        this.selectedMonths = this.getMonthsBetween(selectedPeriod);
        if (this.selectedMonths.length > 0) {
          const nextSixMonths = this.getNextSixMonths(this.selectedMonths[this.selectedMonths.length - 1]);

          // Set From and To months for the next six months
          this.fromMonth = nextSixMonths[0];
          this.toMonth = nextSixMonths[nextSixMonths.length - 1];
          this.getMonthsToVariablePay = nextSixMonths;
        }
      }
    }
    else if (this.frequencyName === 'Annually') {
      if (selectedPeriod.includes('-')) {
        this.selectedMonths = this.getMonthsBetween(selectedPeriod);  // Get the months between the period
        if (this.selectedMonths.length > 0) {
          // Calculate the next 3 months after the selected period
          const nextSixMonths = this.getAnnuallyMonths(this.selectedMonths[this.selectedMonths.length - 1]);

          // Set the From and To months to the next three months
          this.fromMonth = nextSixMonths[0];
          this.toMonth = nextSixMonths[nextSixMonths.length - 1];
          this.getMonthsToVariablePay = nextSixMonths;
        }
      }
    }
    this.onFromMonthChange();
    this.getVariablePaySetup();
    // this.getPreviousYearSetups();

    // Wrap the result in an observable
    return of(this.getMonthsToVariablePay);
  }

  // Helper function to get the next three months after the last month in the selected period
  getNextThreeMonths(lastMonth: string): string[] {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Find the index of the last month in the selected period
    const lastMonthIndex = allMonths.indexOf(lastMonth);
    if (lastMonthIndex === -1) {
      console.error('Invalid last month:', lastMonth);
      return [];
    }

    // Get the next three months after the last month
    const nextMonths = [];
    for (let i = 1; i <= 3; i++) {
      nextMonths.push(allMonths[(lastMonthIndex + i) % 12]);  // Handle wrap-around using modulo
    }

    return nextMonths;
  }

  getNextSixMonths(lastMonth: string): string[] {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Find the index of the last month in the selected period
    const lastMonthIndex = allMonths.indexOf(lastMonth);
    if (lastMonthIndex === -1) {
      console.error('Invalid last month:', lastMonth);
      return [];
    }

    // Get the next three months after the last month
    const nextMonths = [];
    for (let i = 1; i <= 6; i++) {
      nextMonths.push(allMonths[(lastMonthIndex + i) % 12]);  // Handle wrap-around using modulo
    }

    return nextMonths;
  }


  getAnnuallyMonths(lastMonth: string): string[] {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Find the index of the last month in the selected period
    const lastMonthIndex = allMonths.indexOf(lastMonth);
    if (lastMonthIndex === -1) {
      console.error('Invalid last month:', lastMonth);
      return [];
    }

    // Get the next 12 months after the last month
    const nextMonths = [];
    for (let i = 1; i <= 12; i++) {  // Adjusted to get 12 months
      nextMonths.push(allMonths[(lastMonthIndex + i) % 12]);
    }

    return nextMonths;
  }


  // Function to get the next single month
  getNextMonth(currentMonth: string): { current: string, next: string } {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June', 'July',
      'August', 'September', 'October', 'November', 'December'
    ];

    const currentIndex = allMonths.indexOf(currentMonth);
    if (currentIndex === -1) return { current: currentMonth, next: currentMonth }; // If invalid month, return it as is

    const nextIndex = (currentIndex + 1) % allMonths.length; // Wrap around to the start if December is selected
    return { current: currentMonth, next: allMonths[nextIndex] };
  }

  getNextTwelveMonths(startIndex: number): string[] {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const nextTwelveMonths = [];

    for (let i = 0; i < 12; i++) {
      nextTwelveMonths.push(allMonths[(startIndex + i) % 12]); // Handle wrap-around using modulo
    }

    return nextTwelveMonths;

  }
  allMonths: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  selectedToMonth: any;
  filteredFromMonths: string[] = [];
  toMonthsVariablePay: string[] = [];
  onFromMonthChange() {
    const startIndex = this.getMonthsToVariablePay.indexOf(this.fromMonth);

    if (startIndex !== -1) {
      // Include the "From Month" in the available "To Month" options
      this.toMonthsVariablePay = this.getMonthsToVariablePay.slice(startIndex);
    } else {
      this.toMonthsVariablePay = [];
    }
  }

  //   onFromMonthChange(event: any) {
  //     const startIndex = this.getMonthsToVariablePay.indexOf(event.value);

  //     if (startIndex !== -1) {
  //         // Increment the index by 1 to exclude the selected month
  //         const nextMonthIndex = startIndex + 1;

  //         // Limit "To Month" options to only those after the selected "From Month"
  //         if (nextMonthIndex < this.getMonthsToVariablePay.length) {
  //             this.toMonthsVariablePay = this.getMonthsToVariablePay.slice(nextMonthIndex);
  //         } else {
  //             this.toMonthsVariablePay = []; // Reset if no valid months are available
  //         }
  //     } else {
  //         this.toMonthsVariablePay = []; // Reset if the selected month is invalid
  //     }
  // }


  getNextMonthsAfterRange(lastMonth: string, count: number): string[] {
    const allMonths = [
      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
    ];

    const startIndex = allMonths.indexOf(lastMonth);
    if (startIndex === -1) return [];

    const nextMonths = [];
    for (let i = 1; i <= count; i++) {
      const nextIndex = (startIndex + i) % allMonths.length;
      nextMonths.push(allMonths[nextIndex]);
    }

    return nextMonths;
  }

  getMonthsBetween(selectedPeriod: string): string[] {
    const [startMonth, endMonth] = selectedPeriod.split('-');
    const startIndex = this.allMonths.indexOf(startMonth);
    const endIndex = this.allMonths.indexOf(endMonth);

    if (startIndex === -1 || endIndex === -1) {
      console.error('Invalid month range.');
      return [];
    }

    // Check if the range wraps around the year (e.g., October-March)
    if (startIndex <= endIndex) {
      // No wrap-around, return months within the same year
      return this.allMonths.slice(startIndex, endIndex + 1);
    } else {
      // Wrap-around case, combine months from the end of the year and the start of the year
      return [...this.allMonths.slice(startIndex), ...this.allMonths.slice(0, endIndex + 1)];
    }
  }

  // onFromMonthChange(event: any) {
  //   const selectedFromMonth = event?.value;
  //   const startIndex = this.allMonths.indexOf(selectedFromMonth);

  //   if (startIndex !== -1 && startIndex + 2 < this.allMonths.length) {
  //     // Get next 2 months for the "To Month" selection
  //     this.getMonthsToVariablePay = this.allMonths.slice(startIndex + 1, startIndex + 3);
  //   } else {
  //     this.getMonthsToVariablePay = [];
  //   }
  // }

  selectedFromMonth: any;


  determinePeriodLength(frequency: string): number {
    switch (frequency) {
      case 'Monthly':
        return 1;  // Only 1 month
      case 'Quarterly':
        return 3;  // Next 3 months
      case 'Semi_Annually':
        return 6;  // Next 6 months
      default:
        return 1;  // Default to monthly if unknown
    }
  }

  clearCutOffDays() {
    this.cutOffDays = null; // Clear the input box
    this.GetOverallIncrementBudgetGridData = [];
    this.fromMonth = null;
    this.cutOffDate = null;
  }

  onPeriodChangeVariableSummary(event: any) {
    const selectedPeriod = event.value;
    this.selectedMonths = this.getMonthsBetween(selectedPeriod);
    if (this.selectedMonths.length > 0) {
      this.firstMonth = this.selectedMonths[0];
    }
  }
  cutOffData: any;
  cutOffDate: any;
  getCutOffDataForApi() {
    const parsedCutOffDate = new Date(this.cutOffDate);
    const request = {
      companyId: this.loggedInUserCompanyID,
      cutOffDate: new Date(this.cutOffDate),
      frequency: this.setupFrequency,
      frequencyCycle: this.frequencyPeriod,
      fromYear: Number(this.fromYear),
      toYear: Number(this.toYear)
    };
    this.httpService.callPostService(this.config.getVariablePaySetup, request).subscribe((res: any) => {
      this.cutOffData = res.data;
      this.GetOverallIncrementBudgetGridData = [];
      this.GetOverallIncrementBudgetGridData.push({
        year: this.selectedYear,
        frequencyPeriod: this.frequencyPeriod, 
        noOfEligibleEmployees: this.cutOffData?.noOfEligibleEmployees ?? 0,
        totalCtcOfEligibleEmployees: this.cutOffData?.totalCtcOfEligibleEmployees ?? 0,
        finalVPPercentage: this.cutOffData?.finalVPPercentage ? this.cutOffData?.finalVPPercentage : null,
        finalVPAmount: this.cutOffData?.finalVPAmount ? this.cutOffData?.finalVPAmount : null,
        isNew: true
      });
    })
  }

  onCutoffDateInputChange(day: string): void {
    this.cutOffDaysChange.next(day);
  }

  processCutoffDateInput(day: string): void {
    const parsedDay = parseInt(day, 10);
    if (parsedDay && parsedDay > 0) {
      this.cutOffDays = parsedDay; // Update cutOffDays

      // Convert parsedDay back to a string for calculateCutoffDate
      this.calculateCutoffDate(parsedDay.toString());
      // Trigger the API call
      this.getCutOffDataForApi();
    } else {
      console.warn('Invalid cutoff day input. API call not triggered.');
    }
  }

  calculateCutoffDate(day: string): void {
    const dayNumber = parseInt(day, 10);
    if (this.frequencyName === 'Monthly') {
      if (isNaN(dayNumber) || dayNumber <= 0 || dayNumber > 30) {
        this.cutOffDateForVariablepay = 'Invalid day';
        return;
      }
    }
    if (this.frequencyName === 'Quarterly') {
      if (isNaN(dayNumber) || dayNumber <= 0 || dayNumber > 90) {
        this.cutOffDateForVariablepay = 'Invalid day';
        return;
      }
    }
    if (this.frequencyName === 'Semi-Annually') {
      if (isNaN(dayNumber) || dayNumber <= 0 || dayNumber > 180) {
        this.cutOffDateForVariablepay = 'Invalid day';
        return;
      }
    }
    if (this.frequencyName === 'Annually') {
      if (isNaN(dayNumber) || dayNumber <= 0 || dayNumber > 365) {
        this.cutOffDateForVariablepay = 'Invalid day';
        return;
      }
    }

    if (this.selectedMonths.length > 0) {
      const monthDays: { [key: string]: number } = {
        'January': 31,
        'February': this.isLeapYear(new Date().getFullYear()) ? 29 : 28,
        'March': 31,
        'April': 30,
        'May': 31,
        'June': 30,
        'July': 31,
        'August': 31,
        'September': 30,
        'October': 31,
        'November': 30,
        'December': 31
      };

      const firstMonth = this.selectedMonths[0];
      let currentYear = new Date().getFullYear(); // Use the current year
      let currentMonth = firstMonth;
      let remainingDays = dayNumber;
      let calculatedDay = 0;

      // Helper to get the next month
      const getNextMonth = (current: string): string => {
        const months = Object.keys(monthDays);
        const currentIndex = months.indexOf(current);
        return months[(currentIndex + 1) % 12]; // Cycle through months
      };

      // Loop through the months and subtract the days
      while (remainingDays > 0) {
        const daysInCurrentMonth = monthDays[currentMonth];
        if (remainingDays <= daysInCurrentMonth) {
          calculatedDay = remainingDays; // Final cutoff day within the current month
          break;
        } else {
          remainingDays -= daysInCurrentMonth; // Move to next month
          currentMonth = getNextMonth(currentMonth); // Get next month

          // Check if we need to increment the year
          if (currentMonth === 'January') {
            currentYear++; // Increment the year when we reach January
          }
        }
      }

      // Format the month number and the date
      const formattedMonth = this.formatMonthToNumber(currentMonth as 'January' | 'February' | 'March' | 'April' | 'May' | 'June' | 'July' | 'August' | 'September' | 'October' | 'November' | 'December');
      this.cutOffDateForVariablepay = `${calculatedDay.toString().padStart(2, '0')}/${formattedMonth}/${currentYear}`;
    }
    this.employeeCountOnDateChange();
  }


  // Helper function to check for leap year
  isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
  }

  // Helper function to format month names into numbers
  formatMonthToNumber(month: 'January' | 'February' | 'March' | 'April' | 'May' | 'June' | 'July' | 'August' | 'September' | 'October' | 'November' | 'December'): string {
    const months = {
      'January': '01', 'February': '02', 'March': '03', 'April': '04',
      'May': '05', 'June': '06', 'July': '07', 'August': '08',
      'September': '09', 'October': '10', 'November': '11', 'December': '12'
    };
    return months[month]; // TypeScript now knows that 'month' will be a valid key
  }

  tooltipDynamic(): string {
    switch (this.frequencyName) {
      case 'Monthly':
        return '30';
      case 'Quarterly':
        return '90';
      case 'Semi-Annually':
        return '180';
      case 'Annually':
        return '365';
      default:
        return '';
    }
  }

  autoCalculateTotalWeightageIndividual() {
    // Subscribe to form control value changes
    this.variablePaySetupForm.valueChanges.subscribe(values => {
      const individualCompetencyWeightage = Number(values.individualCompetencyWeightage) || 0;
      const individualKpiScoreWeightage = Number(values.individualKpiScoreWeightage) || 0;

      // Auto-calculate totalWeightage
      const totalWeightage = individualCompetencyWeightage + individualKpiScoreWeightage;

      // Update the totalWeightage field
      this.variablePaySetupForm.get('totalWeightage')?.setValue(Number(totalWeightage), { emitEvent: false });
    });
  }

  onsaveVariablePayScore() {
    const payload = this.variableIndivaidualScoreData?.map((item: any) => {
      return {
        id: item.id || 0,
        createdAt: item.createdAt || null,
        band: item.band,
        individualCompetencyWeightage: Number(item.individualKpiCompetencyWeightage || this.variablePaySetupForm?.value?.individualKpiCompetencyWeightage),
        createdBy: 0,
        individualKpiScoreWeightage: Number(item.deptKpiScore || this.variablePaySetupForm?.value?.deptKpiScore),
        totalWeightage: Number(item.totalWeightage || this.variablePaySetupForm?.value?.totalWeightage),
        isDeleted: false,
        lastModifiedBy: 0,
        variablepaySetupId: item.variablepaySetupId || 0
      };
    });
  }

  autoCalculateTotalWeightage() {
    // Subscribe to form control value changes
    this.variablePaySetupForm.valueChanges.subscribe(values => {
      const individualKpiCompetencyWeightage = Number(values.individualKpiCompetencyWeightage) || 0;
      const deptKpiScore = Number(values.deptKpiScore) || 0;
      const companyKPIScoreWeightage = Number(values.companyKPIScoreWeightage) || 0;

      // Auto-calculate totalWeightage
      const totalWeightage = individualKpiCompetencyWeightage + deptKpiScore + companyKPIScoreWeightage;

      // Update the totalWeightage field
      this.variablePaySetupForm.get('totalWeightage')?.setValue(Number(totalWeightage), { emitEvent: false });
    });
  }

  onsaveVariablePayCompanyScore() {
    const payload = {
      id: 0,
      createdAt: null,
      band: this.variablePaySetupForm?.value.band,
      companyKPIScoreWeightage: this.variablePaySetupForm?.value.companyKPIScoreWeightage,
      createdBy: this.loggedInUserName,
      deptKpiScore: this.variablePaySetupForm?.value?.deptKpiScore,
      individualKpiCompetencyWeightage: this.variablePaySetupForm?.value?.individualKpiCompetencyWeightage,
      totalWeightage: this.variablePaySetupForm?.value?.totalWeightage,
      isDeleted: false,
      lastModifiedBy: this.loggedInUserName,
      variablepaySetupId: 0
    }

    // this.httpService.callPostService(this.config.variableSaveCompanyScore, payload).subscribe((data: any) => {
    // })

  }

  getIndividualScore() {
    const payload = {
      companyId: this.loggedInUserCompanyID,
      variablepaySetupId: null
    }
    this.httpService.callPostService(this.config.variableIndividualScore, payload).subscribe((response: any) => {
      this.individualScoreData = response.data;
    });
  }

  getCompanyScore() {
    const payload = {
      companyId: this.loggedInUserCompanyID,
      variablepaySetupId: ''
    }
    this.httpService.callPostService(this.config.variableCompanyScore, payload).subscribe((response: any) => {
      this.variableIndivaidualScoreData = response.data;
    });
  }
  calculateTotalWeightage(): void {
    const individualKpiCompetencyWeightage = Number(this.variablePaySetupForm.get('individualKpiCompetencyWeightage')?.value) || 0;
    const deptKpiScore = Number(this.variablePaySetupForm.get('deptKpiScore')?.value) || 0;
    // Calculate the total weightage
    const totalWeightage = individualKpiCompetencyWeightage + deptKpiScore;

    // Update the form control for totalWeightage without emitting an event
    this.variablePaySetupForm.get('totalWeightage')?.setValue(totalWeightage, { emitEvent: false });

    this.isInValidMaxIndividualKpi = deptKpiScore >= 100;
    this.isInValidMinIndividualKpi = deptKpiScore <= 0;
    this.isInValidMaxIndividualCompetency = individualKpiCompetencyWeightage >= 100;
    this.isInValidMinIndividualCompetency = individualKpiCompetencyWeightage <= 0;
  }

  getMonthsArray(fiscalYear: string): string[] {
    const allMonths = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];

    switch (fiscalYear) {
      case 'Jan_Dec':
        return allMonths;
      case 'Apr_Mar':
        return [...allMonths.slice(3), ...allMonths.slice(0, 3)];
      case 'July_Jun':
        return [...allMonths.slice(6), ...allMonths.slice(0, 6)];
      case 'Oct_Sep':
        return [...allMonths.slice(9), ...allMonths.slice(0, 9)];
      default:
        return [];
    }
  }

  onClickLogs(moduleName: any) {
    this.router.navigate(['/home/hrportal/variablepay/variablePayLogs', { moduleName: moduleName, id: 0 }]);
  }

  onClickBreadcrumPMS() {
    this.router.navigate(['/home/hrportal/variablepay']);
  }

  onClickUploadfile(uploadfile: any) {
    this.router.navigate(['/home/hrportal/variablepayUploadFile', { uploadfile: uploadfile }]);
  }

  onClickEmailContentBtn(emailContent: any) {
    this.router.navigate(['/home/hrportal/variablepay/variablepayEmailContent', { emailContent: emailContent }]);
  }

  onClickVariablePaytLetterBtn(incrementLetter: any) {
    this.router.navigate(['/home/hrportal/variablepay/variablepayLetter', { incrementLetter: incrementLetter }])
  }

  onClickEmpViewVariablePayLetter() {
    const test = this.selectedYear.split('-');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": this.frequencyPeriod,
      "fromYear": test[0],
      "toYear": test[1],
      "userId": [Number(this.loggedInUserId)]
    };
    this.loader.simpleLoader();
    this.httpService.callPostService(this.config.VPgetLetterOfUsers, request).subscribe((result: any) => {
      if(result?.data!=null){
        saveAs(result?.data, 'VariablePayLetter'); 
      }
      this.loader.dismissLoader();
    });
  }

  onYearChangeForInput(event: any) {
    // Check if event and event value exist
    if (event && event.value) {
      const selectedYear = event.value.split('-');

      // Ensure that the split operation returned an array of length 2
      if (selectedYear.length === 2) {
        this.fromYear = selectedYear[0];
        this.toYear = selectedYear[1];

        // Clear the dropdown options before fetching new data
        this.filteredFrequenciesVariable = [];

        // Call getFrequencyForVariable() to fetch the reviewCycle
        this.selectedDashboardMonthPeriod = null;
        this.getFrequencyForVariablePayInput();
        this.getFrequencyForDashboard();
      } else {
        console.error('Invalid year format:', event.value);
      }
    } else {
      console.error('Invalid event:', event);
    }
  }
  onYearChangeForVPInput(event: any) {
    if (event && event.value) {
      const selectedYear = event.value.split('-');
      if (selectedYear.length === 2) {
        this.fromYear = selectedYear[0];
        this.toYear = selectedYear[1];
        this.filteredFrequenciesVariable = [];
        this.frequencyPeriod = null;
        this.selectedDepartment = [];
        this.selectedBand = [];
        this.selectedManager = [];
        this.selectedEmployee = [];
        this.getIncrementInputEligibleTableData = [];
        this.getIncrementInputNonEligibleTableData = [];
        this.getDepartmentsList = []
        this.getBandList = []
        this.getManagerList = []
        this.getEmployeeList = []
        if (this.activeVariablePayInputTab === true) {
          this.getVariablePayInput();;
        } else if (this.activeVariablePayInputTab === false) {
          this.getVariableInputNonEligible();
        }
        this.getVPCurrentYearFrequeny();
        this.getFrequencyForInput();
      }

    }
  }

  getFrequencyForVariablePayInput() {
    this.httpService.callGetService(`${this.config.getPMSSetUpByID}${this.loggedInUserCompanyID}/${this.fromYear}/${this.toYear}`).subscribe((response: any) => {
      this.variableFrequency = response.data['reviewCycle'];
      this.filterFrequencyVariableInput();
    })
  }

  filterFrequencyVariableInput() {
    switch (this.variableFrequency) {
      case 'Monthly':
        this.filteredFrequenciesVariable = ["January", "February", "March", "April", "May", "June", "July"];
        break;
      case 'Quarterly':
        this.filteredFrequenciesVariable = ["Quarterly", "Semi-Annually", "Annually"];
        break;
      case 'Semi_Annually':
        this.filteredFrequenciesVariable = ["Semi-Annually", "Annually"];
        break;
      case 'Annually':
        this.filteredFrequenciesVariable = ["Annually"];
        break;
      default:
        this.filteredFrequenciesVariable = this.frequencies;
    }
  }

  onClickVariablePayIntputActiveTab(data: any) {
    this.selectedDepartment = []
    this.selectedBand = []
    this.selectedManager = []
    this.selectedEmployee = []
    this.activeVariablePayInputTab = data;
    this.getData();
    if (this.activeVariablePayInputTab === true) {
      this.getVariablePayInput();;
    } else if (this.activeVariablePayInputTab === false) {
      this.getVariableInputNonEligible();
    }
  }

  onClickVariablePayReportsActiveTab(data: any) {
    this.selectedDepartment = []
    this.selectedBand = []
    this.vpCategory = []
    this.selectedRating = []
    this.activeVariablePayReportsTab = data;
    this.getData();
    if (data == true) {
      this.getIncrementReportsEligibleData()
    } else {
      this.getIncrementReportsNonEligibleData();
    }
  }

  onClickGenerateVariablePayLetters() {
    this.router.navigate(['/home/hrportal/variablepay/generateVariablePayLetter']);
  }

  isClickEdit(itemId: number): void {
    this.editedItemId = itemId;
    this.onCheckIconView = true;
    this.isFormDisabled = false
  }

  // Individual Score

  editedIndividualScoreId: number | null = null;
  editedIndividualDeotCompanyScoreId: number | null = null;
  individualCompanyScore: any[] = [];

  onClickIndividualScoreEdit(itemId: number): void {
    
    if (this.isInValidMaxIndividualKpi || this.isInValidMinIndividualKpi || this.isInValidMaxIndividualCompetency || this.isInValidMinIndividualCompetency || this.IsIndividualTotalWeightage) {
    } else {
      this.editedIndividualScoreId = itemId;
      this.onCheckIconView = true;
      this.isFormDisabled = false;
    }
  }
  closeIndividualScore() {
    this.isInValidMaxIndividualKpi = false;
    this.isInValidMinIndividualKpi = false;
    this.isInValidMaxIndividualCompetency = false;
    this.isInValidMinIndividualCompetency = false;
    this.IsIndividualTotalWeightage = false;
    this.getScoreToFinalConverterIndividual();
  }
  tempRequestArrayIndividualScore: any[] = [];

  async onSaveIndividualScoreToFinalScoreConverter(item: any) {
    this.editedIndividualScoreId = null;
    this.tempRequestArrayIndividualScore = [];
    this.onCheckIconView = false;
    this.isFormDisabled = false;
    try {
      // Save the request temporarily (without the variablePaySetupId)
      const tempRequest = {
        ...item,
        variablepaySetupId: this.vpId // Initially null, will be updated later
      };

      // Add to tempRequestArrayIndividualScore
      this.tempRequestArrayIndividualScore.push(tempRequest);
      this.httpService.callPostService(this.config.variableSaveIndividualScore, this.tempRequestArrayIndividualScore).subscribe((result: any) => {

      });
      // Check for any validation issues before proceeding
      if (this.InvalidcompanyscoreWT || this.InvalidIndividualCompetencyMaxTW || this.InvalidIndividualCompetencyMinTW
        || this.InvalidDepthKpiMaxScore || this.InvalidDepthKpiMinScore || this.InvalidcompanyKpiScoreMaxScore ||
        this.InvalidcompanyKpiScoreMinScore) {
        window.alert("error");
        return; // Stop execution if there is a validation error
      }

    } catch (error) {
      console.error("Error in onSaveincrementScoreToFinalScoreIndividualConverter:", error);
    }

    this.editedIndividualScoreId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;
  }

  getScoreToFinalConverterIndividual() {
    this.variableIndivaidualScoreData = [];
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "variablepaySetupId": this.setupData?.id ? this.setupData?.id : null,
    }
    this.httpService.callPostService(this.config.variableIndividualScore, request).subscribe((result: any) => {
      this.variableIndivaidualScoreData = result.data?.map((ele: any) => ({
        "band": ele.band,
        "createdAt": null,
        "createdBy": null,
        "individualCompetencyWeightage": ele.individualCompetencyWeightage,
        "totalWeightage": ele.totalWeightage,
        "id": ele.id,
        "individualKpiScoreWeightage": ele.individualKpiScoreWeightage,
        "isDeleted": false,
        "lastModifiedBy": null,
        "updatedAt": null,
        "variablepaySetupId": this.generatedId ? this.generatedId : null,
      }));
      this.editedIndividualScoreId = null;
      this.onCheckIconView = false;
      this.isFormDisabled = false;
    }) 
  }

  IndividualTotalWeightage(item: any) {
    const scoreWeightage: number = Number(item.individualKpiScoreWeightage || 0);
    const competencyWeightage: number = Number(item.individualCompetencyWeightage || 0);
    let totalWeightage = scoreWeightage + competencyWeightage;
    if (totalWeightage > 100 || totalWeightage < 100) {
      this.IsIndividualTotalWeightage = true;
    } else {
      this.IsIndividualTotalWeightage = false;
    }
    if (scoreWeightage < 0) {
      item.individualKpiScoreWeightage = 0
    }
    if (competencyWeightage < 0) {
      item.individualCompetencyWeightage = 0
    }
    item.totalWeightage = totalWeightage;
    this.isInValidMaxIndividualKpi = item.individualKpiScoreWeightage > 100;
    this.isInValidMinIndividualKpi = item.individualKpiScoreWeightage < 0;
    this.isInValidMaxIndividualCompetency = item.individualCompetencyWeightage > 100;
    this.isInValidMinIndividualCompetency = item.individualCompetencyWeightage < 0;
  }

  // Company Score

  queuedScores: any[] = []; // Array to store queued requests

  onClickIndividualDeptcompetencyScoreEdit(itemId: number): void {
    
    if (this.InvalidcompanyscoreWT || this.InvalidIndividualCompetencyMaxTW || this.InvalidIndividualCompetencyMinTW
      || this.InvalidDepthKpiMaxScore || this.InvalidDepthKpiMinScore || this.InvalidcompanyKpiScoreMaxScore ||
      this.InvalidcompanyKpiScoreMinScore) {
      // this.tempRequestArray
    } else {
      this.editedIndividualDeotCompanyScoreId = itemId;
      this.onCheckIconView = true;
      this.isFormDisabled = false;
    }
  }

  // Temporary storage for requests
  tempRequestArray: any[] = []; // Declare this as a class-level variable to hold the temp requests

  getScoreToFinalConverterCompanyScore() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "variablepaySetupId": this.setupData?.id ? this.setupData?.id : null,
    }
    this.httpService.callPostService(this.config.variableCompanyScore, request).subscribe((result: any) => {
      this.individualCompanyScore = [];
      this.individualCompanyScore = result.data?.map((ele: any) => ({
        "band": ele.band,
        "createdAt": null,
        "createdBy": null,
        "companyKPIScoreWeightage": ele.companyKPIScoreWeightage,
        "deptKpiScore": ele.deptKpiScore,
        "totalWeightage": ele.totalWeightage,
        "id": ele.id,
        "individualKpiCompetencyWeightage": ele.individualKpiCompetencyWeightage,
        "isDeleted": false,
        "lastModifiedBy": null,
        "updatedAt": null,
        "variablepaySetupId": this.generatedId ? this.generatedId : null,
      }));

      this.editedIndividualDeotCompanyScoreId = null;
      this.onCheckIconView = false;
      this.isFormDisabled = false;
    })
  }
  validateWeight(event: any): void {
    const input = event.target.value;
    if (input < 0) {
      event.target.value = input.replace('-', '');
    }
  }
  GetScoreToFinalConverterTotalWeightage(item: any, fieldName: any, index: any) {
    if (fieldName == 'individualKpiCompetencyWeightage') {
      if (item.individualKpiCompetencyWeightage < 0) {
        this.individualCompanyScore[index].individualKpiCompetencyWeightage = 0;
        return
      }
    }
    if (fieldName == 'deptKpiScore') {
      if (item.deptKpiScore < 0) {
        this.individualCompanyScore[index].deptKpiScore = 0;
        return
      }
    }
    if (fieldName == 'companyKPIScoreWeightage') {
      if (item.companyKPIScoreWeightage < 0) {
        this.individualCompanyScore[index].companyKPIScoreWeightage = 0;
        return
      }
    }

    const individualCompetencyWeightage: number = Number(item.companyKPIScoreWeightage || 0);
    const deptKpiScore: number = Number(item.deptKpiScore || 0);
    const individualKpiCompetencyWeightage: number = Number(item.individualKpiCompetencyWeightage || 0);

    let totalWeightage = individualCompetencyWeightage + deptKpiScore + individualKpiCompetencyWeightage;

    // Validation: Ensure total weightage is exactly 100
    this.InvalidcompanyscoreWT = (totalWeightage !== 100);

    // Validation: Ensure individual columns do not exceed 100
    this.InvalidIndividualCompetencyMaxTW = individualKpiCompetencyWeightage > 100;
    this.InvalidDepthKpiMaxScore = deptKpiScore > 100;
    this.InvalidcompanyKpiScoreMaxScore = individualCompetencyWeightage > 100;

    item.totalWeightage = totalWeightage;
  }

  async onSaveincrementScoreToFinalScoreCompanyConverter(item: any) {
    this.tempRequestArray = [];
    try {
      // Check validation before saving
      if (this.InvalidcompanyscoreWT || this.InvalidIndividualCompetencyMaxTW || this.InvalidDepthKpiMaxScore || this.InvalidcompanyKpiScoreMaxScore) {
        window.alert("Error: Please ensure all values are correct (e.g., total weightage = 100 and no column exceeds 100).");
        return; // Do not proceed if there's a validation error
      }

      // Save logic

      this.editedIndividualDeotCompanyScoreId = null;
      this.onCheckIconView = false;
      this.isFormDisabled = false;
      try {
        // Save the request temporarily (without the variablePaySetupId)
        const tempRequest = {
          ...item,
          variablepaySetupId: this.vpId // Initially null, will be updated later
        };
        this.tempRequestArray.push(tempRequest);
        this.loader.simpleLoader();
        this.httpService.callPostService(this.config.variableSaveCompanyScore, this.tempRequestArray).subscribe((result: any) => {
          this.loader.dismissLoader();
        });

      } catch (error) {
        console.error("Error in onSaveincrementScoreToFinalScoreCompanyConverter:", error);
      }
      this.editedIndividualDeotCompanyScoreId = null;
      this.onCheckIconView = false;
      this.isFormDisabled = false;

      // Add your API call or save logic here
    } catch (error) {
      console.error("Error:", error);
    }
  }

  removeRowData(rowId: number) {
    this.onCheckIconView = false;
    this.editedIndividualDeotCompanyScoreId = null;
    this.InvalidcompanyscoreWT = false;
    this.InvalidIndividualCompetencyMaxTW = false;
    this.InvalidIndividualCompetencyMinTW = false;
    this.InvalidDepthKpiMaxScore = false;
    this.InvalidDepthKpiMinScore = false;
    this.InvalidcompanyKpiScoreMaxScore = false;
    this.InvalidcompanyKpiScoreMinScore = false;
    this.getScoreToFinalConverterCompanyScore();
  }



  get ratingFormArray() {
    return this.variablePaySetupForm.get('ratings') as FormArray;
  }

  addMoreScoreRating() {
    var maxRange = 0;
    if (this.addedratingArray?.length == 0) {
      maxRange = 0;
    } else {
      for (let i = 0; i < this.addedratingArray?.length; i++) {
        maxRange = this.addedratingArray[i].maxRange;
      }
    }
    this.ratingArrayForSetup.push({
      maxRange: null,
      rating: null,
      minRange: maxRange,
    })
  }

  saveAddedScoreRating() {
    this.ratingArrayForSetup[0].maxRange
    if (this.ratingArrayForSetup[0].maxRange != null && this.ratingArrayForSetup[0].rating != null) {
      if (!this.isInValidMaxRange && !this.isInValidRating) {
        this.errorMsgForRange = false;
        const request = {
          "companyId": this.loggedInUserCompanyID,
          "createdAt": null,
          "createdBy": 0,
          "frequency": this.frequencyName,
          "frequencyCycle": this.frequencyPeriod,
          "fromYear": this.fromYear,
          "id": null,
          "isDeleted": false,
          "lastModifiedBy": 0,
          "maxScoreRange": this.ratingArrayForSetup[0].maxRange,
          "minScoreRange": this.ratingArrayForSetup[0].minRange,
          "rating": this.ratingArrayForSetup[0].rating,
          "toYear": this.toYear,
          "updatedAt": null
        }
        this.loader.simpleLoader();
        this.httpService.callPostService(this.config.variableSaveRateToScore, request).subscribe((result) => {
          this.loader.dismissLoader();
          if (result) {
            this.getScoreRating();
          }
        })
        this.ratingArrayForSetup = []
      } else {
        this.errorMsgForRange = true;
      }
    }
  }

  getScoreRating() {
    const request = {
      // "incrementId": this.incrementId,
      "companyId": this.loggedInUserCompanyID,
      "frequency": this.frequencyName,
      "frequencyCycle": this.frequencyPeriod,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.variableRateToScore, request).subscribe((result: any) => {
      this.addedratingArray = [];
      this.addedratingArray = result.data?.filter((ele: any) => !ele.isDeleted)
      this.addedratingArray = result.data?.map((ele: any) => ({
        maxRange: ele.maxScoreRange,
        minRange: ele.minScoreRange,
        rating: ele.rating,
        id: ele.id,
        isDeleted: ele.isDeleted
      }));
      // this.addedratingArray = this.data.filter((rating: any) => !rating.isDeleted);
    })
  }

  onMaxRangeChange(data: any) {
    if (data.maxRange > data.minRange || isNaN(data.maxRange)) {
      this.isInValidMaxRange = false;
      this.invalidErrMessageForRating = ''
    } else {
      this.invalidErrMessageForRating = 'Max Range should be greater than Min Range';
      this.isInValidMaxRange = true;
    }
  }

  onRatingEmpty(data: any) {
    if (isNaN(data.rating)) {
      this.isInValidRating = false;
    } else {
      this.isInValidRating = true;
    }
  }

  removecreatedScoresRating() {
    this.errorMsgForRange = false;
    this.isInValidMaxRange = false;
    this.isInValidRating = false;
    this.invalidErrMessageForRating = ''
    this.ratingArrayForSetup = [];
  }

  deleteScoreRating() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to delete all ratings?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.addedratingArray.forEach((rating: any) => {
          const request = {
            "companyId": this.loggedInUserCompanyID,
            "frequency": rating.frequencyName,
            "frequencyCycle": rating.frequencyPeriod,
            "fromYear": rating.fromYear,
            "id": rating.id,
            "isDeleted": true,
            "toYear": rating.toYear
          }
          this.httpService.callPostService(this.config.variableSaveRateToScore, request).subscribe((result: any) => {
            if (result) {
              this.getScoreRating();
              this.GetIncrementGrid();
              this.variableGridBandList.flatMap((band: any) =>
                this.addedratingArray?.map((rating: any, colId: any) => {
                  band.variablepayPercentage[colId] = "";
                })
              );
            }
          })
        });

      }
    });

  }

  tempArrayBudgetGrid: any[] = [];
  finalVPAmount: any = null;
  finalVPPercentage: any = null;

  calculateFinalIncrementAmount(item: any) {
    if (item.finalVPPercentage == null) {
      item.finalVPPercentage = null;
      item.finalVPAmount = null;
    }
    if (item.finalVPPercentage && item.totalCtcOfEligibleEmployees) {
      // Calculate finalVPAmount
      item.finalVPAmount = (item.finalVPPercentage / 100) * item.totalCtcOfEligibleEmployees;
      item.finalVPAmount = parseFloat(item.finalVPAmount.toFixed(2)); // Two decimal precision

      // Find the existing item in tempArrayBudgetGrid
      const existingItem = this.tempArrayBudgetGrid.find(tempItem => tempItem.year === item.year);

      const updatedItem = {
        year: item.year || null,
        noOfEligibleEmployees: existingItem?.noOfEligibleEmployees ?? item.noOfEligibleEmployees,  // Retain existing value
        totalCtcOfEligibleEmployees: existingItem?.totalCtcOfEligibleEmployees ?? item.totalCtcOfEligibleEmployees, // Retain existing value
        finalVPPercentage: item.finalVPPercentage || existingItem?.finalVPPercentage,
        finalVPAmount: item.finalVPAmount || existingItem?.finalVPAmount
      };
      this.finalVPAmount = updatedItem.finalVPAmount
      this.finalVPPercentage = updatedItem.finalVPPercentage
      // Update or add the item in tempArrayBudgetGrid
      const index = this.tempArrayBudgetGrid.findIndex(tempItem => tempItem.year === updatedItem.year);
      if (index !== -1) {
        this.tempArrayBudgetGrid[index] = updatedItem;
      } else {
        this.tempArrayBudgetGrid.push(updatedItem);
      }
      this.saveOverallVPBudget();
    } else {
      if (item.finalVPPercentage == 0) {
        item.finalVPPercentage = 0;
        item.finalVPAmount = 0;
      }
    }
  }

  saveOverallVPBudget() {
    const rawCutOffDate = this.cutOffDateForVariablepay || '20/10/2024'; // Default for testing
    const cutOffDate = this.datePipe.transform(this.parseDateString(rawCutOffDate), "yyyy-MM-dd");
    const payload = {
      "createdBy": null,
      "createdAt": null,
      "lastModifiedBy": null,
      "updatedAt": null,
      "id": this.vpId ? this.vpId : null,
      "companyId": this.loggedInUserCompanyID,
      "cutOffDateForVariablepay": cutOffDate,
      "cutOffDays": this.cutOffDate,
      "finalVPAmount": this.finalVPAmount,
      "finalVPPercentage": this.finalVPPercentage,
      "frequency": this.frequencyName,
      "frequencyCycle": this.frequencyPeriod,
      "fromMonth": this.fromMonth,
      "fromYear": parseInt(this.fromYear),
      "toMonth": this.toMonth,
      "toYear": parseInt(this.toYear),
    };

    this.httpService.callPostService(this.config.variablePaySetup, payload).subscribe((result: any) => {
      // this.getVPCurrentYearFrequeny();
      this.getVariablePaySetup();
      const generatedId = result.data?.id;
    });
  }

  removeMinusValue(item: any) {
    const finalVpPercentage: number = Number(item.finalVPPercentage || 0);
    if (finalVpPercentage < 0) {
      item.finalVPPercentage = 0;
    }
  }

  storedVariablePayData: number | null = null;

  OnSaveFinalVariablePayPercentage() {
    this.isVisibleOverallVariablePayBudgetGridAdd = false;
    this.isVisibleOverallVariablePayBudgetGridSave = true;
    const newEntries = this.GetOverallIncrementBudgetGrid.filter((ele: any) => ele.isNew);

    // Assuming you're saving the last finalVPPercentage or a specific one
    if (newEntries.length > 0) {
      const lastEntry = newEntries[newEntries.length - 1]; // Get the last entry (or use the desired logic to pick the value)
      this.storedVariablePayData = lastEntry.finalVPPercentage;
    }
  }


  availableYears(index: number) {
    const selectedYears = this.GetOverallIncrementBudgetGrid
      ?.map((item: any) => item.year)
      .filter((year: any, i: any) => i !== index);
    const allYears = this.GetOverallIncrementBudgetGrid?.map((item: any) => item.year);
    return allYears.filter((year: any) => !selectedYears.includes(year));
  }



  variableGridData: any = [];
  tempRequestArrayVariableGrid: any = [];
  editedVariablePayBudgetGrid: number | null = null;
  editedBandAndRatingWiseId: number | null = null;
  onClickBandAndRatingWiseEdit(rowId: any) {
    this.editedBandAndRatingWiseId = rowId;
    this.onCheckIconView = true;
    this.isFormDisabled = false; // Allow editing of the fields
  }

  async onSaveVariableGrid() {
    this.editedBandAndRatingWiseId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;

    const gridBandRequest = this.variableGridBandList.flatMap((band: any) =>
      this.addedratingArray?.map((rating: any, colId: any) => ({
        "band": typeof band.band === 'object' ? band.band.band : band.band, // Ensure band is a string
        "id": band.id[colId] || null,
        "isDeleted": band.isDeleted,
        "variablepayPercentage": band.variablepayPercentage[colId] || null,
        "ratingId": rating.id
      }))
    );

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "gridBandRequest": gridBandRequest,
    };

    // Check if the array already contains this request
    const existingIndex = this.tempRequestArrayVariableGrid.findIndex(
      (existingRequest: { companyId: any; }) => existingRequest.companyId === request.companyId
    );

    if (existingIndex > -1) {
      // Update the existing request with the new gridBandRequest
      this.tempRequestArrayVariableGrid[existingIndex].gridBandRequest = gridBandRequest;
    } else {
      // Push new request if it doesn't exist
      this.tempRequestArrayVariableGrid.push(request);
    }
  }
  GetIncrementGrid() {
    this.editedBandAndRatingWiseId = null;
    this.onCheckIconView = false;
    this.isFormDisabled = false;

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "variablepaySetupId": this.setupData?.id ? this.setupData?.id : null,
    };

    this.httpService.callPostService(this.config.variableGetGridBand, request).subscribe((result: any) => {
      if (result && result.data) {
        const VariablePercentageData: any = {};

        result.data.forEach((item: any) => {
          if (!VariablePercentageData[item.band]) {
            VariablePercentageData[item.band] = {
              band: item.band,
              id: [],
              variablepayPercentage: []
            };
          }

          VariablePercentageData[item.band].variablepayPercentage.push(item.variablepayPercentage);
          VariablePercentageData[item.band].id.push(item.id);
        });
        this.variableGridBandList.forEach((existingItem: any) => {
          if (VariablePercentageData[existingItem.band]) {
            existingItem.variablepayPercentage = VariablePercentageData[existingItem.band].variablepayPercentage;
            existingItem.id = VariablePercentageData[existingItem.band].id;
          }
        });
        // this.variableGridBandList = Object.values(VariablePercentageData);
      }
    });
  }

  InvalidBandAndRatingWise(item: any, colId: any) {
    let value = Number(item.variablepayPercentage[colId]);
    if (value < 0) {
      item.variablepayPercentage[colId] = 0;
    }
  }

  isEditingRow: number | null = null;
  isFinalIncrementPctFormDisabled: any = true;
  overallIncrementBudgetGridCurrentYear: any
  tempRequestArrayVariableBudget: any[] = []
  GetOverallIncrementBudgetGridData: any = [];

  showCurrentYear() {
    const currentYear = new Date().getFullYear();
    if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
      this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear}`;
    } else {
      this.overallIncrementBudgetGridCurrentYear = `${currentYear}-${currentYear + 1}`;
    }
  }

  getPreviousYearSetups() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getPreviousYearFrequency, request).subscribe((result: any) => {
      this.GetOverallIncrementBudgetGridData = result.data?.map((ele: any) => ({
        year: `${ele.fromYear}-${ele.toYear}`,
        id: ele.id,
        noOfEligibleEmployees: ele.noOfEligibleEmployees,
        totalCtcOfEmployees: ele.totalCtcOfEmployees,
        finalVPPercentage: ele.finalVPPercentage,
        finalVPAmount: ele.finalVPAmount
      }));
    })
  }

  editRow(index: number) {
    this.isEditingRow = index;
    this.isFinalIncrementPctFormDisabled = false;
  }

  async OnSaveFinalVariablePercentage(data: any) {
 
    this.calculateFinalIncrementAmount(data);
    const request = {
      companyId: this.loggedInUserCompanyID,
      // cutOffDate: null,
      finalVPPercentage: data.finalVPPercentage,
      finalVPAmount: data.finalVPAmount,
      fromMonth: null,
      id: data.id || null,
      // incrementOn: null,
      toMonth: null,
      year: data.year
    };

    const index = this.tempRequestArrayVariableBudget.findIndex(tempItem => tempItem.id === request.id);
    if (index > -1) {
      this.tempRequestArrayVariableBudget[index] = request;
    } else {
      this.tempRequestArrayVariableBudget.push(request);
    }

    // Update the values in GetOverallIncrementBudgetGrid as well
    const gridIndex = this.GetOverallIncrementBudgetGrid.findIndex((i: { id: any; }) => i.id === data.id);
    if (gridIndex > -1) {
      this.GetOverallIncrementBudgetGrid[gridIndex].finalVPPercentage = data.finalVPPercentage;
      this.GetOverallIncrementBudgetGrid[gridIndex].finalVPAmount = data.finalVPAmount;
    }

  }

  cancelEdit(index: number) {
    this.isEditingRow = null;
    // this.getOverallIncrementBudgetGrid();
    this.isFinalIncrementPctFormDisabled = true;
  }

  GetOverallIncrementBudgetGridIncrementPct(item: any) {
    const VariablePayPercentage: number = Number(item.finalVPPercentage || 0);
    if (VariablePayPercentage < 0) {
      item.finalVPPercentage = 0;
    }

    const VariablePayAmount: number = Number(item.finalVPAmount || 0);
    if (VariablePayAmount < 0) {
      item.finalVPAmount = 0;
    }
  }

  data: any[] = [
    { name: 'John', age: 30, email: 'john@example.com' },
    { name: 'Jane', age: 25, email: 'jane@example.com' },
  ];

  // downloadExcelForInput() {
  //   const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.variablePayData);
  //   const workbook: XLSX.WorkBook = {
  //     Sheets: { 'data': worksheet },
  //     SheetNames: ['data'],
  //   };
  //   const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  //   const data: Blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
  //   const fileName = 'exported_data.xlsx';
  //   saveAs(data, fileName);
  // }



  openDashboardPopups(operation: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {};
    dialogConfig.panelClass = 'custom-dialog-container';
    dialogConfig.data = {
      operation: operation,
      year: this.selectedYear,
      frequencyPeriod: this.selectedDashboardMonthPeriod
    }
    const dialogRef = this.dialog.open(VariablePayDashboardPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });
    // this.dialog.open(VariablePayDashboardPopupComponent, {
    //   width: '400px',
    //   data: { operation: operation } 
    // });
  }

  onClickEmpGivenPromotion() {

  }

  onClickEligibleEmployees() {

  }

  rateWisePieChart() {
    const chartDom = document.getElementById('rateWiseVariablePayGraph');
    const myChart = echarts.init(chartDom);

    const option = {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item'
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            {
              value: 1048,
              name: 'Budget',
            },
            {
              value: 735,
              name: 'Actual'
            }
          ]
        }
      ]
    }
    myChart.setOption(option);
  }

  rateWiseGraph() {
    const chartDom = document.getElementById('rateWiseVariablePayGraph')!;
    const myChart = echarts.init(chartDom);

    const option = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: ['Poor', 'Good', 'Average'],
          name: 'Ratings',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 10,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          max: 50,
          interval: 10,
          name: 'Variable Pay Amount',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false }
        },
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '15%',
          data: [30, 30, 30], // Corrected budget values
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '15%',
          data: [10, 20, 20], // Corrected actual values
        },
      ],
    };

    myChart.setOption(option);
  }

  rateWiseLineGraph() {

    const chartDom = document.getElementById('rateWiseVariablePayGraph')!;
    const myChart = echarts.init(chartDom);

    const option = {
      tooltip: { trigger: 'axis' },
      legend: { bottom: 10 },
      xAxis: { show: true, type: 'category', data: this.dummyData?.map((ele: { name: any; }) => ele.name) },
      yAxis: { show: true, type: 'value', splitLine: { show: false }, },
      series: [{
        name: 'Score', type: 'line', data: this.dummyData?.map((ele: { value: any; }) => ele.value), itemStyle: { color: this.fisrtDashboardColor },
        label: { show: true, position: 'top' }
      }]
    };

    myChart.setOption(option);
  }

  rateWiseEmployeeCountPieChart() {
    const chartDom = document.getElementById('ratingWiseVariablePayGraph');
    const myChart = echarts.init(chartDom);

    const option = {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item'
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            {
              value: 1048,
              name: 'Budget',
            },
            {
              value: 735,
              name: 'Actual'
            }
          ]
        }
      ]
    }
    myChart.setOption(option);
  }

  rateWiseEmployeeCountGraph() {
    const chartDom = document.getElementById('ratingWiseVariablePayGraph')!;
    const myChart = echarts.init(chartDom);

    const option = {
      color: ['#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: ['Count', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: ['Poor', 'Average', 'Good', 'Excellent'],
          name: 'Ratings',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 10,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          max: 50,
          interval: 10,
          name: 'Count',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          splitLine: { show: false }
        },
      ],
      series: [
        {
          name: 'Count',
          type: 'bar',
          barWidth: '15%',
          data: [30, 10, 45, 20],
        },
      ],
    };

    myChart.setOption(option);
  }

  rateWiseEmployeeCountLineGraph() {

    const chartDom = document.getElementById('ratingWiseVariablePayGraph')!;
    const myChart = echarts.init(chartDom);

    const option = {
      tooltip: { trigger: 'axis' },
      legend: { bottom: 10 },
      xAxis: { show: true, type: 'category', data: this.dummyData?.map((ele: { name: any; }) => ele.name) },
      yAxis: { show: true, type: 'value', splitLine: { show: false }, },
      series: [{
        name: 'Score', type: 'line', data: this.dummyData?.map((ele: { value: any; }) => ele.value), itemStyle: { color: this.fisrtDashboardColor },
        label: { show: true, position: 'top' }
      }]
    };

    myChart.setOption(option);
  }


  eligibleEmployeeCountPieChart() {
    const chartDom = document.getElementById('eligibleEmployeeCountGraph');
    const myChart = echarts.init(chartDom);

    const option = {
      color: ['#F3820E', '#DDDDDD'],
      tooltip: {
        trigger: 'item'
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['40%', '80%'],
          center: ['50%', '70%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            {
              value: 1048,
              name: 'Budget',
            },
            {
              value: 735,
              name: 'Actual'
            }
          ]
        }
      ]
    }
    myChart.setOption(option);
  }

  // 

  eligibleEmployeeCount() {
    const chartDom = document.getElementById('eligibleEmployeeCountGraph')!;
    const myChart = echarts.init(chartDom);

    const option = {
      color: ['#393186', '#F3820E'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      legend: {
        data: ['Budget', 'Actual'],
        bottom: 0,
        left: 'center',
      },
      xAxis: [
        {
          type: 'category',
          data: ['Sales', 'Finance', 'Manufacturing'],
          name: 'Departments',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 10,
          },
          axisTick: {
            alignWithLabel: true,
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          max: 50,
          interval: 10,
          name: 'Budget Amount',
          nameLocation: 'middle',
          nameTextStyle: {
            fontSize: 14,
            padding: 20
          },
          axisLabel: {
            formatter: '{value}%',
          },
          splitLine: { show: false }
        },
      ],
      series: [
        {
          name: 'Budget',
          type: 'bar',
          barWidth: '15%',
          data: [45, 30, 20],
        },
        {
          name: 'Actual',
          type: 'bar',
          barWidth: '15%',
          data: [30, 25, 40],
        },
      ],
    };

    myChart.setOption(option);
  }

  eligibleEmployeeCountLineChart() {

    const chartDom = document.getElementById('eligibleEmployeeCountGraph')!;
    const myChart = echarts.init(chartDom);

    const option = {
      tooltip: { trigger: 'axis' },
      legend: { bottom: 10 },
      xAxis: { show: true, type: 'category', data: this.dummyData?.map((ele: { name: any; }) => ele.name) },
      yAxis: { show: true, type: 'value', splitLine: { show: false }, },
      series: [{
        name: 'Score', type: 'line', data: this.dummyData?.map((ele: { value: any; }) => ele.value), itemStyle: { color: this.fisrtDashboardColor },
        label: { show: true, position: 'top' }
      }]
    };

    myChart.setOption(option);
  }

  groupByDepartmentAndBand() {
    const groupedData = this.variablePayReportShowHideSummaryData.reduce((acc: any[], curr: { department: any; band: any; }) => {
      let department = acc.find((dept: { department: any; }) => dept.department === curr.department);
      if (!department) {
        department = { department: curr.department, bands: [] };
        acc.push(department);
      }
      let band = department.bands.find((b: { band: any; }) => b.band === curr.band);
      if (!band) {
        band = { band: curr.band, employees: [] };
        department.bands.push(band);
      }
      band.employees.push(curr);
      return acc;
    }, []);

    groupedData.forEach((dept: { totalEmployees: any; bands: any[]; }) => {
      dept.totalEmployees = dept.bands.reduce((acc: any, curr: { employees: string | any[]; }) => acc + curr.employees.length, 0);
    });

    this.departmentGroups = groupedData;
  }





  // defaultChartActualAmount() {
  //   const dom = document.getElementById('actualAmountVariablePayGraph') as HTMLDivElement;
  //   this.variablePayActualAmountStatus = echarts.init(dom);
  //   this.setChartActualAmount('bar');
  // }



  getLineChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: { trigger: 'axis' },
      legend: { bottom: 10 },
      xAxis: { show: true, type: 'category', data: data?.map((ele: { name: any; }) => ele.name) },
      yAxis: { show: true, type: 'value', splitLine: { show: false }, },
      series: [{
        name: 'Score', type: 'line', data: data?.map((ele: { value: any; }) => ele.value), itemStyle: { color: this.fisrtDashboardColor },
        label: { show: true, position: 'top' }
      }]
    };
  }
  getBarChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: { trigger: 'axis' },
      legend: { bottom: 10 },
      xAxis: { show: true, type: 'category', data: data?.map((ele: { name: any; }) => ele.name) },
      yAxis: { show: true, type: 'value', splitLine: { show: false }, },
      series: [{
        name: 'Score', type: 'bar', barWidth: 20, data: data?.map((ele: { value: any; }) => ele.value), itemStyle: { color: this.fisrtDashboardColor },
        label: { show: true, position: 'top' }
      }]
    };
  }
  getPieChartOptions(data: any): echarts.EChartsOption {
    return {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        bottom: 10
      },
      series: [
        {
          name: 'Range',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: false
          },
          data: data
        }
      ],
      xAxis: { show: false },  // Hide xAxis for pie chart
      yAxis: { show: false }
    };
  }
  getAreaChartOptions(data: any): echarts.EChartsOption {
    return {
      grid: { show: false },
      legend: { bottom: 10 },
      xAxis: { show: true, type: 'category', boundaryGap: false, data: data?.map((ele: { name: any; }) => ele.name) },
      yAxis: { show: true, type: 'value', splitLine: { show: false } },
      series: [{
        areaStyle: {}, name: 'Score', type: 'line', data: data?.map((ele: { value: any; }) => ele.value), itemStyle: { color: this.fisrtDashboardColor },
        label: { show: true, position: 'top' }
      }]
    };
  }

  onClickVariablePayStats() {
    this.variablePayGraphType = false;
    this.showVariablePayStatus = true;
  }

  onClickVariablePayDeptWise() {
    this.variablePayDeptWiseType = false;
    this.showVariablePayDeptWise = true;
  }

  onClickVariablePayRatingWise() {
    this.variablePayRatingWiseType = false;
    this.showVariablePayRatingWise = true;
  }

  onClickVariablePayBandWise() {
    this.variablePayBandWiseType = false;
    this.showVariablePayBandWise = true;
  }

  onClickVariablePayEmployeeCount() {
    this.variablePayEmployeeCount = false;
    this.showVariablePayEmployeeCount = true;
  }

  onClickVariablePayActualAmount() {
    this.variablePayActualAmount = false;
    this.showVariablePayActualAmount = true;
  }

  onClickVariablePayEligibleEmployees() {
    this.variablePayEligibleEmployees = false;
    this.showVariablePayEligibleEmployees = true;
  }
  isVPSetupDone: boolean = false;
  isVPInputSetupNotDone: boolean = false;
  getVPCurrentYearFrequeny() {
    this.httpService.callGetService(this.config.getVPCurrentYearFrequeny + this.loggedInUserCompanyID + '/' +
      this.fromYear + '/' + this.toYear
    ).subscribe((result: any) => {
      
      if (this.isSelectedYearIsSameYeartoCurrentYear) {
        if (result?.data == null) {
          this.isVPSetupDone = false;
        } else {
          if (this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
            this.isVPSetupDone = false;
          } else {
            this.isVPSetupDone = true;
          }
        }
      } else {
        this.isVPSetupDone = true;
      }
      if (result?.data == null) {
        this.isVPInputSetupNotDone = true;
        this.getFrequencies();
      } else {
        this.setupFrequency = result?.data;
        this.getFrequencyForInput();
        this.filterFrequencies()
        this.isVPInputSetupNotDone = false;
      }
    });
  }



  saveGridBandRating() {
    if(this.editedBandAndRatingWiseId === null) return

    const editedBand = this.variableGridBandList[this.editedBandAndRatingWiseId]
    const gridBandRequest = this.addedratingArray?.map((rating: any, colId: any) => ({
          "band": typeof editedBand.band === 'object' ? editedBand.band.band : editedBand.band, 
          "id": editedBand.id[colId] || null,
          "isDeleted": editedBand.isDeleted,
          "variablepayPercentage": editedBand.variablepayPercentage[colId] || null,
          "ratingId": rating.id
        })).filter((item:any) => item.variablepayPercentage !== null && item.variablepayPercentage !== undefined); 
    // const gridBandRequest = this.variableGridBandList.flatMap((band: any) =>
    //   this.addedratingArray?.map((rating: any, colId: any) => ({
    //     "band": typeof band.band === 'object' ? band.band.band : band.band, 
    //     "id": band.id[colId] || null,
    //     "isDeleted": band.isDeleted,
    //     "variablepayPercentage": band.variablepayPercentage[colId] || null,
    //     "ratingId": rating.id
    //   }))
    // );
    if (gridBandRequest.length === 0) return; 
    this.loader.simpleLoader();
    const request = {
      "variablePaySetupId": this.vpId,
      "gridBandRequest": gridBandRequest,
    };
    this.httpService.callPostService(this.config.variableSaveGridBand, request).subscribe((result: any) => {
      this.editedBandAndRatingWiseId = null;
      this.loader.dismissLoader();
    });
  }
  vpIdForApproval: any;
  
  vpApproval(relatedToName: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to ' + relatedToName + '?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const request = {
          "relatedToId": this.vpIdForApproval,
          "relatedToName": relatedToName,
          "status": true
        };
        this.loader.simpleLoader();
        this.httpService.callPostService(this.config.vpApproval, request).subscribe((result: any) => {
          this.loader.dismissLoader()
          this.checkIsFreezeForHOD();
          this.checkIsSenForMDCeoForApproval();
          this.checkIsVariablePayApproved();
          this.checkIsSenForHRForApproval();
        });
      }
    });
  }
  getVPIDByFrequency() {
    var year = this.selectedYear?.split('-');
    this.httpService.callGetService(this.config.getVPIDByFrequency + this.loggedInUserCompanyID + '/' +
      year[0] + '/' + year[1] + '/' + this.frequencyPeriod
    ).subscribe((result: any) => {
      this.vpIdForApproval = result?.data?.id;
      this.checkIsFreezeForHOD();
      this.checkIsSenForMDCeoForApproval();
      this.checkIsVariablePayApproved();
      this.checkIsSenForHRForApproval();
    });
  }
  isFreezForHOD: boolean = false;
  isSenForMDCeoForApproval: boolean = false;
  isVariablePayApproved: boolean = false;
  isSenForHRForApproval: boolean = false;
  checkIsFreezeForHOD() {
    this.httpService.callGetService(this.config.getVpApprovalById + this.vpIdForApproval +
      '/' + 'Freeze for the HOD' + '/' + true).subscribe((result: any) => {
        this.isFreezForHOD = result?.data?.status;
      });
  }
  checkIsSenForHRForApproval() {
    this.httpService.callGetService(this.config.getVpApprovalById + this.vpIdForApproval +
      '/' + 'Send to HR for Approval' + '/' + true).subscribe((result: any) => {
        this.isSenForHRForApproval = result?.data?.status;
      });
  }
  checkIsSenForMDCeoForApproval() {
    this.httpService.callGetService(this.config.getVpApprovalById + this.vpIdForApproval +
      '/' + 'Send to MDCEO for Approval' + '/' + true).subscribe((result: any) => {
        this.isSenForMDCeoForApproval = result?.data?.status;
      });
  }
  checkIsVariablePayApproved() {
    this.httpService.callGetService(this.config.getVpApprovalById + this.vpIdForApproval +
      '/' + 'Approve Variable Pay' + '/' + true).subscribe((result: any) => {
        this.isVariablePayApproved = result?.data?.status;
      });
  }
  getVPPolicyFile() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "frequencyCycle": null,
      "fromYear": null,
      "relatedToName": "Variable Pay Policy",
      "toYear": null
    };
    this.httpService.callPostService(this.config.getVPPolicyFile, request).subscribe((result: any) => {
      const fileName = result?.data?.vpPolicyFileNameBody
      // saveAs(result?.data?.vpPolicyUrlSubject, fileName);
      const link = document.createElement('a');
      link.href = result?.data?.vpPolicyUrlSubject;  // Set the file URL
      link.download = fileName;  // Set the custom file name
      link.target = '_blank';  // Open the file in a new tab (optional)
      document.body.appendChild(link);  // Append the link to the DOM
      link.click();  // Trigger the download
      document.body.removeChild(link);  // Clean up the DOM
    });
  }
  employeeCountOnDateChange() {
    const cutOffDate = this.datePipe.transform(this.cutOffDateForVariablepay, "yyyy-MM-dd");
    this.httpService.callGetService(this.config.empcount_ctc + this.loggedInUserCompanyID + '/' + cutOffDate + '/' + this.setupFrequency).subscribe((result: any) => {

    });
  }
  previousOverallVPBudgetGrid: any = [];
  getPrevYearSetupVP() {
    const test = this.selectedYear.split('-');
    this.httpService.callGetService(this.config.prev_setupsOfVP + this.loggedInUserCompanyID + '/' +
      this.setupFrequency + '/' + test[0] + '/' + test[1] + '/' + this.frequencyPeriod).subscribe((result: any) => {
        
        this.previousOverallVPBudgetGrid = [];
        if (result.data?.length != 0) {
          for (let i = 0; i < result?.data?.length; i++) {
            this.previousOverallVPBudgetGrid.push({
              year: result?.data[i]?.fromYear + '-' + result?.data[i]?.toYear,
              frequencyPeriod: result?.data[i]?.frequency,
              frequencyCycle: result?.data[i]?.frequencyCycle,
              noOfEligibleEmployees: result?.data[i]?.noOfEligibleEmployees ?? 0,
              totalCtcOfEligibleEmployees: result?.data[i]?.totalCtcOfEligibleEmployees ?? 0,
              finalVPPercentage: result?.data[i]?.finalVPPercentage ? result?.data[i]?.finalVPPercentage : null,
              finalVPAmount: result?.data[i]?.finalVPAmount ? result?.data[i]?.finalVPAmount : null,
              isNew: false
            });
          }
        } else {
          this.previousOverallVPBudgetGrid = [];
        }
      });
  }
  onClickShowAllHeader() {
    this.variablePayInputTableHideShowAllData?.forEach((ele: any, ind: any) => {
      this.variablePayInputTableHideShowAllData[ind].isVisible = true;
    });
    this.isAnyColumnInvisible = this.variablePayInputTableHideShowAllData?.some((ele: any) => !ele.isVisible);
    this.allColumnsInvisible = this.variablePayInputTableHideShowAllData?.every((ele: any) => !ele.isVisible);
  }
  validateInputForNormalization(event: KeyboardEvent): void {
    const pattern = /^[0-9.%]$/; // Allows only digits (0-9) and '%'.
    const inputChar = String.fromCharCode(event.keyCode || event.which);

    if (!pattern.test(inputChar)) {
      event.preventDefault(); // Prevent invalid character input.
    }
  }

  OnClickDownloadBudgetvsActualGraph() {
    this.pdfDownload.VPGraphPDFDownload(
      'budgetWiseGraph', // chartId
      'budgetWiseTable', // tableId
      'Budget vs Actual', // Title
      this.monthPeriodForBudget, // Period
      null, // Department
    );
  }

  downloadGenderWiseBudgetVsActualGraph() {
    let department;
    if (this.deptForGender == 'All') {
      department = 'My Departments'
    } else {
      const getDeparment = this.frequencyDeptName.find((ele: any) => ele.id === this.deptForGender);
      department = getDeparment.id
    }
    this.pdfDownload.VPGraphPDFDownload(
      'genderWiseVariablePayGraph', // chartId
      'genderWiseVariablePayTable', // tableId
      'Gender wise - Budget vs Actual', // Title
      this.monthPeriodForGender, // Period
      department, // Department
    );
  }

  downloadDeptWiseBudgetVsActualGraph() {
    this.pdfDownload.VPGraphPDFDownload(
      'deptWiseVariablePayGraph', // chartId
      'deptWiseVariablePayTable', // tableId
      'Dept wise Budget vs Actual', // Title
      this.monthPeriodForDept, // Period
      this.deptWiseBudgetVsActualDept.map((ele: any) => ele.name), // Department
    );
  }

  downloadRatingWiseBudgetVsActualGraph() {
    let department;
    if (this.deptForRating == 'All') {
      department = 'My Departments'
    } else {
      const getDeparment = this.frequencyRating.find((ele: any) => ele.id === this.deptForRating);
      department = getDeparment.id
    }
    this.pdfDownload.VPGraphPDFDownload(
      'rateWiseVariablePayGraph', // chartId
      'rateWiseVariablePayTable', // tableId
      'Rating wise Budget vs Actual', // Title
      this.monthPeriodForRating, // Period
      department, // Department
    );
  }

  downloadBandWiseBudgetVsActualGraph() {
    let department;
    if (this.deptForBand == 'All') {
      department = 'My Departments'
    } else {
      const getDeparment = this.frequencyBand.find((ele: any) => ele.id === this.deptForBand);
      department = getDeparment.id
    }
    this.pdfDownload.VPGraphPDFDownload(
      'bandWiseVariablePayGraph', // chartId
      'bandWiseVariablePayTable', // tableId
      'Band wise Budget vs Actual', // Title
      this.monthPeriodForBand, // Period
      department, // Department
    );
  }

  downloadRatingVsEmployeeCountGraph() {
    let department;
    if (this.deptForRateVsEmloyee == 'All') {
      department = 'My Departments'
    } else {
      const getDeparment = this.frequencyEmployeeVSBand.find((ele: any) => ele.id === this.deptForRateVsEmloyee);
      department = getDeparment.id
    }
    this.pdfDownload.VPGraphPDFDownload(
      'ratingWiseVariablePayGraph', // chartId
      'ratingWiseVariablePayTable', // tableId
      'Rating vs Employee count', // Title
      this.monthPeriodForRatingCount, // Period
      department, // Department
    );
  }

  downloadYearVsBudgetActualAmountGraph() {
    let department;
    if (this.selectGenderWiseBudgetVsActualDept == 'All') {
      department = 'My Departments'
    } else {
      const getDeparment = this.getDepartmentsList.find((ele: any) => ele.id === this.selectGenderWiseBudgetVsActualDept);
      department = getDeparment.id
    }
    this.pdfDownload.VPGraphPDFDownload(
      'actualAmountVariablePayGraph', // chartId
      'actualAmountVariablePayTable', // tableId
      'Year vs Budget & Actual Amount', // Title
      null, // Period
      department, // Department
    );
  }

  downloadDeptWiseEligibleNonEligibleGraph() {
    this.pdfDownload.VPGraphPDFDownload(
      'eligibleEmployeeCountGraph', // chartId
      'eligibleEmployeeCountTable', // tableId
      'Dept Wise Eligible and Not Eligible Employee Count', // Title
      this.monthPeriodForDeptWiseEligbleNonEligible, // Period
      this.selectedDeptNameForEligbleNonEligible.map((ele: any) => ele.name), // Department
    );
  }
  variablePeriodFrquencyForEmp:any=[];
  dateOfVpEmployee:any;
  approvedVPPeriods() {
    const test = this.selectedYear.split('-');
    this.httpService.callGetService(this.config.approvedVPPeriods + this.loggedInUserCompanyID + '/' + test[0] + '/' + test[1] + '/' + this.frequencyPeriod).subscribe((result: any) => {
      this.dateOfVpEmployee = result?.data
    });
  }
  vpPeriodsByUser(){
    const test = this.selectedYear.split('-');
    this.httpService.callGetService(this.config.vpPeriodsByUser + test[0] + '/' + test[1] + '/' + this.loggedInUserCompanyID).subscribe((result: any) => {
      this.variablePeriodFrquencyForEmp = result?.data;
      if(this.variablePeriodFrquencyForEmp.length!=0){
        this.frequencyPeriod = this.variablePeriodFrquencyForEmp[0];
        this.approvedVPPeriods();
      }
    });
  }
}
